import { isEmpty } from '@jfs/utils'
import _ from 'lodash'
import { flow, Instance, onSnapshot, types } from 'mobx-state-tree'
import { exportType } from '..'
import { getOthersProducerChannelIds } from '../../components/ApiConfig'
import { getCardIdFromName } from '../../components/NewCheckboxGrid/Fixtures'
import { addEmsCardsReq } from '../../network/addEmsCards'
import { APIEndPoints } from '../../network/APIEndPoints'
import { applicationRetryReq } from '../../network/applicationRetry'
import { approveRejectTaskReq } from '../../network/approveRejectTaskChecker'
import { bulkOnboardingDeleteFile } from '../../network/bulkOnboardingDeleteFile'
import { bulkOnboardingFileUpload } from '../../network/bulkOnboardingFileUpload'
import { checkApplicationStatusReq } from '../../network/checkApplicationStatus'
import { checkCreationStatusReq } from '../../network/checkCreationStatus'
import { claimTaskReq } from '../../network/claimTaskChecker'
import { updateConfig } from '../../network/configUpdate'
import { createApiMappingByProfileNameReq, createApiMappingReq } from '../../network/createApiMapping'
import { createConfigOfEntity } from '../../network/createConfig'
import { createEntityReq } from '../../network/createEntity'
import { createGroup } from '../../network/createGroup'
import { createMultipleApiMappingReq } from '../../network/createMultipleApiMapping'
import { createSubGroupReq } from '../../network/createSubGroup'
import { createUpdateDeleteFiu } from '../../network/createUpdateDeleteFiu'
import { createUserWithPermissions } from '../../network/createUserWithPermissions'
import {
  downloadExportFileApi,
  getExportAuditTrailsRequest,
  getExportFileRequest,
  initiateExportFileApi,
} from '../../network/exportFileApi'
import { exportFile } from '../../network/exportFle'
import { downloadFileUsingJobId, getJobIdForExportApi } from '../../network/exportUsingJobIdApi'
import { extendAppSessionAPI } from '../../network/ExtendAppSession'
import { extendUserSessionAPI } from '../../network/ExtendUserSession'
import { fetchDevicesGqlReq } from '../../network/fetchDevicesGql'
import { fetchEntityDetailsGetMerchantReq } from '../../network/fetchEntityDetailsGetMerchantReq'
import { fetchSearchEntityReq } from '../../network/fetchSearchEntity'
import { fetchTerminalListDetailsReq } from '../../network/fetchTerminalsListDetails'
import { getAadharRedactionGlobalCheckerListReq } from '../../network/getAadharRedactionCheckerList'
import { getAadharRedactionMakerListReq } from '../../network/getAadharRedactionMakerList'
import { getAllBankDetailsByIFSC } from '../../network/getAllBankDetailsByIFSC'
import { getAllLovsReq, getLovReq } from '../../network/getAllLovs'
import { fetchApiMappingListOfChannelIdReq } from '../../network/getApiMappingList'
import { fetchApisListByChannel } from '../../network/getApisListByChannel'
import { getAuditTrialList } from '../../network/getAuditTrialList'
import { getMccFromBizCategory } from '../../network/getBizLineFromMcc'
import { getBizProgDetailsFromMccCode } from '../../network/getBizProgdetailsFromMcc'
import { getCardSchemesListApi } from '../../network/getCardSchemesList'
import { getCardsList } from '../../network/getCardsList'
import { getConfigOfEntity } from '../../network/getConfigEntity'
import { getDocumentImageRequest } from '../../network/getDocumentImageRequest'
import { getEmisTenuresReq } from '../../network/getEmisTenures'
import { getEMSCardsList } from '../../network/getEMSCardsList'
import { getGroupsListReq } from '../../network/getEmsGroupsList'
import { getSubGroupsListReq } from '../../network/getEmsSubGroupList'
import { getFiuCheckerListReq } from '../../network/getFiuCheckerListReq'
import { getFiuMakerListReq } from '../../network/getFiuMakerList'
import { getGlobalCheckerListReq } from '../../network/getGlobalCheckerList'
import { getInstrumentsNew } from '../../network/getInstrumentsNew'
import { getKycDocumentCategoriesLov } from '../../network/getKycDocumentCategoryFromIdLov'
import { getMakerListReq } from '../../network/getMakerList'
import { getMdrDetails } from '../../network/getMdrDetails'
import { getMyCheckerListReq } from '../../network/getMyCheckerList'
import { fetchOthersApisConfig } from '../../network/getOthersApiConfig'
import { getPaymentsInstruments } from '../../network/getPaymentInstruments'
import { getPincodeData } from '../../network/getPincodeData'
import { getProfileAccessReq } from '../../network/getProfileAccess'
import { getProgramCategoryDetails } from '../../network/getProgramCategoryDetails'
import { getProgramDetailsByProgramIds } from '../../network/getProgramDetailsByProgramIds'
import { getViewDocumentListRequest } from '../../network/getViewDocument'
import { insertCards } from '../../network/insertCards'
import { insertConfig } from '../../network/insertConfig'
import { insertConfigList } from '../../network/insertConfigList'
import { insertMetaConfig } from '../../network/insertMetaConfigList'
import { kycDeleteDocument } from '../../network/kycDeleteDocument'
import { kycDocumentDownload } from '../../network/kycDocumentDownload'
import { kycDocumentsListRq } from '../../network/kycDocumentsList'
import { kycGetUploadId, kycUploadDocument } from '../../network/kycUploadDocument'
import { linkUnlinkMerchantWithDeviceReq } from '../../network/linkUnlinkDeviceMerchant'
import { login } from '../../network/login'
import { logoutCall } from '../../network/logoutCall'
import { manageSRQsApi } from '../../network/manageSRQsApi'
import { menuInfo } from '../../network/menuInfo'
import { processFiuDataReq } from '../../network/processFiuData'
import { removeConfigOfEntityApi } from '../../network/removeConfig'
import { sampleFileDownload } from '../../network/sampleFileDownload'
import { searchConfigEntityReq } from '../../network/searchEntityConfig'
import { syncWithMasReq } from '../../network/syncWithMas'
import { updatApisStatusByProfileNameReq, updatApisStatusReq } from '../../network/updateApisStatus'
import { updateEmsCardsReq } from '../../network/updateEmsCards'
import { updateGroupSubGroupReq } from '../../network/updateEmsGrpSubGrp'
import { updateEntityReq } from '../../network/updateEntity'
import { updateGroupCamundaReq } from '../../network/updateGroupCamunda'
import { updatProfileApisStatusReq } from '../../network/UpdateProfileApiStatus'
import { updateSubGroupCamundaReq } from '../../network/updateSubGroupCamunda'
import { uploadedFileHistory } from '../../network/uploadedFileHistory'
import { EmType } from '../../screens/EntityManagement'
import { mimeTypes, PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { Api } from '../models/Api'
import { approvalData, Approvals } from '../models/Approval'
import { BankType } from '../models/Bank'
import { BulkEntity, BulkEntityData } from '../models/BulkEntity'
import { Card, cardData } from '../models/Card'
import { CreditAdjustment, creditadjustmentData } from '../models/CreditAdjustment'
import { EntityMaster, entityMasterData } from '../models/EntityMaster'
import { EntityOnboarding, entityOnboardingData } from '../models/EntityOnboarding'
import { EssControls, essControlsData } from '../models/EssControls'
import { feePackageData, FeePackageModel } from '../models/FeePackage'
import { FeePackageFileUpload, feePackageFileUploadData } from '../models/FeePackageFileUpload'
import { feePackageMIDData, FeePackageToMId } from '../models/FeePackageToMid'
import { FileUpload, fileUploadData } from '../models/FileUpload'
import { defaultSelectedFilters, Filters } from '../models/Filters'
import { excelFileData, GenerateExcelFile } from '../models/GenerateExcelFile'
import { LedgerMapping, ledgerMappingData } from '../models/LedgerMapping'
import { BulkOnnboardResponse, merchantdata, MerchantMapping } from '../models/Merchant'
import { MerchantPayoutConfig, merchantPayoutConfigData } from '../models/MerchantPayoutConfig'
import { Message } from '../models/Message'
import { Netbanking, netBankingData } from '../models/Netbanking'
import {
  Address,
  Checker,
  ContactProfile,
  EntityContactAddress,
  getRefIdForPaymentInstruments,
  getUrlConfigs,
  Onboarding,
  onboardingData,
  RiskConfigurations,
} from '../models/Onboarding'
import { PayLaterType } from '../models/PayLater'
import { PayoutCms, payoutCmsData } from '../models/PayoutCms'
import { PayoutFrequencyConfig, payoutFrequencyConfigData } from '../models/PayoutFrequencyConfig'
import { posApprovalData, PosApprovals } from '../models/PosApprovals'
import { PostRecon, postReconData } from '../models/PostRecon'
import { ProcessingEntity } from '../models/ProcessingEntity'
import { RiskConfig, riskTxnsData } from '../models/RiskConfig'
import { RoutingRule, routingRuleData } from '../models/Routing'
import { Session, sessionData } from '../models/Session'
import { sourceAccConfigData, SourceAccountConfig } from '../models/SourceAccountConfig'
import { User, userData } from '../models/User'
import { UserManagement, userManagementdata } from '../models/UserManagement'
import { WalletType } from '../models/Wallet'
import { getExportByJobIdProgressApi } from './../../network/exportUsingJobIdApi'
import {
  delay,
  formatDate,
  fromDateTime,
  generateRandomString,
  getAcceptableStatus,
  getErrorMessage,
  getImageLocation,
  getIncreasingDelay,
  MessageTypes,
} from './../../utils'
import { getSelectedDate } from './../../utils/constants'
import { bankingCodeData, BankingCodes } from './../models/BankingCode'
import { Devices, devicesData } from './../models/Devices'
import { packageData, PackageModel } from './../models/Package'
import { packageInstrumentData, PackageToInstrument } from './../models/PackageToInstrument'
import { packageMIDData, PackageToMId } from './../models/PackageToMId'

export const getDocumentCategoryName = (categoryName: string, categories: any) => {
  if (categories?.length > 0) {
    return categories?.filter((category) => category?.key === categoryName)?.[0]?.value
  } else {
    return categoryName
  }
}

const checkCompareNGetValidConfigListChanges = (updatedList: any[], originalList: any[]) => {
  let validList: any[] = []
  for (let i = 0; i < updatedList.length; i++) {
    const orgFilteredList = originalList?.filter(
      (org) => org.configValuesReferenceId === updatedList[i].configValuesReferenceId,
    )
    const updatedFilteredList = updatedList?.filter(
      (upd) => upd.configValuesReferenceId === updatedList[i].configValuesReferenceId,
    )
    if (orgFilteredList?.length !== 0 && updatedFilteredList?.length !== 0) {
      if (orgFilteredList[0].key === 'SUPPORTED_PROCESSING_ENTITY') {
        if (
          orgFilteredList[0].key === updatedFilteredList[0].key &&
          orgFilteredList[0].value === updatedFilteredList[0].value &&
          orgFilteredList[0].status !== updatedFilteredList[0].status
        ) {
          validList.push(updatedFilteredList[0])
        }
      } else if (
        orgFilteredList[0].key === updatedFilteredList[0].key &&
        orgFilteredList[0].value !== updatedFilteredList[0].value
      ) {
        validList.push(updatedFilteredList[0])
      }
    }
  }
  return validList
}

const checkCompareNGetValidEntConfigChanges = (updatedList: any[], originalList: any[]) => {
  let tempUpdatedList: any[] = updatedList
  if (originalList?.length > 0 && updatedList?.length > 0) {
    originalList.map((org) => {
      updatedList.map((upd, index) => {
        if (org.configType === upd.configType) {
          upd?.configValues?.map((updConf) => {
            if (org.key === updConf.key && org.value === updConf.value) {
              console.log('===> upd: ', JSON.parse(JSON.stringify(upd)))
              tempUpdatedList.splice(index, 1)
            }
          })
        }
      })
    })
  }
  console.log('tempUpdatedList', JSON.parse(JSON.stringify(tempUpdatedList)))
  return tempUpdatedList
}

const checkIfPaymentInstrumentConfigPresent = (key: string, value: any, configList: any[]) => {
  return configList.filter((conf) => conf.key === key && conf.value === value).length > 0
}

export const checkIfProfileAccessPresent = (profileName: string, accessList: any[]) => {
  let isPresent = false
  for (let i = 0; i < accessList?.length; i++) {
    if (accessList[i]?.profileName === profileName && accessList[i]?.status === 'ACTIVE') {
      isPresent = true
      break
    }
  }
  return isPresent
}

const getKeyValueStatusList = (list: any[]) => {
  const keyValueStatusList: any[] = []
  list.map((item) => {
    keyValueStatusList.push({
      key: item.key,
      value: item.value,
      status: item.status,
    })
  })
  return keyValueStatusList
}

const getPageSize = (size: number, totalPage: number) => {
  if (totalPage === 1) {
    return size
  }
  return size < 10 && size > 0 ? 10 : size
}

const getPagesCount = (pageSize: number, totalCount: number) => {
  return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize)
}

const getPaginationObject = (totalElements: number, pageNum: number, pageCount: number) => {
  const totEle = totalElements
  const totPage = totEle < 11 ? 1 : getPagesCount(pageCount, totalElements)
  const pageNumber = totEle < 11 ? 1 : pageNum ?? 1
  const pgSize = getPageSize(pageCount ?? 1, totPage)
  return {
    size: pgSize,
    totalElements: totEle ?? 0,
    totalPages: totPage,
    number: pageNumber,
  }
}

const getIsCheckedFromSearchConfig = (data: any, configList: any[]) => {
  let isChecked = false
  configList.map((config) => {
    if (config.value === data.value || config.value === data.id || config.value === data?.partnerName) {
      isChecked = true
    }
  })
  return isChecked
}

const getIsCheckedFromPartnerConfig = (data: any, configList: any[]) => {
  let isChecked = false
  configList.map((config) => {
    if (config.value === data?.partnerName && config.status === 'ACTIVE') {
      isChecked = true
    }
  })
  return isChecked
}

export const getIsCheckedFromCardSearchConfig = (data: any, cardConfigList: any[]) => {
  let isDomesticAllowed = false
  let isInternationalAllowed = false
  let isPremium = false
  for (let i = 0; i < cardConfigList.length; i++) {
    if (data.type === cardConfigList[i].type && data.scheme === cardConfigList[i].scheme) {
      isDomesticAllowed = cardConfigList[i].isDomesticAllowed
      isInternationalAllowed = cardConfigList[i].isInternationalAllowed
      isPremium = cardConfigList[i].isPremium
      break
      // return { isDomesticAllowed, isInternationalAllowed, isPremium }
    }
  }
  return { isDomesticAllowed, isInternationalAllowed, isPremium }
}

const addStatusToConfigValues = (configList: any[]) => {
  return configList.map((config) => {
    return {
      ...config,
      status: 'ACTIVE',
    }
  })
}

const addStatusToConfigurations = (configurations: any[]) => {
  return configurations.map((configuration) => {
    const configValuesNew = configuration.configValues.map((configValue: any) => {
      return {
        ...configValue,
        status: 'ACTIVE',
      }
    })
    const configNew = {
      configType: configuration.configType,
      configValues: configValuesNew,
    }
    return configNew
  })
}

const getListOfPageNumber = (list: any[], pageNumber: number, pageSize: number) => {
  return list?.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)
}

const RecentSearch = types.model('recents', {
  searchString: types.string,
  filterKey: types.string,
})

const Lov = types.model('Lov', {
  key: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
})

const waitTill = (ms: number) => new Promise((res) => setTimeout(res, ms))

const Pagination = types.model('Pagination', {
  size: types.optional(types.number, 0),
  totalElements: types.optional(types.number, 0),
  totalPages: types.optional(types.number, 0),
  number: types.optional(types.number, 1),
})

const SelectedPageRows = types.model('SelectedPageRows', {
  pageNumber: types.number,
  selectedRows: types.optional(types.array(types.number), []),
})

const Position = types.model('position', {
  left: types.optional(types.number, 0),
  top: types.optional(types.number, 0),
  visible: types.optional(types.boolean, false),
})

const DateRange = types.model('date', {
  fromDate: types.optional(types.Date, getSelectedDate(4)),
  toDate: types.optional(types.Date, new Date(Date.now())),
  position: types.optional(Position, {}),
  dateLabel: types.optional(types.string, 'Last 90 days'),
})

const CheckerApplicationStatus = types.model('CheckerApplicationStatus', {
  applicationId: types.optional(types.string, ''),
  applicationStatus: types.optional(types.string, ''),
  applicationType: types.optional(types.string, ''),
  assignee: types.optional(types.string, ''),
  brandName: types.optional(types.string, ''),
  groupAddress: types.maybeNull(types.array(Address)),
  groupContacts: types.maybeNull(types.array(ContactProfile)),
  legalName: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  errorTask: types.optional(types.string, ''),
  completedTaskList: types.optional(types.array(types.string), []),
  errorReason: types.optional(types.string, ''),
  identificationNumber: types.optional(types.string, ''),
  inProgressTask: types.optional(types.string, ''),
  callCount: types.optional(types.number, 0),
  jfsUserid: types.optional(types.string, ''),
  comments: types.optional(types.string, ''),
  creationDate: types.optional(types.string, ''),
})
const Cin = types.model('Cin', {
  number: types.maybeNull(types.string),
  date: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
})

const Director = types.model('Director', {
  din: types.maybeNull(types.string),
  firstName: types.maybeNull(types.string),
  middleName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  dob: types.maybeNull(types.string),
  // slno: types.maybeNull(types.number),
  surrenderedDin: types.maybeNull(types.string),
  beginAt: types.maybeNull(types.string),
  endAt: types.maybeNull(types.string),
  _editDelete: types.maybeNull(types.string),
  directorReferenceId: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
})

const Ubo = types.model('Ubo', {
  firstName: types.maybeNull(types.string),
  middleName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  dob: types.maybeNull(types.string),
  _editDelete: types.maybeNull(types.string),
  beneficialOwnerReferenceId: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
})

const AuthorisedSignatory = types.model('AuthorisedSignatory', {
  authSigFirstname: types.maybeNull(types.string),
  authSigMidname: types.maybeNull(types.string),
  authSigLastname: types.maybeNull(types.string),
  authSigDOB: types.maybeNull(types.string),
  _editDelete: types.maybeNull(types.string),
  authorisedSignatoryReferenceId: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
})

const Fiu = types.model('Fiu', {
  cin: types.maybeNull(Cin),
  directors: types.maybeNull(types.array(Director)),
  ubos: types.maybeNull(types.array(Ubo)),
  authSignatories: types.maybeNull(types.array(AuthorisedSignatory)),
  isFiuDataChanged: types.maybeNull(types.boolean),
})

const ServiceError = types
  .model('ServiceError', {
    title: types.optional(types.string, ''),
    traceId: types.optional(types.string, ''),
    message: types.optional(types.string, ''),
    serviceName: types.optional(types.string, ''),
  })
  .actions((self) => ({
    setServiceError(title: string, traceId: string, message: string, serviceName: string) {
      self.title = title
      self.traceId = traceId
      self.message = message
      self.serviceName = serviceName
    },
    resetServiceError() {
      self.title = ''
      self.traceId = ''
      self.message = ''
      self.serviceName = ''
    },
  }))
  .views((self) => ({
    getServiceError(): any {
      return {
        title: self.title,
        traceId: self.traceId,
        message: self.message,
        serviceName: self.serviceName,
      }
    },
  }))

const KycDocument = types.model('KycDocument', {
  DOCID: types.maybeNull(types.string),
  NAME: types.maybeNull(types.string),
  MERCHANT_DOCUMENT_TYPE: types.maybeNull(types.string),
  DOCUMENTSTATUS: types.maybeNull(types.string),
  RID: types.maybeNull(types.string),
  TRANSACTION_ID: types.maybeNull(types.string),
})

const Document = types.model('Document', {
  NAME: types.maybeNull(types.string),
  MERCHANT_DOCUMENT_TYPE: types.maybeNull(types.string),
  MERCHANT_DOCUMENT_NAME: types.maybeNull(types.string),
  RID: types.maybeNull(types.string),
  TRANSACTION_ID: types.maybeNull(types.string),
  DOCUMENTSTATUS: types.maybeNull(types.string),
  expiry: types.maybeNull(types.string),
  deleteOnly: types.maybeNull(types.string),
  uploadId: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
  _replace: types.maybeNull(types.string),
  DOCID: types.maybeNull(types.string),
  documentNumber: types.maybeNull(types.string),
  documentCategory: types.maybeNull(types.string),
  documentId: types.maybeNull(types.string),
  kycDocuments: types.maybeNull(types.array(KycDocument)),
  dateOfExpiry: types.maybeNull(types.string),
})

const DocumentCategory = types.model('DocumentCategory', {
  key: types.maybeNull(types.string),
  value: types.maybeNull(types.string),
  documentCategories: types.maybeNull(types.optional(types.array(types.string), [])),
})

const AuditTrialObject = types.model('AuditTrialObject', {
  code: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  status: types.maybeNull(types.boolean),
})

const AuditTrial = types.model('AuditTrial', {
  createdBy: types.maybeNull(types.string),
  createdDate: types.maybeNull(types.string),
  lastModifiedBy: types.maybeNull(types.string),
  lastModifiedDate: types.maybeNull(types.string),
  id: types.maybeNull(types.number),
  key: types.maybeNull(types.string),
  object: types.maybeNull(AuditTrialObject),
  // listObject: null,
  type: types.maybeNull(types.string),
  className: types.maybeNull(types.string),
  username: types.maybeNull(types.string),
  approvalType: types.maybeNull(types.string),
  approvalStatus: types.maybeNull(types.boolean),
  fileType: types.maybeNull(types.union(types.number, types.string)),
  action: types.maybeNull(types.string),
  actionBy: types.maybeNull(types.string),
  actionDoneAt: types.maybeNull(types.string),
})

const Root = types
  .model('Root', {
    user: User,
    entityMaster: EntityMaster,
    bankingCode: BankingCodes,
    card: Card,
    devices: Devices,
    netBanking: Netbanking,
    routingRule: RoutingRule,
    merchantMapping: MerchantMapping,
    approvals: Approvals,
    message: Message,
    package: PackageModel,
    packageToInstrument: PackageToInstrument,
    packageToMId: PackageToMId,
    generateExcelFile: GenerateExcelFile,
    fileUpload: FileUpload,
    session: Session,
    userManagement: UserManagement,
    apis: types.optional(types.array(Api), []),
    apiaccesslist: types.optional(types.array(Api), []),
    onboarding: Onboarding,
    recentSearches: types.array(RecentSearch),
    bulkEntity: BulkEntity,
    lovs: types.optional(types.array(Lov), []),
    pagination: types.optional(Pagination, {}),
    // selectedRowsIndex: types.optional(types.array(SelectedPageRows), []),
    globalCheckerList: types.optional(types.array(Checker), []),
    myCheckerList: types.optional(types.array(Checker), []),
    makerList: types.optional(types.array(Checker), []),
    selectedDateInfo: types.optional(DateRange, {}),
    filter: types.optional(Filters, {}),
    feePackage: FeePackageModel,
    feePackageFileUpload: FeePackageFileUpload,
    feePackageToMId: FeePackageToMId,
    ledgerMapping: LedgerMapping,
    riskConfig: RiskConfig,
    payoutCms: PayoutCms,
    merchantPayoutConfig: MerchantPayoutConfig,
    sourceAccountConfig: SourceAccountConfig,
    essControls: EssControls,
    processingEntity: ProcessingEntity,
    payoutFrequencyConfig: PayoutFrequencyConfig,
    creditAdjustment: CreditAdjustment,
    checkerApplicationStatus: types.optional(CheckerApplicationStatus, {}),
    serviceError: types.optional(ServiceError, {}),
    forceSideMenuRefresh: types.optional(types.boolean, false),
    isApiConfigSaveCallDone: types.optional(types.boolean, false),
    documents: types.optional(types.array(Document), []),
    posApprovals: PosApprovals,
    fiu: types.optional(Fiu, {}),
    fiuCheckerList: types.optional(types.array(Checker), []),
    fiuMakerList: types.optional(types.array(Checker), []),
    aadharRedactiondocuments: types.optional(types.array(Document), []),
    aadharEditedRedactiondocuments: types.optional(types.array(Document), []),
    aadharNonEditedRedactiondocuments: types.optional(types.array(Document), []),
    aadharRedactionCheckerList: types.optional(types.array(Checker), []),
    aadharRedactionMakerList: types.optional(types.array(Checker), []),
    aadharOriginalList: types.optional(types.array(Document), []),
    postRecon: PostRecon,
    documentCategories: types.maybeNull(types.array(DocumentCategory)),
    auditTrials: types.maybeNull(types.array(AuditTrial)),
    entityOnboarding: EntityOnboarding,
  })
  .actions((self) => ({
    fetchAuditTrialList: flow(function* fetchAuditTrialList(
      approvalDataType: string,
      isAccessConfigPriviledged: boolean,
      isApprover: boolean,
      page: any,
      getAbortController: any,
    ) {
      try {
        const abortController = getAbortController()
        const response = yield getAuditTrialList(
          self.user.name,
          approvalDataType,
          page,
          isAccessConfigPriviledged,
          isAccessConfigPriviledged ? 'privileged' : isApprover ? 'approver' : 'user',
          self.session.getTokens,
          abortController,
        )
        //  self.auditTrials = response
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    clearAadharRedactionsEditedNonEditedDocs() {
      self.aadharEditedRedactiondocuments = JSON.parse(JSON.stringify([]))
      self.aadharNonEditedRedactiondocuments = JSON.parse(JSON.stringify([]))
    },
    clearSubmittedFiuData(type: string) {
      if (type === 'director') {
        self.fiu.directors.map((dir, index) => {
          if (dir?.action?.length > 0) {
            self.fiu.directors.splice(index, 1)
          }
        })
      } else if (type === 'ubo') {
        self.fiu.ubos.map((ubo, index) => {
          if (ubo?.action?.length > 0) {
            self.fiu.ubos.splice(index, 1)
          }
        })
      } else if (type === 'auth') {
        self.fiu.authSignatories.map((auth, index) => {
          if (auth?.action?.length > 0) {
            self.fiu.authSignatories.splice(index, 1)
          }
        })
      }
    },
    clearDocuments() {
      self.documents = JSON.parse(JSON.stringify([]))
      self.onboarding.uploadId = ''
    },
    resetBusinessLineAndCategory() {
      self.onboarding.businessDetail.businessLine = ''
      self.onboarding.businessDetail.businessCategory = ''
    },
    getDocumentTypeFromNonEditedList(docNumber: string) {
      let docType = ''
      for (let i = 0; i < self?.aadharNonEditedRedactiondocuments?.length; i++) {
        if (self?.aadharNonEditedRedactiondocuments[i]?.DOCID === docNumber) {
          docType = self?.aadharNonEditedRedactiondocuments[i]?.MERCHANT_DOCUMENT_TYPE
          break
        }
      }
      return docType
    },
    exportFileAsync: flow(function* exportFileAsync(data: any, type: any, isElevated: any, getAbortController: any) {
      try {
        let req = getExportFileRequest(data)
        if (['privileged', 'approver', 'user'].includes(type)) {
          req = getExportAuditTrailsRequest(isElevated, self.user.name, data)
        }
        const abortController = getAbortController()
        const resp = yield initiateExportFileApi(req, type, isElevated, RootStore.session.getTokens)
        const fileName = resp?.data?.content?.fileName
        if (resp?.data?.status === 'SUCCESS' && fileName) {
          let noOfRetry = 0
          while (noOfRetry < 20) {
            noOfRetry++
            const downloadFileReps = yield (self as any).downloadExportFileAsync(fileName, abortController)
            if (downloadFileReps?.status === 'PENDING') {
              yield delay(getIncreasingDelay(noOfRetry))
            } else if (downloadFileReps?.status === 'SUCCESS') {
              break
            } else {
              throw new Error(downloadFileReps?.message)
            }
          }
        } else {
          throw new Error('an unexpected error has occured')
        }
      } catch (e) {
        RootStore.message.setMessage(getErrorMessage(e), MessageTypes.ERROR)
        console.log({ e })
      }
    }),
    downloadExportFileAsync: flow(function* downloadExportFileAsync(fileName: string, abortController: any) {
      let errorCode = ''
      let resp: any = {}
      try {
        resp = yield downloadExportFileApi(fileName, RootStore.session.getTokens, abortController)
        if (window && !errorCode && resp && resp?.data && resp?.data instanceof ArrayBuffer) {
          let contentType = resp.headers['content-type']
          if (mimeTypes.get(contentType) === undefined) {
            return { status: 'FAILED' }
          } else {
            const blob = new Blob([resp?.data], { type: contentType })
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = fileName
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
            return { status: 'SUCCESS' }
          }
        } else {
          const status = resp?.data?.meta?.status
          if (status === 2) {
            return { status: 'PENDING' }
          } else {
            return { status: 'FAILED', message: resp?.data?.meta?.message }
          }
        }
      } catch (e) {
        console.log({ e })
      }
      return { status: 'FAILED' }
    }),
    undoAadharReplace(data: any) {
      self.documents.map((doc) => {
        if (doc?.NAME === data?.NAME) {
          doc.action = ''
          return doc
        }
      })

      self.aadharRedactiondocuments.map((aDoc) => {
        if (aDoc?.NAME === data?.NAME) {
          aDoc.action = ''
          return aDoc
        }
      })
    },
    replaceAadharRedaction(data: any) {
      if (self.aadharRedactiondocuments?.length > 0) {
        for (let i = 0; i < self.aadharRedactiondocuments.length; i++) {
          if (self.aadharRedactiondocuments?.[i]?.NAME === data?.NAME) {
            self.aadharRedactiondocuments[i].action = 'REPLACE'
          }
        }
      }
      self.documents.map((doc) => {
        if (doc.NAME === data.NAME) {
          doc.action = 'REPLACE'
          return doc
        }
      })
    },
    getKycEditedAadharDocumentsList() {
      let list = []
      if (self.aadharRedactiondocuments?.length > 0) {
        self.aadharRedactiondocuments.map((doc) => {
          if (doc?.action !== null && doc?.action !== '') {
            list.push({
              NAME: doc?.NAME,
              MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
              DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
              action: doc?.action,
              _undo: '',
            })
          }
        })
      }
      return list
    },
    setFiuDataChanged(isChanged: boolean) {
      self.fiu.isFiuDataChanged = isChanged
    },
    processFiuData: flow(function* processFiuData(
      applicationId: string,
      status: string,
      comments: string,
      filterType: string,
    ) {
      try {
        const response = yield processFiuDataReq(applicationId, status, comments, self.session.getTokens, filterType)
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    exportFiuRecords: flow(function* exportFiuRecords(processDefinitionKeyType, fileType, entityId) {
      const req = {
        inputFilters: {
          endDateTime: fromDateTime(new Date(self.selectedDateInfo.toDate)),
          startDateTime: fromDateTime(new Date(self.selectedDateInfo.fromDate)),
          entityId,
          ...(self.filter?.applicationStatus.length > 0 &&
            !self.filter?.applicationStatus?.includes('ALL') && {
              status: getAcceptableStatus(self.filter?.applicationStatus),
            }),
        },
        processDefinitionKeyType,
        //: 'AADHAAR_REDACTION',
        fileType: exportType.get(fileType),
      }
      let resp
      try {
        resp = yield exportFile(self.session.getTokens, req)
        return resp
      } catch (e) {
        RootStore?.message?.setMessage(e?.message ?? 'Error while processing')
      }
      return resp
    }),
    getDirectorChanges(_identificationNumber: string) {
      let list: any[] = []
      self.fiu.directors.map((dir) => {
        if (dir?.action?.length > 0) {
          list.push({
            din: dir?.din,
            firstName: dir?.firstName,
            middleName: dir?.middleName,
            lastName: dir?.lastName,
            dob: dir?.dob?.includes('T') ? dir?.dob?.split('T')?.[0] : dir?.dob,
            beginAt: dir?.beginAt?.includes('T') ? dir?.beginAt : `${dir?.beginAt}T05:30:00.000Z`,
            endAt:  dir?.endAt?.includes('T') ? dir?.endAt : `${dir?.endAt}T05:30:00.000Z`,
            action: dir?.action,
            ...(dir?.directorReferenceId?.length > 0 && { directorReferenceId: dir?.directorReferenceId }),
          })
        }
      })
      return list
    },
    getUboChanges(_identificationNumber: string) {
      let list: any[] = []
      self.fiu.ubos.map((ubo) => {
        if (ubo?.action?.length > 0) {
          list.push({
            firstName: ubo?.firstName,
            middleName: ubo?.middleName,
            lastName: ubo?.lastName,
            dob: ubo?.dob?.includes('T') ? ubo?.dob?.split('T')?.[0] : ubo?.dob,
            action: ubo?.action,
            ...(ubo?.beneficialOwnerReferenceId?.length > 0 && {
              beneficialOwnerReferenceId: ubo?.beneficialOwnerReferenceId,
            }),
          })
        }
      })
      return list
    },
    getAuthChanges(_identificationNumber: string) {
      let list: any[] = []
      self.fiu.authSignatories.map((auth) => {
        if (auth?.action?.length > 0) {
          list.push({
            authSigFirstname: auth?.authSigFirstname,
            authSigMidname: auth?.authSigMidname,
            authSigLastname: auth?.authSigLastname,
            authSigDOB: auth?.authSigDOB?.includes('T') ? auth?.authSigDOB?.split('T')?.[0] : auth?.authSigDOB,
            action: auth?.action,
            ...(auth?.authorisedSignatoryReferenceId?.length > 0 && {
              authorisedSignatoryReferenceId: auth?.authorisedSignatoryReferenceId,
            }),
          })
        }
      })
      return list
    },
    createUpdateDeleteFiuData: flow(function* createUpdateDeleteFiuData(
      identificationNumber: string,
      auditType: string,
      dataToManipulate: any,
      makerComments?: string,
    ) {
      try {
        let response
        if (dataToManipulate) {
          response = yield createUpdateDeleteFiu(
            identificationNumber,
            auditType,
            dataToManipulate,
            makerComments,
            self.session.getTokens,
          )
          if (response?.status === 'Success') {
            RootStore.message.setMessage(
              `Application with id ${response?.data?.applicationId} has been submitted to Checker`,
              MessageTypes.SUCCESS,
            )
            // if (auditType === 'AADHAR_REDACTION') {
            //   self.aadharRedactiondocuments = JSON.parse(JSON.stringify([]))
            //   self.aadharEditedRedactiondocuments = JSON.parse(JSON.stringify([]))
            //   self.aadharNonEditedRedactiondocuments = JSON.parse(JSON.stringify([]))
            // }
          }
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
      }
    }),
    getDirectorsList(entityId: string) {
      let list = []
      self?.onboarding?.searchEntity?.map((ent) => {
        if (ent.entity.identificationNumber === entityId) {
          if (ent.directorEntities?.length > 0) {
            ent.directorEntities.map((dir) => {
              if (dir.action === null || dir.action === '') {
                list.push({
                  din: dir?.din,
                  firstName: dir?.firstName,
                  middleName: dir?.middleName,
                  lastName: dir?.lastName,
                  dob: dir?.dob?.includes(' ') ? dir?.dob?.split?.(' ')?.[0] : dir?.dob,
                  beginAt: dir?.beginAt?.includes('T') ? dir?.beginAt?.split('T')?.[0] : dir?.beginAt,
                  endAt: dir?.endAt?.includes('T') ? dir?.endAt?.split('T')?.[0] : dir?.endAt,
                  directorReferenceId: dir?.directorReferenceId,
                  status: dir?.status,
                  _editDelete: '',
                })
              }
            })
          }
        }
      })
      return list
    },
    getEditedDirectorsList() {
      let list = []
      self?.fiu?.directors?.map((dir) => {
        if (dir?.action?.length > 0) {
          list.push({
            din: dir?.din,
            firstName: dir?.firstName,
            middleName: dir?.middleName,
            lastName: dir?.lastName,
            dob: dir?.dob?.includes(' ')
              ? dir?.dob?.split?.(' ')?.[0]
              : dir?.dob?.includes('T')
              ? dir?.dob?.split('T')?.[0]
              : dir?.dob,
            beginAt: dir?.beginAt,
            endAt: dir?.endAt,
            directorReferenceId: dir?.directorReferenceId,
            action: dir?.action,
            _undo: '',
          })
        }
      })
      return list
    },
    getUboList(entityId: string) {
      let list = []
      self?.onboarding?.searchEntity?.map((ent) => {
        if (ent.entity.identificationNumber === entityId) {
          if (ent.beneficialOwnerEntity?.length > 0) {
            ent.beneficialOwnerEntity.map((ubo) => {
              if (ubo.action === null || ubo.action === '') {
                const data = {
                  firstName: ubo?.firstName,
                  middleName: ubo?.middleName,
                  lastName: ubo?.lastName,
                  dob: !isNaN(+ubo?.dob) ? new Date(+ubo?.dob)?.toISOString()?.split('T')?.[0] : ubo?.dob,
                  beneficialOwnerReferenceId: ubo?.beneficialOwnerReferenceId,
                  status: ubo?.status,
                  _editDelete: '',
                }
                list.push(data)
              }
            })
          }
        }
      })
      return list
    },
    getEditedUboList() {
      let list = []
      self?.fiu?.ubos?.map((ubo) => {
        if (ubo?.action?.length > 0) {
          const data = {
            firstName: ubo?.firstName,
            middleName: ubo?.middleName,
            lastName: ubo?.lastName,
            dob: !isNaN(+ubo?.dob)
              ? new Date(+ubo?.dob)?.toISOString()?.split('T')?.[0]
              : ubo?.dob?.includes('T')
              ? ubo?.dob?.split('T')?.[0]
              : ubo?.dob,
            beneficialOwnerReferenceId: ubo?.beneficialOwnerReferenceId,
            action: ubo?.action,
            _undo: '',
          }
          list.push(data)
        }
      })
      return list
    },
    getAuthSignotoriesList(entityId: string) {
      let list = []
      self?.onboarding?.searchEntity?.map((ent) => {
        if (ent.entity.identificationNumber === entityId) {
          if (ent?.entity?.authorisedSignatories?.length > 0) {
            ent.entity.authorisedSignatories.map((auth) => {
              if (auth.action === null || auth.action === '') {
                list.push({
                  firstName: auth?.authSigFirstname,
                  middleName: auth?.authSigMidname,
                  lastName: auth?.authSigLastname,
                  dob: auth?.authSigDOB,
                  authorisedSignatoryReferenceId: auth?.authorisedSignatoryReferenceId,
                   status: auth?.status,
                  _editDelete: '',
                })
              }
            })
          }
        }
      })
      return list
    },
    getEditedAuthSignotoriesList() {
      let list = []
      self?.fiu?.authSignatories?.map((auth) => {
        if (auth?.action?.length > 0) {
          list.push({
            firstName: auth?.authSigFirstname,
            middleName: auth?.authSigMidname,
            lastName: auth?.authSigLastname,
            dob: auth?.authSigDOB?.includes('T') ? auth?.authSigDOB?.split('T')?.[0] : auth?.authSigDOB,
            authorisedSignatoryReferenceId: auth?.authorisedSignatoryReferenceId,
            action: auth?.action,
            _undo: '',
          })
        }
      })
      return list
    },
    updateCin(mCin: any) {
      self.fiu.cin.date = mCin?.cinDate
      self.fiu.cin.number = mCin?.cinNumber
      self.fiu.cin.action = 'UPDATE'
      self.fiu.isFiuDataChanged = true
    },
    addDirector(director: any) {
      if (
        director &&
        (director?.din?.length > 0 ||
          director?.beginAt?.length > 0 ||
          director?.dob?.length > 0 ||
          director?.endAt?.length > 0 ||
          director?.firstName?.length > 0 ||
          director?.middleName?.length > 0 ||
          director?.lastName?.length > 0)
      ) {
        self.fiu.directors.push({
          din: director?.din,
          beginAt: director?.beginAt.split('T')?.[0],
          dob: director?.dob?.split('T')?.[0],
          endAt: director?.endAt.split('T')?.[0],
          firstName: director.firstName,
          middleName: director.middleName,
          lastName: director.lastName,
          action: 'CREATE',
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    addUbo(ubo: any) {
      if (
        ubo &&
        (ubo?.uboFname?.length > 0 || ubo?.uboLname?.length > 0 || ubo?.uboMname?.length > 0 || ubo?.uboDob?.length > 0)
      ) {
        self.fiu.ubos.push({
          firstName: ubo.uboFname,
          lastName: ubo.uboLname,
          middleName: ubo.uboMname,
          dob: ubo?.uboDob?.split('T')?.[0],
          action: 'CREATE',
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    addAuthorisedSignatory(auth: any) {
      if (
        auth &&
        (auth?.authSigFirstname?.length > 0 ||
          auth?.authSigLastname?.length > 0 ||
          auth?.authSigMidname?.length > 0 ||
          auth?.authSigDOB?.length > 0)
      ) {
        self.fiu.authSignatories.push({
          authSigFirstname: auth.authSigFirstname,
          authSigLastname: auth.authSigLastname,
          authSigMidname: auth.authSigMidname,
          authSigDOB: auth?.authSigDOB?.split('T')?.[0],
          action: 'CREATE',
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    updateDirectorChanges(mDirector: any, identificationNumber: string) {
      if (mDirector && self.fiu.directors.length > 0) {
        self.fiu.directors.map((data) => {
          if (data?.directorReferenceId === mDirector?.directorReferenceId) {
            data.beginAt = mDirector.beginAt
            data.dob = mDirector.dob
            data.endAt = mDirector.endAt
            data.firstName = mDirector.firstName
            data.middleName = mDirector.middleName
            data.lastName = mDirector.lastName
            data.din = mDirector.din
            data.action = 'UPDATE'
          }
          return data
        })
        self.onboarding.searchEntity.map((entity) => {
          if (entity.entity.identificationNumber === identificationNumber) {
            entity.directorEntities.map((dir) => {
              if (dir.directorReferenceId === mDirector.directorReferenceId) {
                dir.action = 'UPDATE'
              }
              return dir
            })
          }
          return entity
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    updateUboChanges(mUbo: any, identificationNumber: string) {
      if (mUbo && self.fiu.ubos.length > 0) {
        self.fiu.ubos.map((data) => {
          if (data?.beneficialOwnerReferenceId === mUbo?.beneficialOwnerReferenceId) {
            data.dob = mUbo.uboDob
            data.firstName = mUbo.uboFname
            data.middleName = mUbo.uboMname
            data.lastName = mUbo.uboLname
            data.action = 'UPDATE'
          }
          return data
        })
        self.onboarding.searchEntity.map((entity) => {
          if (entity.entity.identificationNumber === identificationNumber) {
            entity.beneficialOwnerEntity.map((ubo) => {
              if (ubo.beneficialOwnerReferenceId === mUbo.beneficialOwnerReferenceId) {
                ubo.action = 'UPDATE'
              }
              return ubo
            })
          }
          return entity
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    updateAuthSigChanges(mAuth: any, identificationNumber: string) {
      if (mAuth && self.fiu.authSignatories.length > 0) {
        self.fiu.authSignatories.map((data) => {
          if (data?.authorisedSignatoryReferenceId === mAuth?.authorisedSignatoryReferenceId) {
            data.authSigDOB = mAuth.authSigDOB
            data.authSigFirstname = mAuth.authSigFirstname
            data.authSigMidname = mAuth.authSigMidname
            data.authSigLastname = mAuth.authSigLastname
            data.action = 'UPDATE'
          }
          return data
        })

        self.onboarding.searchEntity.map((entity) => {
          if (entity.entity.identificationNumber === identificationNumber) {
            entity?.entity?.authorisedSignatories?.map((auth) => {
              if (auth.authorisedSignatoryReferenceId === mAuth.authorisedSignatoryReferenceId) {
                auth.action = 'UPDATE'
              }
              return auth
            })
          }
          return entity
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    deleteDirector(directorData: any, identificationNumber: string) {
      if (
        self.fiu.directors.filter((director) => director.directorReferenceId === directorData.directorReferenceId)
          .length !== 0
      ) {
        for (let i = 0; i < self.fiu.directors.length; i++) {
          if (self.fiu.directors[i].directorReferenceId === directorData.directorReferenceId) {
            self.fiu.directors[i].action = 'DELETE'
          }
        }
        self.onboarding.searchEntity.map((entity) => {
          if (entity.entity.identificationNumber === identificationNumber) {
            entity.directorEntities.map((dir) => {
              if (dir.directorReferenceId === directorData.directorReferenceId) {
                dir.action = 'DELETE'
              }
              return dir
            })
          }
          return entity
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    undoDirector(directorData: any, identificationNumber: string) {
      self.onboarding.searchEntity.map((entity) => {
        if (entity.entity.identificationNumber === identificationNumber) {
          if (entity && entity?.directorEntities?.length > 0) {
            entity.directorEntities.map((dir) => {
              if (dir.directorReferenceId === directorData.directorReferenceId) {
                dir.action = ''
                return dir
              }
            })
          }
        }
        return entity
      })
      self.fiu.directors.map((dir) => {
        if (dir.directorReferenceId === directorData?.directorReferenceId) {
          // const nameArray = directorData?.name?.split(' ')
          dir.din = directorData.din
          dir.directorReferenceId = directorData?.directorReferenceId
          dir.dob = directorData?.dob
          dir.endAt = directorData?.endAt
          dir.beginAt = directorData?.beginAt
          dir.firstName = directorData?.firstName
          dir.middleName = directorData?.middleName
          dir.lastName = directorData?.lastName
          dir._editDelete = ''
          dir.action = ''
          return dir
        }
        // return dir
      })
      self.fiu.isFiuDataChanged = true
    },
    undoUbo(uboData: any, identificationNumber: string) {
      self.onboarding.searchEntity.map((entity) => {
        if (entity.entity.identificationNumber === identificationNumber) {
          if (entity && entity?.beneficialOwnerEntity?.length > 0) {
            entity.beneficialOwnerEntity.map((ubo) => {
              if (ubo.beneficialOwnerReferenceId === uboData.beneficialOwnerReferenceId) {
                ubo.action = ''
                return ubo
              }
            })
          }
        }
        return entity
      })
      self.fiu.ubos.map((ubo) => {
        if (ubo.beneficialOwnerReferenceId === uboData?.beneficialOwnerReferenceId) {
          // const nameArray = uboData?.name?.split(' ')
          ubo.firstName = uboData?.firstName
          ubo.middleName = uboData?.middleName
          ubo.lastName = uboData?.lastName
          ubo.dob = uboData?.dob
          ubo.beneficialOwnerReferenceId = uboData?.beneficialOwnerReferenceId
          ubo._editDelete = ''
          ubo.action = ''
          return ubo
        }
        // return ubo
      })

      self.fiu.isFiuDataChanged = true
    },
    undoAuth(authData: any, identificationNumber: string) {
      self.onboarding.searchEntity.map((entity) => {
        if (entity.entity.identificationNumber === identificationNumber) {
          if (entity && entity.entity && entity?.entity?.authorisedSignatories?.length > 0) {
            entity.entity.authorisedSignatories.map((auth) => {
              if (auth.authorisedSignatoryReferenceId === authData.authorisedSignatoryReferenceId) {
                auth.action = ''
                return auth
              }
            })
          }
        }
        return entity
      })
      self.fiu.authSignatories.map((auth) => {
        if (auth.authorisedSignatoryReferenceId === authData?.authorisedSignatoryReferenceId) {
          // const nameArray = authData?.name?.split(' ')
          auth.authSigFirstname = authData?.firstName
          auth.authSigMidname = authData?.middleName
          auth.authSigLastname = authData?.lastName
          auth.authSigDOB = authData?.dob
          auth.authorisedSignatoryReferenceId = authData?.authorisedSignatoryReferenceId
          auth._editDelete = ''
          auth.action = ''
          return auth
        }
      })
      self.fiu.isFiuDataChanged = true
    },
    deleteUbo(uboData: any, identificationNumber: string) {
      if (
        self.fiu.ubos.filter((ubo) => ubo.beneficialOwnerReferenceId === uboData.beneficialOwnerReferenceId).length !==
        0
      ) {
        for (let i = 0; i < self.fiu.ubos.length; i++) {
          if (self.fiu.ubos[i].beneficialOwnerReferenceId === uboData.beneficialOwnerReferenceId) {
            self.fiu.ubos[i].action = 'DELETE'
          }
        }
        self.onboarding.searchEntity.map((entity) => {
          if (entity.entity.identificationNumber === identificationNumber) {
            entity.beneficialOwnerEntity.map((ubo) => {
              if (ubo.beneficialOwnerReferenceId === uboData.beneficialOwnerReferenceId) {
                ubo.action = 'DELETE'
              }
              return ubo
            })
          }
          return entity
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    deleteAuthSignatory(authData: any, identificationNumber: string) {
      if (
        self.fiu.authSignatories.filter(
          (auth) => auth.authorisedSignatoryReferenceId === authData.authorisedSignatoryReferenceId,
        ).length !== 0
      ) {
        for (let i = 0; i < self.fiu.authSignatories.length; i++) {
          if (self.fiu.authSignatories[i].authorisedSignatoryReferenceId === authData.authorisedSignatoryReferenceId) {
            self.fiu.authSignatories[i].action = 'DELETE'
          }
        }
        self.onboarding.searchEntity.map((entity) => {
          if (entity?.entity?.identificationNumber === identificationNumber) {
            entity?.entity?.authorisedSignatories?.map((auth) => {
              if (auth.authorisedSignatoryReferenceId === authData.authorisedSignatoryReferenceId) {
                auth.action = 'DELETE'
              }
              return auth
            })
          }
          return entity
        })
        self.fiu.isFiuDataChanged = true
      }
    },
    kycDocumentsList: flow(function* kycDocumentsList(
      uploadId: string,
      type: string,
      aadharRejectedState: string,
      ignoreEmptyError: boolean = false,
    ) {
      try {
        if (type === 'REDACT') {
          self.aadharEditedRedactiondocuments = JSON.parse(JSON.stringify([]))
        } else {
          self.documents = JSON.parse(JSON.stringify([]))
        }
        const response = yield kycDocumentsListRq(
          uploadId,
          self.session.getTokens,
          type,
          aadharRejectedState,
          ignoreEmptyError,
        )
        if (type === 'REDACT') {
          self.aadharEditedRedactiondocuments = response
        } else {
          self.documents = response
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
      }
    }),
    getParentChildEntityList(entityId: string) {
      let bussHierarchy: any[] = []
      let childList: any[] = []
      let entityName,
        level,
        groupName,
        subGroupName = ''
      self.onboarding.searchEntity.map((data) => {
        groupName = data?.group?.brandName
        entityName = data?.entity?.legalName
        subGroupName = data?.subGroup?.brandName
        level = data?.entity?.entityLevel
        if (data?.entity?.identificationNumber === entityId) {
          if (data?.group) {
            bussHierarchy.push({
              id: data?.group?.identificationNumber,
              type: 'Group',
              name: data?.group?.brandName,
              masId: data?.group?.groupId ?? '', //TODO: Check
              status: data?.group?.status,
            })
          }

          if (data?.subGroup) {
            bussHierarchy.push({
              id: data?.subGroup?.identificationNumber,
              type: 'Subgroup',
              name: data?.subGroup?.brandName,
              masId: data?.subGroup?.groupId ?? '', //TODO: Check
              status: data?.subGroup?.status,
            })
          }

          if (data?.parent) {
            bussHierarchy.push({
              id: `${data?.parent?.identificationNumber}`,
              type: 'Parent',
              name: data?.parent?.businessName,
              masId: data?.parent?.identificationNumber,
              status: data?.parent?.status,
            })
          }
          if (data?.entity) {
            bussHierarchy.push({
              id: data?.entity?.identificationNumber,
              type: 'Entity',
              name: data?.entity?.businessName,
              masId: data?.entity?.identificationNumber,
              status: data?.entity?.status,
              source: data?.entity?.source,
            })
          }

          data?.child?.map((child: any) => {
            childList.push({
              // entityLevel: data?.parent?.entityLevel,
              identificationNumber: child?.identificationNumber,
              businessName: child?.businessName,
              status: (self as any).getLovsDescriptionFromKeyValue('Status', child?.status),
            })
          })
        }
      })

      self.pagination = {
        size: 10,
        totalElements: childList?.length,
        totalPages: childList?.length / 10 > 1 ? Math.ceil(childList?.length / 10) : 1,
        number: self.pagination.number,
      }

      return {
        parentList: bussHierarchy,
        childList: getListOfPageNumber(childList, self.pagination.number, 10),
        entityName: entityName,
        groupName: groupName,
        subGroupName: subGroupName,
        level: level,
      }
    },
    resetBusinessLineAndCategory() {
      self.onboarding.businessDetail.businessLine = ''
      self.onboarding.businessDetail.businessCategory = ''
    },
    getEntityContactProfiles(entityId: string, type: string) {
      let contactDetails: any[] = []
      if (entityId && self.onboarding.searchEntity.length > 0 && type !== EmType.createSingleEntity) {
        self.onboarding.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            if (data?.entity?.source === 'MAS') {
              let mContact = data?.entity?.contactDetails?.filter((contact) => contact?.role === 'CRP')?.[0]
              if (mContact && !mContact?.mobileNumber.startsWith('+91')) {
                mContact.mobileNumber =
                  mContact?.entityContactAddress?.countryCode?.length > 0
                    ? `${mContact?.entityContactAddress?.countryCode}${mContact?.mobileNumber}`
                    : `${mContact?.mobileNumber}`
              }
              contactDetails.push(mContact)
            } else {
              contactDetails = data?.entity?.contactDetails
            }
          }
        })
      } else if (
        self.onboarding.entityDetails &&
        self?.onboarding?.entityDetails?.contactDetails &&
        type === EmType.createSingleEntity
      ) {
        contactDetails = self?.onboarding?.entityDetails?.contactDetails
      } else if (
        (type === EmType.createGroup || type === EmType.createSingleEntity) &&
        self.onboarding.contactProfiles?.length > 0
      ) {
        contactDetails = self?.onboarding?.contactProfiles
      }
      return contactDetails
    },
    getEntitySettlementDetails(entityId: string, type: string) {
      let settlementDetails
      if (entityId && self.onboarding.searchEntity.length > 0 && type !== EmType.createSingleEntity) {
        self.onboarding.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            settlementDetails = data?.entity?.settlementDetails
            settlementDetails.dailyTransactionValue = data?.entity?.businessProfile?.dailyTransactionValue
          }
        })
      } else if (self.onboarding.entityDetails && type === EmType.createSingleEntity) {
        settlementDetails = self.onboarding.entityDetails.settlementDetails
        settlementDetails.dailyTransactionValue =
          self?.onboarding?.entityDetails?.businessProfile?.dailyTransactionValue
      }
      return settlementDetails
    },
    getDocumentsList: flow(function* getViewDocument(
      entityId: string,
      isAadharRedaction: boolean = false,
      isNonEditedList: boolean = false,
      type: string,
    ) {
      try {
        self.documents = JSON.parse(JSON.stringify([]))
        const response = yield getViewDocumentListRequest(
          entityId,
          self.session.getTokens,
          self.onboarding.searchFilterBy === 'SubGroup ID' ? '' : type,
        )
        if (isAadharRedaction) {
          self.aadharRedactiondocuments = response?.jdmsDocs
          self.aadharOriginalList = response?.jdmsDocs
          if (isNonEditedList) {
            self.aadharNonEditedRedactiondocuments = response?.jdmsDocs
          }
        } else {
          self.documents =
            type === EmType.Search && type?.length > 0 && self.onboarding.searchFilterBy !== 'SubGroup ID'
              ? response?.documents
              : response?.jdmsDocs
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    kycDocumentDownloadFetch: flow(function* kycDocumentDownloadFetch(
      uploadId: string,
      documentId: string,
      uploadType: string,
      fileName: string,
    ) {
      try {
        const resp = yield kycDocumentDownload(uploadId, documentId, self.session.getTokens, uploadType)
        try {
          if (resp?.error && resp?.error?.length > 0) {
            RootStore.message.setMessage('File not available to view/download', 'NEGATIVE')
            return 'failed'
          }
        } catch (e) {}

        const type =
          fileName?.includes('png') || fileName?.includes('PNG')
            ? 'image/png'
            : fileName?.includes('jpg') ||
              fileName?.includes('JPG') ||
              fileName?.includes('jpeg') ||
              fileName?.includes('JPEG')
            ? 'image/jpeg'
            : fileName?.includes('pdf') || fileName?.includes('PDF')
            ? 'application/pdf'
            : 'image/png'
        const blob = new Blob([resp], { type: type })
        if (blob.size === 0) {
          RootStore.message.setMessage('File not available to view/download', 'NEGATIVE')
          return 'failed'
        }
        const url = window.URL.createObjectURL(blob)
        return url
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    downloadKycImage: flow(function* getImage(id: string, document: any, docType: string = '') {
      try {
        const resp = yield getDocumentImageRequest(id, document?.MERCHANT_DOCUMENT_TYPE, self.session.getTokens)

        if (resp?.error && resp?.error?.length > 0) {
          RootStore.message.setMessage('File not available to view/download', 'NEGATIVE')
          return 'failed'
        }
        // const fileInfo = resp.headers['content-disposition']
        const type =
          docType !== ''
            ? document?.NAME?.includes('png') || document?.NAME?.includes('PNG')
              ? 'image/png'
              : document?.NAME?.includes('jpg') ||
                document?.NAME?.includes('JPG') ||
                document?.NAME?.includes('jpeg') ||
                document?.NAME?.includes('JPEG')
              ? 'image/jpeg'
              : document?.NAME?.includes('pdf') || document?.NAME?.includes('PDF')
              ? 'application/pdf'
              : 'image/png'
            : docType
        // let contentType = resp.headers['content-type']
        //check for undefined file download on session expire
        // if (mimeTypes.get(contentType) === undefined) {
        //   return
        // }
        // let fileInfo = resp.headers['content-disposition']
        const blob = new Blob([resp], { type: type })
        if (blob.size === 0) {
          RootStore.message.setMessage('File not available to view/download', 'NEGATIVE')
          return 'failed'
        }
        const url = window.URL.createObjectURL(blob)
        return url
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    addDocument(document: any) {
      self.documents = JSON.parse(JSON.stringify([...self.documents, document]))
    },
    deleteDocument(document: any) {
      const index = self.documents.indexOf(document)
      if (index !== -1) {
        self.documents.splice(index, 1)
      }
    },
    deleteKycDoc: flow(function* deleteKycDoc(
      uploadId: string,
      documentId: string,
      uploadType: string,
      docType: string,
    ) {
      try {
        const response = yield kycDeleteDocument(uploadId, documentId, uploadType, self.session.getTokens)
        if (response === 'SUCCESS') {
          self.aadharRedactiondocuments.map((doc) => {
            if (doc?.DOCID === documentId) {
              const orgDoc = self.aadharOriginalList.filter((org) => org?.MERCHANT_DOCUMENT_TYPE === docType)?.[0]
              doc.action = null
              doc.DOCUMENTSTATUS = orgDoc?.DOCUMENTSTATUS
              doc.DOCID = orgDoc?.DOCID
              return doc
            }
            return doc
          })
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    setFileUploaded(isUploaded: boolean) {
      self.bulkEntity.fileUploaded = isUploaded
    },
    getUpdatedEntityContactProfile(entityId: string) {
      let contactDetails: any[] = []
      if (entityId && self.onboarding.searchEntity.length > 0) {
        self.onboarding.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            data?.entity?.contactDetails?.map((contact) => {
              if (
                contact?.entityContactAddress?.addressLine1?.length >= 0 ||
                contact?.entityContactAddress?.addressLine2?.length >= 0 ||
                contact?.entityContactAddress?.city?.length >= 0 ||
                contact?.entityContactAddress?.state?.length >= 0 ||
                contact?.entityContactAddress?.pincode?.length >= 0
              ) {
                let entityContactAddress = {
                  addressLine1: contact?.entityContactAddress?.addressLine1,
                  addressLine2: contact?.entityContactAddress?.addressLine2,
                  city: contact?.entityContactAddress?.city,
                  state: contact?.entityContactAddress?.state,
                  pincode: contact?.entityContactAddress?.pincode,
                }
                contact.entityContactAddress = JSON.parse(JSON.stringify(entityContactAddress))
              }
              if (contact?.dob === 'NA') {
                contact.dob = null
              }
              return contact
            })
            contactDetails = data?.entity?.contactDetails
          }
        })
      }
      return contactDetails
    },
    resetCheckerApplicationStatus() {
      self.checkerApplicationStatus = JSON.parse(JSON.stringify({}))
    },
    updateEntityContactAddressProfile(entityId: string, updatedEntityContactAddress: any, contactId: number) {
      if (entityId && self.onboarding.searchEntity.length > 0) {
        self.onboarding.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            data?.entity?.contactDetails?.map((contact) => {
              if (contactId === contact.id) {
                contact.entityContactAddress = updatedEntityContactAddress
              }
              return contact
            })
            return data
          }
          return data
        })
      }
    },
    resetApiConfigSaveCallDone() {
      self.isApiConfigSaveCallDone = false
    },
    resetGlobalSearchString() {
      self.onboarding.globalSearchString = ''
    },
    setSideMenuRefresh(isRefresh: boolean) {
      self.forceSideMenuRefresh = isRefresh
    },
    getUploadedFileHistory: flow(function* getUploadedFileHistory(type: string, size: number) {
      try {
        self.bulkEntity.files = JSON.parse(JSON.stringify([]))
        const response = yield uploadedFileHistory(
          RootStore.session.getTokens,
          type,
          self.pagination.number,
          size,
          self.selectedDateInfo,
        )
        self.bulkEntity.files = response?.response?.data?.content
        self.pagination = JSON.parse(JSON.stringify(response?.page))
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    bulkOnboardingDeleteReq: flow(function* bulkOnboardingDeleteReq(fileId: number, type: string) {
      try {
        const response = yield bulkOnboardingDeleteFile(fileId, type, self.session.getTokens)
        if (response?.filename && response?.filename?.length > 0) {
          RootStore.message.setMessage('File deleted successfully', MessageTypes.SUCCESS)
        } else {
          RootStore.message.setMessage('Error while deleting file', MessageTypes.ERROR)
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    bulkOnboardfileUpload: flow(function* bulkOnboardfileUpload(file: any, type: string) {
      try {
        self.bulkEntity.fileUploaded = false
        const resp = yield bulkOnboardingFileUpload(file, type, RootStore.session.getTokens)
        if (resp?.data?.status === 'UPLOADED') {
          self.bulkEntity.uploadedFile = resp?.data
          self.bulkEntity.uploadedFile.id = resp?.data?.id
        }
        let errorCode = ''
        try {
          errorCode = resp?.data?.error?.code ?? ''
          if (errorCode === '33607' || errorCode === '33306') {
            if (errorCode === '33607') {
              extendUserSessionAPI().then((response) => {
                console.log('extendUserSessionAPI response', response)
                return (self as any).bulkOnboardfileUpload(file, type)
              })
            } else {
              extendAppSessionAPI().then((response) => {
                console.log('extendAppSessionAPI response', response)
                return (self as any).bulkOnboardfileUpload(file, type)
              })
            }
          }
        } catch (err) {
          console.log(err)
        }
        if (errorCode === '') {
          self.bulkEntity.fileUploaded = true
          RootStore.message.setMessage(resp?.message ?? 'File Upload Success', MessageTypes.SUCCESS)
        } else {
          if (errorCode !== '33607' && errorCode !== '33306') {
            RootStore.message.setMessage(resp?.data?.error?.message, MessageTypes.ERROR)
          }
        }
        return resp
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getRiskSettingsLimitsData(configType: string) {
      let dataList: any[] = []
      if (self.onboarding.entityDetails.riskSettings && self.onboarding.entityDetails.riskSettings.length > 0) {
        const dataArr = self.onboarding.entityDetails.riskSettings.filter((risk) => risk.configType === configType)
        const initKey = configType === 'OPEN_LOOP_RISK' ? 'OPEN_LOOP_' : 'CLOSE_LOOP_'

        if (dataArr.length > 0) {
          let currentValue = ''
          let previousValue = ''
          let olderValue = ''
          let recruitmentValue = ''

          if (dataArr.filter((data) => data.key.endsWith('TRANSACTION_LIMIT')).length > 0) {
            dataArr
              .filter((data) => data.key.endsWith('TRANSACTION_LIMIT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_TRANSACTION_LIMIT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_TRANSACTION_LIMIT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_TRANSACTION_LIMIT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_TRANSACTION_LIMIT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          if (dataArr.filter((data) => data.key.endsWith('EXIT_LIMIT')).length > 0) {
            dataArr
              .filter((data) => data.key.endsWith('EXIT_LIMIT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_EXIT_LIMIT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_EXIT_LIMIT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_EXIT_LIMIT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_EXIT_LIMIT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          if (dataArr.filter((data) => data.key.endsWith('TRANSACTION_COUNT')).length > 0) {
            dataArr
              .filter((data) => data.key.endsWith('TRANSACTION_COUNT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_TRANSACTION_COUNT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_TRANSACTION_COUNT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_TRANSACTION_COUNT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_TRANSACTION_COUNT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          if (dataArr.filter((data) => data.key.endsWith('RISK_SCORE')).length > 0) {
            dataArr
              .filter((data) => data.key.endsWith('RISK_SCORE'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_RISK_SCORE`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_RISK_SCORE`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_RISK_SCORE`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_RISK_SCORE`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }
        }
      }
      console.log('getRiskSettingsLimitsData', dataList)
      return dataList
    },
    // getRiskSettingsData(configType: string, key: string) {
    //   if (self.onboarding.entityDetails.riskSettings && self.onboarding.entityDetails.riskSettings.length > 0) {
    //     for (let i = 0; i < self.onboarding.entityDetails.riskSettings.length; i++) {
    //       const data = self.onboarding.entityDetails.riskSettings[i]
    //       if (data.configType === configType && key === data.key) {
    //         return data.value !== null && data.value !== undefined ? data.value : 'NA'
    //       }
    //     }
    //   }
    //   return 'NA'
    // },
    fetchMdrPackageDetails: flow(function* fetchMdrPackageDetails(feePkgId: string) {
      try {
        const response = yield getMdrDetails(feePkgId, self.session.getTokens)
        return response
      } catch (error) {
        RootStore.message.setMessage(error?.data?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    getRiskSettingsLimitsData(configType: string) {
      let dataList: any[] = []
      if (
        self.onboarding.entityDetails.riskSettings &&
        self.onboarding.entityDetails.riskSettings.configurations.length > 0
      ) {
        const configTypeDataArr = self.onboarding.entityDetails.riskSettings.configurations.filter(
          (risk) => risk.configType === configType,
        )

        const otherRiskSettingsDataArr = self.onboarding.entityDetails.riskSettings.configurations.filter(
          (risk) => risk.configType === 'RISK_SETTING',
        )?.[0]?.configValues

        const initKey = configType === 'OPEN_LOOP_RISK' ? 'OPEN_LOOP_' : 'CLOSE_LOOP_'

        if (configTypeDataArr.length > 0) {
          let currentValue = ''
          let previousValue = ''
          let olderValue = ''
          let recruitmentValue = ''

          const configValues = configTypeDataArr[0].configValues
          if (configValues.filter((data) => data.key.endsWith('TRANSACTION_LIMIT')).length > 0) {
            configValues
              .filter((data) => data.key.endsWith('TRANSACTION_LIMIT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_TRANSACTION_LIMIT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_TRANSACTION_LIMIT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_TRANSACTION_LIMIT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_TRANSACTION_LIMIT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          if (configValues.filter((data) => data.key.endsWith('EXIT_LIMIT')).length > 0) {
            configValues
              .filter((data) => data.key.endsWith('EXIT_LIMIT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_EXIT_LIMIT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_EXIT_LIMIT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_EXIT_LIMIT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_EXIT_LIMIT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          if (configValues.filter((data) => data.key.endsWith('TRANSACTION_COUNT')).length > 0) {
            configValues
              .filter((data) => data.key.endsWith('TRANSACTION_COUNT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_TRANSACTION_COUNT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_TRANSACTION_COUNT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_TRANSACTION_COUNT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_TRANSACTION_COUNT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          const otherRiskScoreSettings = otherRiskSettingsDataArr.filter((data) => data.key.endsWith('RISK_SCORE'))
          if (otherRiskScoreSettings?.length > 0) {
            otherRiskScoreSettings.map((data) => {
              if (data.key === 'CURRENT_RISK_SCORE') {
                currentValue = data.value
              }

              if (data.key === 'PREVIOUS_RISK_SCORE') {
                previousValue = data.value
              }

              if (data.key === 'OLDER_RISK_SCORE') {
                olderValue = data.value
              }

              if (data.key === 'RECRUITMENT_RISK_SCORE') {
                recruitmentValue = data.value
              }
            })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }
        }
      }
      console.log('getRiskSettingsLimitsData', dataList)
      return dataList
    },
    getRiskSettingsData(configType: string, key: string) {
      if (
        self.onboarding.entityDetails.riskSettings &&
        self.onboarding.entityDetails.riskSettings.configurations.length > 0
      ) {
        for (let i = 0; i < self.onboarding.entityDetails.riskSettings.configurations.length; i++) {
          const data = self.onboarding.entityDetails.riskSettings.configurations[i]
          if (data.configType === configType) {
            for (let j = 0; j < data.configValues.length; j++) {
              if (key === data.configValues[j].key) {
                return data.configValues[j].value !== null && data.configValues[j].value !== undefined
                  ? data.configValues[j].value
                  : 'NA'
              }
            }
          }
        }
      }
      return 'NA'
    },
    getMasRiskSettingsLimitsData(entityId: string, configType: string) {
      let dataList: any[] = []
      if (self.onboarding.configurations && self.onboarding.configurations?.length > 0) {
        const configTypeDataArr = self.onboarding.configurations.filter((risk) => risk.configType === configType)

        const otherRiskSettingsDataArr = self.onboarding.configurations.filter(
          (risk) => risk.configType === 'RISK_SETTING',
        )

        const initKey = configType === 'OPEN_LOOP_RISK' ? 'OPEN_LOOP_' : 'CLOSE_LOOP_'

        if (configTypeDataArr.length > 0) {
          let currentValue = ''
          let previousValue = ''
          let olderValue = ''
          let recruitmentValue = ''

          const configValues = configTypeDataArr
          if (configValues.filter((data) => data.key.endsWith('TRANSACTION_LIMIT')).length > 0) {
            configValues
              .filter((data) => data.key.endsWith('TRANSACTION_LIMIT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_TRANSACTION_LIMIT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_TRANSACTION_LIMIT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_TRANSACTION_LIMIT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_TRANSACTION_LIMIT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          if (configValues.filter((data) => data.key.endsWith('EXIT_LIMIT')).length > 0) {
            configValues
              .filter((data) => data.key.endsWith('EXIT_LIMIT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_EXIT_LIMIT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_EXIT_LIMIT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_EXIT_LIMIT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_EXIT_LIMIT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          if (configValues.filter((data) => data.key.endsWith('TRANSACTION_COUNT')).length > 0) {
            configValues
              .filter((data) => data.key.endsWith('TRANSACTION_COUNT'))
              .map((data) => {
                if (data.key === `${initKey}CURRENT_TRANSACTION_COUNT`) {
                  currentValue = data.value
                }

                if (data.key === `${initKey}PREVIOUS_TRANSACTION_COUNT`) {
                  previousValue = data.value
                }

                if (data.key === `${initKey}OLDER_TRANSACTION_COUNT`) {
                  olderValue = data.value
                }

                if (data.key === `${initKey}RECRUITMENT_TRANSACTION_COUNT`) {
                  recruitmentValue = data.value
                }
              })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }

          const otherRiskScoreSettings = otherRiskSettingsDataArr.filter((data) => data.key.endsWith('RISK_SCORE'))
          if (otherRiskScoreSettings?.length > 0) {
            otherRiskScoreSettings.map((data) => {
              if (data.key === 'CURRENT_RISK_SCORE') {
                currentValue = data.value
              }

              if (data.key === 'PREVIOUS_RISK_SCORE') {
                previousValue = data.value
              }

              if (data.key === 'OLDER_RISK_SCORE') {
                olderValue = data.value
              }

              if (data.key === 'RECRUITMENT_RISK_SCORE') {
                recruitmentValue = data.value
              }
            })

            dataList.push({
              current: currentValue,
              previous: previousValue,
              older: olderValue,
              recruitment: recruitmentValue,
            })
          }
        }
      }
      console.log('getMasRiskSettingsLimitsData', dataList)
      return dataList
    },
    getMasEntityRiskSettingsData(entityId: string, configType: string, key: string) {
      if (self.onboarding?.configurations && self.onboarding?.configurations?.length > 0) {
        for (let i = 0; i < self.onboarding?.configurations?.length; i++) {
          const data = self.onboarding?.configurations[i]
          if (data?.configType === configType) {
            if (data?.key === key) {
              return data?.value !== null && data?.value !== undefined
                ? data?.value === 'N'
                  ? 'No'
                  : data?.value === 'Y'
                  ? 'Yes'
                  : data?.value
                : 'NA'
            }
          }
        }
      }
      return 'NA'
    },
    getUpdatedColumnHeaderArray() {
      let checkedHeaderArr: any[] = [
        { name: 'Domestic', isSelected: false },
        { name: 'International', isSelected: false },
        { name: 'Platinum', isSelected: false },
      ]
      let domestic = 0
      let international = 0
      let platinum = 0
      const selectedCardsList = self.onboarding.cardList.filter(
        (card) => card.type === self.onboarding.merchant.preferences.selectedCardTypeId,
      )
      selectedCardsList.map((card) => {
        if (card.isDomesticAllowed) {
          domestic++
        }
        if (card.isInternationalAllowed) {
          international++
        }
        if (card.isPremium) {
          platinum++
        }
      })
      if (domestic === selectedCardsList.length) {
        let foundIndex = checkedHeaderArr.findIndex((header) => header.name === 'Domestic')
        checkedHeaderArr[foundIndex] = { name: 'Domestic', isSelected: true }
      }
      if (international === selectedCardsList.length) {
        let foundIndex = checkedHeaderArr.findIndex((header) => header.name === 'International')
        checkedHeaderArr[foundIndex] = { name: 'International', isSelected: true }
      }
      if (platinum === selectedCardsList.length) {
        let foundIndex = checkedHeaderArr.findIndex((header) => header.name === 'Platinum')
        checkedHeaderArr[foundIndex] = { name: 'Platinum', isSelected: true }
      }
      return checkedHeaderArr
    },
    cardsSelectDeselectAll(isAllSelected: boolean, cardType: string) {
      self.onboarding.cardList
        .filter((card) => card.type === getCardIdFromName(cardType))
        .map((card) => {
          card.isDomesticAllowed = isAllSelected
          card.isInternationalAllowed = isAllSelected
          card.isPremium = isAllSelected
          card.isSelected = isAllSelected
          return card
        })
      self.onboarding.hasCardsChanged = true
    },
    cardsColumnSelectionChange(columnName: string, isSelected: boolean) {
      self.onboarding.cardList
        .filter((card) => card.type === self.onboarding.merchant.preferences.selectedCardTypeId)
        .map((card) => {
          if (columnName === 'Domestic') {
            card.isDomesticAllowed = isSelected
          }
          if (columnName === 'International') {
            card.isInternationalAllowed = isSelected
          }
          if (columnName === 'Platinum') {
            card.isPremium = isSelected
          }
          return card
        })
      self.onboarding.hasCardsChanged = true
    },
    cardsRowsSelectionChange(cardType: string, cardScheme: string, rowItem: any, isSelected: boolean) {
      self.onboarding.cardList
        .filter((card) => card.type === cardType)
        .map((card) => {
          if (card.scheme === cardScheme) {
            card.isSelected = isSelected
            card.isDomesticAllowed = isSelected
            card.isInternationalAllowed = isSelected
            card.isPremium = isSelected
            return card
          }
        })
      self.onboarding.hasCardsChanged = true
    },
    cardsIndividualCheckChange(cardType: string, cardScheme: string, item: any, isSelected: boolean) {
      self.onboarding.cardList
        .filter((card) => card.type === cardType)
        .map((card) => {
          if (card.type === item.type && card.scheme === item.scheme) {
            if (cardScheme === 'Domestic') {
              card.isDomesticAllowed = isSelected
            }
            if (cardScheme === 'International') {
              card.isInternationalAllowed = isSelected
            }
            if (cardScheme === 'Platinum') {
              card.isPremium = isSelected
            }
          }
          if (card.isSelected) {
            if (!card.isDomesticAllowed || !card.isInternationalAllowed || !card.isPremium) {
              card.isSelected = false
            }
          } else {
            if (card.isDomesticAllowed && card.isInternationalAllowed && card.isPremium) {
              card.isSelected = true
            }
          }
          return card
        })
      self.onboarding.hasCardsChanged = true
    },
    signIn: flow(function* signIn(username: string, password: string) {
      try {
        const response = yield login(username, password)
        console.log('login res', { response })
        const own = self
        own.user.token = response?.token
        own.user.expiresAt = response?.expireAt
        localStorage.setItem('token', response?.token)
        localStorage.setItem('expiresAt', response?.expireAt)

        const menuResponse = yield menuInfo(true, response?.token)
        console.log({ menuResponse })

        own.user.id = menuResponse?.id
        own.user.name = menuResponse?.name
        own.user.accessConfig = JSON.stringify(menuResponse?.accessConfig)
        own.user.group = JSON.stringify(menuResponse?.group)
        localStorage.setItem('accessConfig', JSON.stringify(menuResponse?.accessConfig))
        localStorage.setItem('group', JSON.stringify(menuResponse?.group))
        localStorage.setItem('name', menuResponse?.name)
        localStorage.setItem('id', menuResponse?.id)
        // RootStore.message.setMessage('login successfull', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    logout: flow(function* logout() {
      try {
        const response = yield logoutCall()
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    sampleFileDownload: flow(function* (filename: string) {
      try {
        const resp = yield sampleFileDownload(filename, self.session.getTokens)
        let errorObj
        try {
          if (resp?.data?.byteLength <= 100) {
            errorObj = JSON.parse(new TextDecoder('utf-8').decode(resp?.data))
          }
        } catch (e) {}
        if (errorObj) {
          throw errorObj
        }
        let contentType = resp.headers['content-type']
        //check for undefined file download on session expire
        if (mimeTypes.get(contentType) === undefined) {
          return
        }
        let fileInfo = resp.headers['content-disposition']
        const fileName = fileInfo?.slice(fileInfo.indexOf('=') + 1) ?? 'file'
        const blob = new Blob([resp?.data], {
          type: contentType,
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = fileName + `${mimeTypes.get(contentType)}`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
    }),
    exportByJobIdAsync: flow(function* (reqObject: any, getAbortController: any) {
      try {
        const { jobId } = yield getJobIdForExportApi(reqObject, getAbortController()?.abortController)
        yield delay(5000)
        const response = yield (self as any).getExportByJobIdProgress(jobId, 1, getAbortController)
        if (response?.abortRecursive) {
          return
        }
        console.log('htag status resp', response)
        const resp = yield downloadFileUsingJobId(jobId, getAbortController()?.abortController)
        let errorObj
        try {
          if (resp?.data?.byteLength <= 100) {
            errorObj = JSON.parse(new TextDecoder('utf-8').decode(resp?.data))
          }
        } catch (e) {}
        if (errorObj) {
          throw errorObj
        }
        let contentType = resp.headers['content-type']
        //check for undefined file download on session expire
        if (mimeTypes.get(contentType) === undefined) {
          return
        }
        let fileInfo = resp.headers['content-disposition']
        const fileName =
          fileInfo?.slice(fileInfo.indexOf('=') + 1) ?? reqObject?.jobType + '_' + formatDate(new Date().getTime())
        const blob = new Blob([resp?.data], {
          type: contentType,
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = fileName + `${mimeTypes.get(contentType)}`
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getExportByJobIdProgress: flow(function* (jobId: string, noOfTimes = 0, getAbortController: any) {
      try {
        const { abortController, abortRecursive } = getAbortController()
        if (abortRecursive) {
          return { abortRecursive }
        } else if (noOfTimes <= 1000) {
          const response = yield getExportByJobIdProgressApi(jobId, abortController)
          console.log('getExportByJobIdProgressApi', response)
          if (response?.status === 'SUCCESS') {
            return response
          } else if (response?.status === 'FAILED') {
            throw { message: 'An error has occoured , while downloading File' }
          } else {
            yield delay(5000)
            return yield (self as any).getExportByJobIdProgress(jobId, noOfTimes + 1, getAbortController)
          }
        } else {
          throw { message: 'An error has occoured , while downloading File' }
        }
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getGenericMakerCheckerList: flow(function* getGenericMakerCheckerList(apiCallAsync: any, data: any) {
      try {
        const response = yield apiCallAsync(data)
        RootStore.setPagination(response?.pagination)
        return response?.data
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getInsturmentsApi: flow(function* getInstrumentsApi(instrumentType?: number) {
      try {
        const response = yield getInstrumentsNew(self.session.getTokens, instrumentType)
        if (response.length === 0) {
          const customError = {
            error: instrumentType === PAYMENT_MODE_SUBTYPES.WALLET ? 'No Wallets' : 'No Banks',
          }
          throw customError
        }
        if (instrumentType === PAYMENT_MODE_SUBTYPES.WALLET) {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            walletList: response,
          }
        } else if (instrumentType === PAYMENT_MODE_SUBTYPES.PAYLATER) {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            payLaterList: response,
          }
        } else if (instrumentType === PAYMENT_MODE_SUBTYPES.FOOD_CARD) {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            foodCardList: response,
          }
        } else {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            bankList: response,
          }
        }
      } catch (error) {
        const customError = {
          message: error?.message ?? 'Oops!! Something went wrong.',
        }
        const TOKEN_EXPIRY_CODE = '33708'
        if (error?.code === TOKEN_EXPIRY_CODE) {
          self.message.setMessage(customError.message, MessageTypes.ERROR, error?.code)
        }
        throw customError
      }
    }),
    getInstrumentsList(type: number, searchKey: string = '') {
      if (type === PAYMENT_MODE_SUBTYPES.PAYLATER) {
        const payLaterList = self.onboarding.merchant.preferences.payLaterList.toJSON()?.map((item: PayLaterType) => {
          return {
            id: item.id,
            text: item.name,
            imageUrl: item.logo,
            inputData: item.inputData,
            isSelected: item.isSelected,
            type: item.type,
          }
        })
        if (payLaterList.length === 0) {
          return []
        } else {
          const filter = payLaterList
            // .map((item: any) => {
            //   const inputData = item?.inputData ?? []
            //   const validationData = inputData.filter((item: any) => item.usage === 'validation')
            //   if (validationData.length > 0) {
            //     const amount = '0'
            //     const valResult = validationData
            //       .map((itemData: any) => {
            //         return {
            //           validation: eval(`${amount} ${itemData.validationPattern} ${itemData.labelString}`),
            //         }
            //       })
            //       .filter((item: any) => item.validation === false)
            //     if (valResult.length === 0) {
            //       return item
            //     }
            //   }
            // })
            .filter((item: any) => item !== undefined)
          const payList = filter
            .sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
            .filter((item) => +item.type === type)
          return payList
        }
      } else if (type === PAYMENT_MODE_SUBTYPES.WALLET) {
        const walletsRetData: any = []
        const walletList = self.onboarding.merchant.preferences.walletList
          .toJSON()
          ?.map((item: WalletType) => {
            return {
              id: item.id,
              text: item.name,
              imageUrl: item.logo,
              isPopular: item.isPopular,
              rank: item.rank,
              isSelected: item.isSelected,
              type: item.type,
            }
          })
          .filter((item) => +item.type === type)

        if (walletList.length === 0) {
          return []
        }

        if (self.onboarding.merchant.allowedPaymentModes?.length > 0) {
          const [walletPaymentMode]: any = self.onboarding.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.WALLET
          })
          if (walletPaymentMode && walletPaymentMode?.id?.length > 0) {
            const filterWalletList = walletList.filter((item: any) => {
              return walletPaymentMode?.id.includes(Number(item.id))
            })
            const others = filterWalletList.map((item: any) => {
              return {
                id: item.id,
                text: item.text,
                imageUrl: item?.imageUrl || '',
                isSelected: item.isSelected,
                type: item.type,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              walletsRetData.push({
                title: 'Other Wallets',
                data: others,
              })
              return walletsRetData
            }
          }
        } else if (self.onboarding.merchant.notAllowedPaymentModes?.length > 0) {
          const [walletPaymentMode]: any = self.onboarding.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.WALLET
          })
          if (walletPaymentMode && walletPaymentMode?.id?.length > 0) {
            const filterWalletList = walletList.filter((item: any) => {
              return !walletPaymentMode?.id.includes(Number(item.id))
            })

            const popular = filterWalletList
              ?.filter((item: any) => item.isPopular)
              .sort((a: any, b: any) => (a.rank > b.rank ? 1 : -1))
            if (popular.length !== 0) {
              walletsRetData.push({
                title: 'Popular Wallets',
                data: popular,
              })
            }

            const others = filterWalletList
              .map((item: any) => {
                return {
                  id: item.id,
                  text: item.text,
                  imageUrl: item?.imageUrl || '',
                  isSelected: item.isSelected,
                  type: item.type,
                }
              })
              .filter((item) => item.type === type)
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              walletsRetData.push({
                title: 'Other Wallets',
                data: others,
              })
              return walletsRetData
            }
          }
        }
        const popular = walletList
          ?.filter((item: any) => item.isPopular)
          .sort((a: any, b: any) => (a.rank > b.rank ? 1 : -1))
        if (popular.length !== 0) {
          walletsRetData.push({
            title: 'Popular Wallets',
            data: popular,
          })
        }
        const others = walletList.map((item: any) => {
          return {
            id: item.id,
            text: item.text,
            imageUrl: item?.imageUrl || '',
            isSelected: item.isSelected,
            type: item.type,
          }
        })

        if (others.length !== 0) {
          others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
          walletsRetData.push({
            title: 'Other Wallets',
            data: others,
          })
        }

        return walletList //walletsRetData //TODO: CHECk
      } else if (type === PAYMENT_MODE_SUBTYPES.FOOD_CARD) {
        const retData: any = []
        const foodCardList = self.onboarding.merchant.preferences?.foodCardList
        if (foodCardList.length === 0) {
          return []
        }
        const getShortName: any = {
          'Punjab National Bank - Retail': 'PNB Bank',
          'Axis Bank - Retail': 'Axis Bank',
          'Yes Bank - Retail': 'YES Bank',
          'ICICI Bank - Retail': 'ICICI Bank',
          'State Bank of India': 'SBI Bank',
          'HDFC Bank - Retail': 'HDFC Bank',
          'Kotak Bank': 'Kotak Bank',
        }

        if (self.onboarding.merchant.allowedPaymentModes?.length > 0) {
          const [foodCardPaymentMode]: any = self.onboarding.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.FOOD_CARD
          })
          if (foodCardPaymentMode && foodCardPaymentMode?.id?.length > 0) {
            const filterFoodCardList = foodCardList.filter((item: any) => {
              return foodCardPaymentMode?.id.includes(Number(item.id))
            })
            const others = filterFoodCardList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        } else if (self.onboarding.merchant.notAllowedPaymentModes?.length > 0) {
          const [foodCardPaymentMode]: any = self.onboarding.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.FOOD_CARD
          })
          if (foodCardPaymentMode && foodCardPaymentMode?.id?.length > 0) {
            const filterFoodCardList = foodCardList.filter((item: any) => {
              return !foodCardPaymentMode?.id.includes(Number(item.id))
            })
            const popular = filterFoodCardList
              .filter((item) => item.isPopular)
              .map((item: BankType) => ({
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }))
              .sort((a, b) => (a.rank > b.rank ? 1 : -1))

            if (popular.length !== 0) {
              retData.push({
                title: 'Popular banks',
                data: popular,
              })
            }
            const others = filterFoodCardList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        }

        const popular = foodCardList
          .toJSON()
          .filter((item) => item.isPopular)
          .map((item: BankType) => ({
            id: item.id,
            text: getShortName[item.name] ?? item.name,
            imageUrl: item.logo,
            position: getImageLocation(item.id),
            rank: item.rank,
          }))
          .sort((a, b) => (a.rank > b.rank ? 1 : -1))
        if (popular.length !== 0) {
          retData.push({
            title: 'Popular banks',
            data: popular,
          })
        }
        const others = foodCardList
          .toJSON()
          .map((item: BankType) => {
            return {
              id: item.id,
              text: item.name,
              imageUrl: item?.logo || '',
              position: getImageLocation(item.id),
              type: item.type,
            }
          })
          .filter((item) => +item.type === type)

        if (others.length !== 0) {
          others.sort((a, b) => a.text.localeCompare(b.text))
          retData.push({
            title: 'Other banks',
            data: others,
          })
        }
        return retData
      } else {
        const retData: any = []
        const bankList =
          searchKey.length === 0
            ? self.onboarding.merchant.preferences?.bankList
            : self.onboarding.merchant.preferences?.bankList.filter((bank) =>
                bank.name.toLowerCase().includes(searchKey.toLowerCase()),
              )

        if (bankList.length === 0) {
          return []
        }

        const getShortName: any = {
          'Punjab National Bank - Retail': 'PNB Bank',
          'Axis Bank - Retail': 'Axis Bank',
          'Yes Bank - Retail': 'YES Bank',
          'ICICI Bank - Retail': 'ICICI Bank',
          'State Bank of India': 'SBI Bank',
          'HDFC Bank - Retail': 'HDFC Bank',
          'Kotak Bank': 'Kotak Bank',
        }

        if (self.onboarding.merchant.allowedPaymentModes?.length > 0) {
          const [netBankingPaymentMode]: any = self.onboarding.merchant.allowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB
          })
          if (netBankingPaymentMode && netBankingPaymentMode?.id?.length > 0) {
            const filterBankList = bankList.filter((item: any) => {
              return netBankingPaymentMode?.id.includes(Number(item.id))
            })
            const others = filterBankList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
                isSelected: item.isSelected,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        } else if (self.onboarding.merchant.notAllowedPaymentModes?.length > 0) {
          const [netBankingPaymentMode]: any = self.onboarding.merchant.notAllowedPaymentModes?.filter((item: any) => {
            return Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB
          })
          if (netBankingPaymentMode && netBankingPaymentMode?.id?.length > 0) {
            const filterBankList = bankList.filter((item: any) => {
              return !netBankingPaymentMode?.id.includes(Number(item.id))
            })
            const popular = filterBankList
              .filter((item) => item.isPopular)
              .map((item: BankType) => ({
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
                isSelected: item.isSelected,
              }))
              .sort((a, b) => (a.rank > b.rank ? 1 : -1))

            if (popular.length !== 0) {
              retData.push({
                title: 'Popular banks',
                data: popular,
              })
            }
            const others = filterBankList.map((item: any) => {
              return {
                id: item.id,
                text: getShortName[item.name] ?? item.name,
                imageUrl: item.logo,
                position: getImageLocation(item.id),
                rank: item.rank,
                isSelected: item.isSelected ?? false,
              }
            })
            if (others.length !== 0) {
              others.sort((a, b) => a.text?.localeCompare(b?.text ?? ''))
              retData.push({
                title: 'Other banks',
                data: others,
              })
              return retData
            }
          }
        }

        const popular = bankList
          .filter((item) => item.isPopular)
          .map((item: BankType) => ({
            id: item.id,
            text: getShortName[item.name] ?? item.name,
            imageUrl: item.logo,
            position: getImageLocation(item.id),
            rank: item.rank,
            isSelected: item.isSelected ?? false,
          }))
          .sort((a, b) => (a.rank > b.rank ? 1 : -1))
        if (popular.length !== 0) {
          retData.push({
            title: 'Popular banks',
            data: popular,
          })
        }
        const others = bankList
          .map((item: BankType) => {
            return {
              id: item.id,
              text: item.name,
              imageUrl: item?.logo || '',
              position: getImageLocation(item.id),
              isSelected: item.isSelected ?? false,
              type: item.type,
            }
          })
          .filter((item) => +item.type === type)

        if (others.length !== 0) {
          others.sort((a, b) => a.text.localeCompare(b.text))
          retData.push({
            title: 'Other banks',
            data: others,
          })
        }
        return others //TODO: retData
      }
    },
    updateSelection(id: string, isSelected: boolean, type: number) {
      if (type === PAYMENT_MODE_SUBTYPES.NB) {
        let selectedBankList: any[] = []
        console.log('updateSelection: b4 =>', new Date().toISOString())
        self.onboarding.merchant.preferences.bankList.map((bank) => {
          if (bank.id === id) {
            bank.isSelected = isSelected
            let updatedBank = {
              ...bank,
              isSelected: isSelected,
            }
            selectedBankList.push(updatedBank)
            if (
              self?.onboarding?.configList?.length > 0 &&
              self?.onboarding?.configList?.filter((conf) => conf.key === 'SUPPORTED_NETBANKING' && conf.value === id)
                .length === 0
            ) {
              self.onboarding.addToConfigList('SUPPORTED_NETBANKING', id, isSelected)
            } else if (self?.onboarding?.configList === null || self?.onboarding?.configList?.length === 0) {
              self.onboarding.addToConfigList('SUPPORTED_NETBANKING', id, isSelected)
            } else {
              self.onboarding.deleteConfigList(
                'SUPPORTED_NETBANKING',
                id,
                getRefIdForPaymentInstruments('SUPPORTED_NETBANKING', id, self.onboarding.configList),
                isSelected,
              )
            }
          } else {
            selectedBankList.push(bank)
          }
        })
        self.onboarding.merchant.preferences.bankList = JSON.parse(JSON.stringify(selectedBankList))
        self.onboarding.isAllBanksSelected =
          self.onboarding.merchant.preferences.bankList.filter((bank) => bank.isSelected).length ===
          self.onboarding.merchant.preferences.bankList.length
        console.log('updateSelection: after =>', new Date().toISOString())
      } else if (type === PAYMENT_MODE_SUBTYPES.WALLET) {
        let selectedWalletist: any[] = []
        self.onboarding.merchant.preferences.walletList.map((wallet) => {
          if (wallet.id === id) {
            wallet.isSelected = isSelected
            let updatedWallet = {
              ...wallet,
              isSelected: isSelected,
            }
            selectedWalletist.push(updatedWallet)

            if (
              self?.onboarding?.configList?.length > 0 &&
              self?.onboarding?.configList?.filter((conf) => conf.key === 'SUPPORTED_WALLET' && conf.value === id)
                .length === 0
            ) {
              self.onboarding.addToConfigList('SUPPORTED_WALLET', id, isSelected)
            } else if (self?.onboarding?.configList === null || self?.onboarding?.configList?.length === 0) {
              self.onboarding.addToConfigList('SUPPORTED_WALLET', id, isSelected)
            } else {
              self.onboarding.deleteConfigList(
                'SUPPORTED_WALLET',
                id,
                getRefIdForPaymentInstruments('SUPPORTED_WALLET', id, self.onboarding.configList),
                isSelected,
              )
            }
          } else {
            selectedWalletist.push(wallet)
          }
        })
        self.onboarding.merchant.preferences.walletList = JSON.parse(JSON.stringify(selectedWalletist))
        self.onboarding.isAllWalletSelected =
          self.onboarding.merchant.preferences.walletList.filter((wallet) => wallet.isSelected).length ===
          self.onboarding.merchant.preferences.walletList.length
      } else if (type === PAYMENT_MODE_SUBTYPES.PAYLATER) {
        let selectedPayLaterList: any[] = []
        self.onboarding.merchant.preferences.payLaterList.map((paylater) => {
          if (paylater.id === id) {
            paylater.isSelected = isSelected

            let updatedPayLater = {
              ...paylater,
              isSelected: isSelected,
            }
            selectedPayLaterList.push(updatedPayLater)

            if (
              self?.onboarding?.configList?.length > 0 &&
              self?.onboarding?.configList?.filter((conf) => conf.key === 'SUPPORTED_PAYLATER' && conf.value === id)
                .length === 0
            ) {
              self.onboarding.addToConfigList('SUPPORTED_PAYLATER', id, isSelected)
            } else if (self?.onboarding?.configList === null || self?.onboarding?.configList?.length === 0) {
              self.onboarding.addToConfigList('SUPPORTED_PAYLATER', id, isSelected)
            } else {
              self.onboarding.deleteConfigList(
                'SUPPORTED_PAYLATER',
                id,
                getRefIdForPaymentInstruments('SUPPORTED_PAYLATER', id, self.onboarding.configList),
                isSelected,
              )
            }
          } else {
            selectedPayLaterList.push(paylater)
          }
        })
        self.onboarding.merchant.preferences.payLaterList = JSON.parse(JSON.stringify(selectedPayLaterList))
        self.onboarding.isAllPayLaterSelected =
          self.onboarding.merchant.preferences.payLaterList.filter((paylater) => paylater.isSelected).length ===
          self.onboarding.merchant.preferences.payLaterList.length
      } else if (type === PAYMENT_MODE_SUBTYPES.CORP_NB) {
        let selectedBankList: any[] = []
        self.onboarding.merchant.preferences.corpBankList.map((bank) => {
          if (bank.id === id) {
            bank.isSelected = isSelected
            let updatedBank = {
              ...bank,
              isSelected: isSelected,
            }
            selectedBankList.push(updatedBank)
            if (
              self?.onboarding?.configList?.length > 0 &&
              self?.onboarding?.configList?.filter(
                (conf) => conf.key === 'SUPPORTED_CORPORATENETBANKING' && conf.value === id,
              ).length === 0
            ) {
              self.onboarding.addToConfigList('SUPPORTED_CORPORATENETBANKING', id, isSelected)
            } else if (self?.onboarding?.configList === null || self?.onboarding?.configList?.length === 0) {
              self.onboarding.addToConfigList('SUPPORTED_CORPORATENETBANKING', id, isSelected)
            } else {
              self.onboarding.deleteConfigList(
                'SUPPORTED_CORPORATENETBANKING',
                id,
                getRefIdForPaymentInstruments('SUPPORTED_CORPORATENETBANKING', id, self.onboarding.configList),
                isSelected,
              )
            }
          } else {
            selectedBankList.push(bank)
          }
        })
        self.onboarding.merchant.preferences.corpBankList = JSON.parse(JSON.stringify(selectedBankList))
        self.onboarding.isAllBanksSelected =
          self.onboarding.merchant.preferences.corpBankList.filter((bank) => bank.isSelected).length ===
          self.onboarding.merchant.preferences.corpBankList.length
      }
    },
    updateAllSelection(isAllSelected: boolean, type: number) {
      if (type === PAYMENT_MODE_SUBTYPES.NB) {
        self.onboarding.isAllBanksSelected = isAllSelected
        self.onboarding.merchant.preferences.bankList.map((bank) => {
          //To add config as its all selection
          if (isAllSelected) {
            //To add only those which is not selected earlier
            if (!bank.isSelected) {
              self.onboarding.addAllToConfigList('SUPPORTED_NETBANKING', bank.id, isAllSelected)
            }
            if (!bank.isSelected) {
              bank.isSelected = isAllSelected
            }
          } else {
            if (self?.onboarding?.configList?.length > 0) {
              self.onboarding.deleteConfigList(
                'SUPPORTED_NETBANKING',
                bank.id,
                getRefIdForPaymentInstruments('SUPPORTED_NETBANKING', bank.id, self.onboarding.configList),
                isAllSelected,
              )
            }
            bank.isSelected = isAllSelected
          }
          return bank
        })
      } else if (type === PAYMENT_MODE_SUBTYPES.WALLET) {
        self.onboarding.isAllWalletSelected = isAllSelected
        self.onboarding.merchant.preferences.walletList.map((wallet) => {
          //To add config as its all selection
          if (isAllSelected) {
            //To add only those which is not selected earlier
            if (!wallet.isSelected) {
              self.onboarding.addAllToConfigList('SUPPORTED_WALLET', wallet.id, isAllSelected)
            }
            if (!wallet.isSelected) {
              wallet.isSelected = isAllSelected
            }
          } else {
            if (self?.onboarding?.configList?.length > 0) {
              self.onboarding.deleteConfigList(
                'SUPPORTED_WALLET',
                wallet.id,
                getRefIdForPaymentInstruments('SUPPORTED_WALLET', wallet.id, self.onboarding.configList),
                isAllSelected,
              )
            }
            wallet.isSelected = isAllSelected
          }
          return wallet
        })
        // isAllBanksSelected: types.optional(types.boolean, false),
        // isAllPayLaterSelected: types.optional(types.boolean, false),
        // isAllWalletSelected: types.optional(types.boolean, false),
      } else if (type === PAYMENT_MODE_SUBTYPES.PAYLATER) {
        self.onboarding.isAllPayLaterSelected = isAllSelected
        self.onboarding.merchant.preferences.payLaterList.map((paylater) => {
          //To add config as its all selection
          if (isAllSelected) {
            //To add only those which is not selected earlier
            if (!paylater.isSelected) {
              self.onboarding.addAllToConfigList('SUPPORTED_PAYLATER', paylater.id, isAllSelected)
            }
            if (!paylater.isSelected) {
              paylater.isSelected = isAllSelected
            }
          } else {
            if (self?.onboarding?.configList?.length > 0) {
              self.onboarding.deleteConfigList(
                'SUPPORTED_PAYLATER',
                paylater.id,
                getRefIdForPaymentInstruments('SUPPORTED_PAYLATER', paylater.id, self.onboarding.configList),
                isAllSelected,
              )
            }
            paylater.isSelected = isAllSelected
          }
          return paylater
        })
      } else if (type === PAYMENT_MODE_SUBTYPES.EMI) {
        // self.onboarding.updateChecked(5, isSelected)
      } else if (type === PAYMENT_MODE_SUBTYPES.CORP_NB) {
        self.onboarding.isAllBanksSelected = isAllSelected
        self.onboarding.merchant.preferences.corpBankList.map((bank) => {
          //To add config as its all selection
          if (isAllSelected) {
            //To add only those which is not selected earlier
            if (!bank.isSelected) {
              self.onboarding.addAllToConfigList('SUPPORTED_CORPORATENETBANKING', bank.id, isAllSelected)
            }
            if (!bank.isSelected) {
              bank.isSelected = isAllSelected
            }
          } else {
            if (self?.onboarding?.configList?.length > 0) {
              self.onboarding.deleteConfigList(
                'SUPPORTED_CORPORATENETBANKING',
                bank.id,
                getRefIdForPaymentInstruments('SUPPORTED_CORPORATENETBANKING', bank.id, self.onboarding.configList),
                isAllSelected,
              )
            }
            bank.isSelected = isAllSelected
          }
          return bank
        })
      }
    },
    setSearchString(searchKey: string) {
      const own = self
      own.onboarding.searchString = searchKey
    },
    fetchApiConfig: flow(function* fetchApiConfig(channelId: string, profileName: string) {
      const own = self
      let response
      try {
        response = yield fetchApisListByChannel(channelId, profileName, RootStore.session.getTokens)
        // console.log('fetchApiConfig response', JSON.parse(JSON.stringify(response)))
        own.apis = JSON.parse(JSON.stringify([...own.apis, ...response]))
        if (checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
          console.log('===> profilesaccesslist includes PCI_MERCHANT so setting all selected')
          self.apis.map((api) => {
            if (api.profileName === 'PCI_MERCHANT') {
              api.isSelected = true
            }
            return api
          })
        }
        if (checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
          console.log('===> profilesaccesslist includes NON_PCI_MERCHANT so setting all selected')
          self.apis.map((api) => {
            if (api.profileName === 'NON_PCI_MERCHANT') {
              api.isSelected = true
            }
            return api
          })
        }
        if (checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
          console.log('===> profilesaccesslist includes EMI so setting all selected')
          self.apis.map((api) => {
            if (api.profileName === 'EMI') {
              api.isSelected = true
            }
            return api
          })
        }
        console.log('fetchApiConfig response', JSON.parse(JSON.stringify(response)))
      } catch (error) {
        console.log('fetchApiConfig error', error)
      }
      return response
    }),
    updateSelectedApiIds(profileName: string, id: string, status: boolean): void {
      // const own = self
      if (self.apis.filter((api) => api.profileName === profileName && api.id === id).length > 0) {
        self.apis.filter((api) => api.profileName === profileName && api.id === id)[0].isSelected = status
      }
      // api.isSelected = status
      console.log('===> api selected id :', id, status)
      let selectedCount = 0

      const profileApis =
        profileName === 'NON_PCI_MERCHANT'
          ? (self as any).getCommonInPciNonPci()
          : profileName === 'OTHERS'
          ? (self as any).getOthersApisList()
          : self.apis.filter((api) => api.profileName === profileName)

      const profileApisLength = profileApis.length

      profileApis.map((profApi) => {
        if (profApi.isSelected) {
          selectedCount++
        }
      })

      if (profileApisLength === selectedCount) {
        if (profileName === 'PCI_MERCHANT') {
          self.onboarding.isAllPciSelected = true
        }
        if (profileName === 'NON_PCI_MERCHANT') {
          self.onboarding.isAllCommonPciNonPciSelected = true
        }
        if (profileName === 'EMI') {
          self.onboarding.isAllEmisSelected = true
        }
        if (profileName === 'OTHERS') {
          self.onboarding.isAllOthersSelected = true
        }
      }

      console.log('===> isAllPciSelected', self.onboarding.isAllPciSelected)
      console.log('===> isAllCommonPciNonPciSelected', self.onboarding.isAllCommonPciNonPciSelected)
      console.log('===> isAllEmisSelected', self.onboarding.isAllEmisSelected)
      console.log('===> isAllOthersSelected', self.onboarding.isAllOthersSelected)

      // own.apis
      //   .filter((api) => api.profileName === 'PCI_MERCHANT' || api.profileName === 'NON_PCI_MERCHANT')
      //   .map((commonApi) => {
      //     console.log('==> commonApi.isSelected', commonApi.isSelected)
      //     self.onboarding.isAllCommonPciNonPciSelected = commonApi.isSelected
      //   })

      // own.apis
      //   .filter((api) => api.profileName === 'EMI')
      //   .map((emiApi) => {
      //     console.log('==> emiApi.isSelected', emiApi.isSelected)
      //     self.onboarding.isAllEmisSelected = emiApi.isSelected
      //   })

      // own.apis
      //   .filter((api) => api.profileName === 'OTHERS')
      //   .map((othersApi) => {
      //     console.log('==> othersApi.isSelected', othersApi.isSelected)
      //     self.onboarding.isAllOthersSelected = othersApi.isSelected
      //   })

      // if (!own.selectedApiIds.includes(id)) {
      //   own.selectedApiIds.push(id)
      // } else {
      //   own.selectedApiIds.remove(id)
      // }
    },
    updateGroupApisStatusByChannelID(profileName: string, status: boolean): void {
      const own = self
      const apisOfChannelId = own.apis
        .filter((api) => api.profileName === profileName)
        .map((api: any) => {
          api.isActive = status
          api.isSelected = status
          return api
        })

      console.log('===> updateGroupApisStatusByChannelID channelId: ', JSON.parse(JSON.stringify(apisOfChannelId)))
    },
    createNewApiMapping: flow(function* createNewApiMapping(
      apiList: any[],
      producerChannelId: string,
      consumerChannelId: string,
    ) {
      console.log('===> createNewApiMapping channel ids: ', producerChannelId, consumerChannelId)
      let response
      try {
        response = yield createApiMappingReq(apiList, producerChannelId, consumerChannelId, RootStore.session.getTokens)
        console.log('createNewApiMapping response: ', response)
        // setToastBgMessageByStatus(response?.status, 'Api Mapping created successfully', response?.error?.message ?? '')
      } catch (error) {
        console.log('error', error)
        if (error?.errorCode === '33714') {
          ;(self as any).updateSelectedApisStatus(apiList, self.onboarding.getOwnChannelId())
        }
      }
      return response
    }),
    createApiMappingByProfileName: flow(function* createApiMappingByProfileName(
      profileName: string,
      producerChannelId: string,
      consumerChannelId: string,
    ) {
      console.log('===> createApiMappingByProfileName channel ids: ', producerChannelId, consumerChannelId)
      let response
      try {
        response = yield createApiMappingByProfileNameReq(
          producerChannelId,
          consumerChannelId,
          profileName,
          RootStore.session.getTokens,
        )
        console.log('createApiMappingByProfileName response: ', response)
        // setToastBgMessageByStatus(response?.status, 'Api Mapping created successfully', response?.error?.message ?? '')
      } catch (error) {
        console.log('error', error)
        if (error?.errorCode === '33714') {
          ;(self as any).updateProfileStatus(consumerChannelId, 1, profileName)
        }
      }
      return response
    }),

    createNewMultipleApiMapping: flow(function* createNewMultipleApiMapping(mappingArr: any[]) {
      console.log('===> createNewMultipleApiMapping channel ids: ', mappingArr)
      let response
      try {
        response = yield createMultipleApiMappingReq(mappingArr, RootStore.session.getTokens)
        console.log('createNewMultipleApiMapping response: ', response)
        // setToastBgMessageByStatus(response?.status, 'Api Mapping created successfully', response?.error?.message ?? '')
      } catch (error) {
        console.log('error', error)
      }
      return response
    }),
    updateSelectedApisStatus: flow(function* updateSelectedApisStatus(apis: any[], consumerChannelId: string) {
      console.log('===> updateProfileMapping apis: ', apis)
      let response
      try {
        response = yield updatApisStatusReq(apis, consumerChannelId, RootStore.session.getTokens)
        console.log('updateProfileMapping response', response)
        // setToastBgMessageByStatus(
        //   response?.status,
        //   'Updated Profile Mapping Successfully',
        //   response?.error?.message ?? '',
        // )
      } catch (error) {
        console.log('error', error)
      }
      return response
    }),
    updateProfileStatus: flow(function* updateProfileStatus(
      consumerChannelId: string,
      status: number,
      profileName: string,
    ) {
      console.log('===> updateProfileStatus apis: ', consumerChannelId, status, profileName)
      let response
      try {
        response = yield updatApisStatusByProfileNameReq(
          profileName,
          consumerChannelId,
          status,
          RootStore.session.getTokens,
        )
        console.log('updateProfileStatus response', response)
        // setToastBgMessageByStatus(
        //   response?.status,
        //   'Updated Profile Mapping Successfully',
        //   response?.error?.message ?? '',
        // )
      } catch (error) {
        console.log('error', error)
      }
      return response
    }),
    updateSelecteProfileStatus: flow(function* updateSelecteProfileStatus(apis: any[], channelId: string) {
      let response
      try {
        response = yield updatProfileApisStatusReq(channelId, apis, RootStore.session.getTokens)
        console.log('updateSelecteProfileStatus response', response)
      } catch (error) {
        console.log('error', error)
      }
      return response
    }),
    getProfileApiAccess: flow(function* getProfileApiAccess(consumerChannelId: string) {
      let response
      try {
        response = yield getProfileAccessReq(consumerChannelId, RootStore.session.getTokens)
        console.log('getProfileApiAccess response', response)
        self.onboarding.profilesaccesslist = response?.data
        if (self.onboarding.profilesaccesslist.length > 0) {
          if (checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
            self.onboarding.isAllPciSelected = true
            self.onboarding.isAllCommonPciNonPciSelected = true
          }
          if (checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
            self.onboarding.isAllCommonPciNonPciSelected = true
          }
          if (checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
            self.onboarding.isAllEmisSelected = true
          }
          if (checkIfProfileAccessPresent('OTHERS', self.onboarding.profilesaccesslist)) {
            self.onboarding.isAllOthersSelected = true
          }
        }
      } catch (error) {
        console.log('error', error)
      }
      return response
    }),
    setEmiFileUpload(isUploaded: boolean) {
      const own = self
      own.onboarding.isEmiFileUploaded = isUploaded
      self.onboarding.paymentConfig.map((item) => {
        if (item.id === 5) {
          item.isChecked = isUploaded
        }
      })
    },
    setCardsChecked(isModified: boolean) {
      const own = self
      own.onboarding.isCardsModified = isModified
      self.onboarding.paymentConfig.map((item) => {
        //For checking cards section in outer list and marking checked
        if (item.id === 3) {
          item.isChecked = isModified
        }
      })
    },
    fetchDevices: flow(function* fetchDevices(entityId: string) {
      let response
      try {
        response = yield fetchDevicesGqlReq(entityId, RootStore.session.getTokens)
        console.log('fetchDevices response', response)
        if (response instanceof Object) {
          self.onboarding.devices =
            response?.findDevices && response?.findDevices?.deviceDetails ? response?.findDevices?.deviceDetails : []
          console.log('fetchDevices response', response)
        } else if (typeof response === 'string' && response?.length > 0) {
          RootStore.message.setMessage(response, MessageTypes.ERROR)
          throw response
        }
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    updateSearchRecents(searchString: string, filterKey: string): void {
      const own = self
      const foundRecent = own.recentSearches.find(
        (recent) => recent?.searchString === searchString && recent?.filterKey === filterKey,
      )
      !foundRecent && own.recentSearches.push({ searchString: searchString, filterKey: filterKey })
    },
    createEmsGroup: flow(function* createEmsGroup(data: any) {
      const traceId = generateRandomString(20)
      try {
        const response = yield createGroup(data, RootStore.session.getTokens, traceId)
        console.log('createEmsGroup', response)
        return response
      } catch (error) {
        // RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        //TODO: Test n fail camunda api n send traceIdCamundaCreate
        RootStore.serviceError.setServiceError(
          'Service Error',
          traceId,
          getErrorMessage(error),
          APIEndPoints.createGroup_camunda,
        )
        throw error
      }
    }),
    createSubGroup: flow(function* createSubGroup(data: any) {
      const traceId = generateRandomString(20)
      try {
        const response = yield createSubGroupReq(data, RootStore.session.getTokens, traceId)
        console.log('createSubGroup', response)
        return response
      } catch (error) {
        if (error?.errorCode === -10001) {
          RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        } else {
          RootStore.serviceError.setServiceError(
            'Service Error',
            traceId,
            getErrorMessage(error),
            APIEndPoints.createSubGroup_camunda,
          )
        }
        throw error
      }
    }),
    createEntity: flow(function* createEntity(data: any) {
      const traceId = generateRandomString(20)
      try {
        const response = yield createEntityReq(data, RootStore.session.getTokens, traceId)
        console.log('===> createEntity', response)
        return response
      } catch (error) {
        // RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        RootStore.serviceError.setServiceError(
          'Service Error',
          traceId,
          getErrorMessage(error),
          APIEndPoints.createEntity_camunda,
        )
        throw error
      }
    }),
    checkCreationStatus: flow(function* checkCreationStatus(
      applicationId: string,
      currentCount = 0,
      isLinkToMAS: boolean,
    ) {
      console.log('===> checkCreationStatus', currentCount)
      const maxRetry = 10
      const traceId = generateRandomString(20)
      try {
        const response = yield checkCreationStatusReq(applicationId, RootStore.session.getTokens)
        // if (response.status !== 'COMPLETED' && response.status !== 'FAILED' && response.status !== 'ABORTED') {
        if (
          response.identificationNumber === undefined ||
          (response.identificationNumber === null &&
            response?.errorDetail?.error?.code !== 6010 &&
            response?.errorDetail?.status !== 'FAILED')
        ) {
          waitTill(2 * 1000)
            .then(() => {
              if (currentCount < maxRetry) {
                return (self as any).checkCreationStatus(applicationId, currentCount + 1)
              } else {
                console.log('===> else in then')
              }
            })
            .catch((e) => {
              console.log('===> catch inside promise', e)
            })
        }
        if (response?.identificationNumber?.length > 0 && isLinkToMAS) {
          console.log('===> calling getConfigAndCreateConfigEntity', response?.identificationNumber)
          ;(self as any).getConfigAndCreateConfigEntity(response?.identificationNumber)
        }
        if (response?.error) {
          // RootStore.message.setMessage(response?.error, MessageTypes.ERROR)
          RootStore.serviceError.setServiceError(
            'Service Error',
            traceId,
            getErrorMessage(response?.error),
            APIEndPoints.checkStatusCreateEntity,
          )
        } else if (response?.errorStatus && response?.errorStatus?.error && response?.errorStatus?.error?.message) {
          RootStore.message.setMessage(response?.errorStatus?.error?.message, MessageTypes.ERROR)
        } else if (
          response?.errorDetail &&
          response?.errorDetail?.error &&
          response?.errorDetail?.error?.message &&
          response?.errorDetail?.error?.code !== 200
        ) {
          RootStore.message.setMessage(response?.errorDetail?.error?.message, MessageTypes.ERROR)
        }
        return response
      } catch (error) {
        console.log('===> catch checkCreationStatus', error)
      }
    }),
    fetchEntityDetailsGetMerchant: flow(function* fetchEntityDetailsGetMerchant(
      searchStr: string,
      fetchString: string,
    ) {
      let response
      const traceId = generateRandomString(20)
      try {
        response = yield fetchEntityDetailsGetMerchantReq(searchStr, fetchString, RootStore.session.getTokens, traceId)
        if (response instanceof Object) {
          self.onboarding.entityDetails = response?.findEntity
          console.log('fetchGetMerchant response', response)
        } else {
          RootStore.serviceError.setServiceError('Service Error', traceId, response, APIEndPoints.getEntityDetails)
        }
      } catch (error) {
        console.log('error', error)
        RootStore.serviceError.setServiceError(
          'Service Error',
          traceId,
          getErrorMessage(error),
          APIEndPoints.getEntityDetails,
        )
      }
      return response
    }),
    fetchTerminalListDetails: flow(function* fetchTerminalListDetails(searchStr: string) {
      let response
      try {
        response = yield fetchTerminalListDetailsReq(searchStr, RootStore.session.getTokens)
        if (response instanceof Object) {
          self.onboarding.terminalDetails = response
          console.log('fetchTerminalListDetails response', response)
        } else {
          RootStore.message.setMessage(response, MessageTypes.ERROR)
        }
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    fetchSearchEntity: flow(function* fetchSearchEntity(searchStr: string, searchBy: string, fetchQuery: string) {
      let response
      const traceId = generateRandomString(20)
      try {
        if (fetchQuery === 'fiu') {
          self.fiu.directors = JSON.parse(JSON.stringify([]))
          self.fiu.authSignatories = JSON.parse(JSON.stringify([]))
          self.fiu.ubos = JSON.parse(JSON.stringify([]))
          self.fiu.cin = { number: '', date: '', action: '' }
          self.fiu.isFiuDataChanged = true
        }
        const pageNumber = self.pagination.number === 0 ? 1 : self.pagination.number
        const size = self.pagination.size < 5 ? 5 : self.pagination.size
        try {
          ;(self as any).fetchAllLovs(...['SetupCompleteInd', 'OwnerType', 'TerminalStatus', 'EntityType'])
        } catch (lovErr) {
          console.log('lovErr', lovErr)
        }
        response = yield fetchSearchEntityReq(
          searchStr,
          searchBy,
          pageNumber,
          size,
          RootStore.session.getTokens,
          fetchQuery,
          traceId,
        )
        if (response instanceof Object) {
          self.onboarding.searchEntity = response?.findEntity?.entitySearchList
          self.pagination = response?.findEntity?.page
          if (fetchQuery === 'fiu') {
            const entitySearchList = response?.findEntity?.entitySearchList?.[0]
            if (entitySearchList?.directorEntities) {
              self.fiu.directors = entitySearchList?.directorEntities
            }
            if (entitySearchList?.entity?.authorisedSignatories) {
              self.fiu.authSignatories = entitySearchList?.entity?.authorisedSignatories
            }
            if (entitySearchList?.beneficialOwnerEntity) {
              self.fiu.ubos = entitySearchList?.beneficialOwnerEntity
            }
            self.fiu.cin = {
              number: entitySearchList?.entity?.businessProfile?.cin,
              date: entitySearchList?.entity?.businessProfile?.dateOfIncorporation,
            }
          }
        } else {
          if (fetchQuery !== 'checkEntityPresence' && response !== "Record doesn't exist") {
            RootStore.serviceError.setServiceError('Service Error', traceId, response, APIEndPoints.searchEntity)
            throw { response, showError: false }
          } else if (response === "Record doesn't exist" && fetchQuery !== 'checkEntityPresence') {
            RootStore.message.setMessage(response, MessageTypes.ERROR)
          }
        }
        self.onboarding.cardList = JSON.parse(JSON.stringify([]))
        self.onboarding.cardSelectedList = JSON.parse(JSON.stringify([]))
        self.onboarding.convenienceFees = JSON.parse(JSON.stringify([]))
        self.onboarding.profilesaccesslist = JSON.parse(JSON.stringify([]))
        self.onboarding.configList = JSON.parse(JSON.stringify([]))
        self.onboarding.createdConfigList = JSON.parse(JSON.stringify([]))
        self.onboarding.deletedConfigList = JSON.parse(JSON.stringify([]))
        self.onboarding.updateConfigList = JSON.parse(JSON.stringify([]))
        self.onboarding.entityConfigs = JSON.parse(JSON.stringify([]))
        self.onboarding.configurations = JSON.parse(JSON.stringify([]))
        self.onboarding.createdEntityConfigs = JSON.parse(JSON.stringify([]))
        self.onboarding.deletedEntityConfigs = JSON.parse(JSON.stringify([]))
        self.onboarding.businessCategoryMccCodeList = JSON.parse(JSON.stringify([]))
        self.onboarding.updatedEntityConfigs = JSON.parse(JSON.stringify([]))
        self.onboarding.s2sUrls = JSON.parse(JSON.stringify([]))
        self.onboarding.collectLinkUrls = JSON.parse(JSON.stringify([]))
      } catch (error) {
        const { showError = true } = error
        console.log('===> fetchSearchEntity error: ', error)
        if (showError) {
          if (fetchQuery !== 'checkEntityPresence' && error?.message !== "Record doesn't exist") {
            if (error?.data?.errorCode !== 'ERR_NETWORK') {
              RootStore.serviceError.setServiceError('Service Error', traceId, response, APIEndPoints.searchEntity)
              throw { response, showError: false }
            } else {
              RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
            }
          } else if (error?.message === "Record doesn't exist" && fetchQuery !== 'checkEntityPresence') {
            RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
          } else if (fetchQuery === 'checkEntityPresence' && error?.message?.length > 0) {
            RootStore.message.setMessage(error?.message, MessageTypes.ERROR)
          }
        }
        self.onboarding.cardList = JSON.parse(JSON.stringify([]))
        self.onboarding.cardSelectedList = JSON.parse(JSON.stringify([]))
        self.onboarding.convenienceFees = JSON.parse(JSON.stringify([]))
        self.onboarding.profilesaccesslist = JSON.parse(JSON.stringify([]))
        self.onboarding.configList = JSON.parse(JSON.stringify([]))
        self.onboarding.createdConfigList = JSON.parse(JSON.stringify([]))
        self.onboarding.deletedConfigList = JSON.parse(JSON.stringify([]))
        self.onboarding.updateConfigList = JSON.parse(JSON.stringify([]))
        self.onboarding.entityConfigs = JSON.parse(JSON.stringify([]))
        self.onboarding.configurations = JSON.parse(JSON.stringify([]))
        self.onboarding.createdEntityConfigs = JSON.parse(JSON.stringify([]))
        self.onboarding.deletedEntityConfigs = JSON.parse(JSON.stringify([]))
        self.onboarding.businessCategoryMccCodeList = JSON.parse(JSON.stringify([]))
        self.onboarding.updatedEntityConfigs = JSON.parse(JSON.stringify([]))
        throw response ? response : error
      }
      return response
    }),
    getGroupsList: flow(function* getGroupsList(groupId: string) {
      let response
      try {
        response = yield getGroupsListReq(groupId, RootStore.session.getTokens)
        console.log('getGroupsList response', JSON.stringify(response))
        if (groupId.length > 0) {
          self.onboarding.group = response?.[0]
        } else {
          self.onboarding.groups = response
        }
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    getSubGroupsList: flow(function* getSubGroupsList(groupId: string, subGroupId: string) {
      let response
      try {
        self.onboarding.selectedParentEntityId = ''
        self.onboarding.selectedParentEntityName = ''
        response = yield getSubGroupsListReq(groupId, subGroupId, RootStore.session.getTokens)
        if (subGroupId.length > 0) {
          self.onboarding.subgroup = response
        } else {
          self.onboarding.subgroups = response
        }
        console.log('getSubGroupsList response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    updateGroupSubGroup: flow(function* updateGroupSubGroup(data: any) {
      let response
      try {
        response = yield updateGroupSubGroupReq(data, RootStore.session.getTokens)
        console.log('updateGroupSubGroup response', response)
        if (response && response?.data && response?.data?.identificationNumber) {
          if (data?.type === 'SUBGROUP') {
            self.onboarding.subgroup.map((subgrp) => {
              if (subgrp.identificationNumber === response?.data?.identificationNumber) {
                subgrp = response?.data
              }
              return subgrp
            })
          } else {
            self.onboarding.group = response?.data
          }
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
        }
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    linkUnlinkMerchantWithDevice: flow(function* linkUnlinkMerchantWithDevice(
      mid: string,
      deviceSerialNo: string,
      action: string,
    ) {
      let response
      try {
        response = yield linkUnlinkMerchantWithDeviceReq(mid, deviceSerialNo, action, RootStore.session.getTokens)
        console.log('linkUnlinkMerchantWithDevice response', response)
        const updatedDevices = self.onboarding.updateDevicePostLinkUnlink(mid, response?.data?.deviceRequestList[0])
        console.log('updatedDevices: ', JSON.parse(JSON.stringify(updatedDevices)))
        self.onboarding.devices = updatedDevices
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchAllLovs: flow(function* fetchAllLovs(
      key1: string,
      key2: string,
      key3: string,
      key4: string,
      key5: string,
      key6: string,
      key7: string,
      key8: string,
      key9: string,
      key10: string,
      key11: string,
      key12: string,
      key13: string,
      key14: string,
      key15: string,
    ) {
      let response
      const traceId = generateRandomString(20)
      try {
        response = yield getAllLovsReq(
          key1,
          key2,
          key3,
          key4,
          key5,
          key6,
          key7,
          key8,
          key9,
          key10,
          key11,
          key12,
          key13,
          key14,
          key15,
          RootStore.session.getTokens,
          traceId,
        )
        if (response instanceof Object) {
          self.lovs = [...self.lovs, ...response?.findLov]
          //TO fix repeated values
          self.lovs = self.lovs.filter(
            (value, index, self) =>
              index ===
              self.findIndex(
                (t) => t.value === value.value && t.description === value.description && t.key === value.key,
              ),
          )
          if (key1 === 'SUPPORTED_PROCESSING_ENTITY' || key2 === 'SUPPORTED_PROCESSING_ENTITY') {
            const partnerList = (self as any).getLovsFromKey('SUPPORTED_PROCESSING_ENTITY')
            let list = []
            partnerList.map((partner) => {
              list.push({ partnerName: partner?.value, checkBox: false })
            })
            self.onboarding.partners = JSON.parse(JSON.stringify(list))
          }
          console.log('fetchAllLovs response', response, JSON.parse(JSON.stringify(self.lovs)))
        } else {
          // RootStore.message.setMessage(response, MessageTypes.ERROR)
          RootStore.serviceError.setServiceError('Service Error', traceId, response, APIEndPoints.getAllLovs)
        }
      } catch (error) {
        console.log('error', error)
        // RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        if (error?.data?.errorCode !== 'ERR_NETWORK') {
          RootStore.serviceError.setServiceError(
            'Service Error',
            traceId,
            getErrorMessage(error),
            APIEndPoints.getAllLovs,
          )
        } else {
          RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        }
      }
      return response
    }),
    fetchLov: flow(function* fetchLov(key: string) {
      let response
      const traceId = generateRandomString(20)
      try {
        response = yield getLovReq(key, RootStore.session.getTokens, traceId)
        if (response instanceof Object) {
          self.lovs = [...self.lovs, ...response?.findLov]
          //TO fix repeated values
          self.lovs = self.lovs.filter(
            (value, index, self) =>
              index ===
              self.findIndex(
                (t) => t.value === value.value && t.description === value.description && t.key === value.key,
              ),
          )
          console.log('fetchLov response', response, JSON.parse(JSON.stringify(self.lovs)))
        } else {
          // RootStore.message.setMessage(response, MessageTypes.ERROR)
          RootStore.serviceError.setServiceError('Service Error', traceId, response, APIEndPoints.getAllLovs)
        }
      } catch (error) {
        console.log('error', error)
        // RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        RootStore.serviceError.setServiceError(
          'Service Error',
          traceId,
          getErrorMessage(error),
          APIEndPoints.getAllLovs,
        )
      }
      return response
    }),
    fetchAllBusinessLines: flow(function* fetchAllBusinessLines() {
      let response
      try {
        response = yield getMccFromBizCategory(RootStore.session.getTokens)
        self.onboarding.businessCategoryMccCodeList = response
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    fetchEmisTenures: flow(function* fetchEmisTenures() {
      let response
      try {
        response = yield getEmisTenuresReq(RootStore.session.getTokens)
        self.onboarding.emis = response
        console.log('fetchEmisTenures response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchCardsList: flow(function* fetchCardsList(cardType: string) {
      let response
      try {
        response = yield getCardsList(cardType, RootStore.session.getTokens)
        self.onboarding.cardList = response
        // self.onboarding.cardsList = cardsListParser(reponse)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchEmsCardsList: flow(function* fetchEmsCardsList(entityId: string) {
      let response: any[]
      try {
        response = yield getEMSCardsList(entityId, RootStore.session.getTokens)
        self.onboarding.cardSelectedList = response
        if (self.onboarding.cardList.length > 0) {
          const updatedCards: any[] = []
          self.onboarding.cardList.map((card) => {
            const { isDomesticAllowed, isInternationalAllowed, isPremium } = getIsCheckedFromCardSearchConfig(
              card,
              self.onboarding.cardSelectedList,
            )
            let updatedCard = {
              ...card,
              isDomesticAllowed: isDomesticAllowed,
              isInternationalAllowed: isInternationalAllowed,
              isPremium: isPremium,
            }
            updatedCards.push(updatedCard)
            // return updatedCard
          })
          self.onboarding.cardList = updatedCards
        }
        console.log('===> fetchEmsCardsList response', JSON.parse(JSON.stringify(self.onboarding.cardList)))
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    updateEmsCards: flow(function* updateEmsCards(entityId: string, data: any[]) {
      let response
      try {
        if (self.onboarding.hasCardsChanged) {
          response = yield updateEmsCardsReq(entityId, data, RootStore.session.getTokens)
          console.log('updateEmsCards response', response)
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
          self.onboarding.hasCardsChanged = false
        }
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    addEmsCards: flow(function* addEmsCards(entityId: string, data: any[]) {
      let response
      try {
        response = yield addEmsCardsReq(entityId, data, RootStore.session.getTokens)
        console.log('addEmsCards response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    //TODO: check if needed
    setSelectedCardTypeChecked(isChecked: boolean) {
      self.onboarding.cardList.map((card) => {
        if (card.type === self.onboarding.merchant.preferences.selectedCardType) {
          card.isDomesticAllowed = isChecked
          card.isInternationalAllowed = isChecked
          card.isPremium = isChecked
          card.isSelected = isChecked
          console.log('===> setSelectedCardTypeChecked, card ', card)
          return card
        }
      })
      console.log('===> setSelectedCardTypeChecked', JSON.parse(JSON.stringify(self.onboarding.cardList)))
    },
    updateCardsSelectionByType(typeObj: any) {
      self.onboarding.merchant.preferences.selectedCardType = typeObj.value
      self.onboarding.merchant.preferences.selectedCardTypeId = `${typeObj.id}`
    },
    insertCardsSelections: flow(function* insertCardsSelections(mid: string, cards: any[], isUpdateRequired: boolean) {
      let response
      try {
        response = yield insertCards(mid, cards, RootStore.session.getTokens, isUpdateRequired)
        console.log('insertCardsSelections response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    getConfigAndCreateConfigEntity: flow(function* getConfigAndCreateConfigEntity(entityId: string) {
      console.log('===> getConfigAndCreateConfigEntity entityId: ', entityId)
      let response, createConfigResp
      try {
        response = yield getConfigOfEntity(entityId, RootStore.session.getTokens)
        console.log('===> getConfigOfEntity response: ', response)
        console.log('===> riskSettings configurations: ', self.onboarding.entityDetails.riskSettings.configurations)

        createConfigResp = yield createConfigOfEntity(
          entityId,
          response?.data?.data?.configValues?.length > 0
            ? addStatusToConfigValues(response?.data?.data?.configValues)
            : [],
          response?.data?.response?.configurations?.length > 0 &&
            self.onboarding.entityDetails.riskSettings.configurations?.length > 0
            ? addStatusToConfigurations([
                ...response?.data?.response?.configurations,
                ...self.onboarding.entityDetails.riskSettings.configurations,
              ])
            : response?.data?.response?.configurations?.length === 0 &&
              self.onboarding.entityDetails.riskSettings.configurations?.length > 0
            ? addStatusToConfigurations([...self.onboarding.entityDetails.riskSettings.configurations])
            : response?.data?.response?.configurations?.length > 0 &&
              self.onboarding.entityDetails.riskSettings.configurations?.length === 0
            ? addStatusToConfigurations([...response?.data?.response?.configurations])
            : [],
          RootStore.session.getTokens,
        )
        console.log('===> createConfigOfEntity response: ', createConfigResp)
      } catch (error) {
        console.log('===> getConfigAndCreateConfigEntity error: ', error)
        //INFO: To handle Record doesn't exist error case on getConfig api, and creating empty configs
        const configurations = self?.onboarding?.entityDetails?.riskSettings?.configurations
        createConfigResp = yield createConfigOfEntity(
          entityId,
          [],
          configurations?.length > 0 ? addStatusToConfigurations([...configurations]) : [],
          RootStore.session.getTokens,
        )
        console.log('===> createConfigOfEntity response: ', createConfigResp)
        return createConfigResp
        // throw error
      }
      return response
    }),
    getConfigByEntityId: flow(function* getConfigByEntityId(entityId: string) {
      console.log('===> getConfigByEntityId entityId: ', entityId)
      let response
      try {
        response = yield getConfigOfEntity(entityId, RootStore.session.getTokens)
        self.onboarding.searchEntity.map((entity) => {
          if (entity.identificationNumber === entityId) {
            const riskSettings = RiskConfigurations.create({
              configurations: JSON.parse(JSON.stringify(response?.data?.data?.configurations)),
            })
            entity.riskSettings = riskSettings
          }
          return entity
        })
      } catch (error) {
        console.log('===> getConfigByEntityId error: ', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    createNewConfigEntity: flow(function* createNewConfigEntity(entityId: string) {
      let response
      const configValues: any[] = [
        ...getKeyValueStatusList(self.onboarding.addedchannelIds),
        ...getKeyValueStatusList(self.onboarding.createdConfigList),
      ]
      // const riskSettings =
      //   self?.onboarding?.entityDetails?.riskSettings?.configurations?.length > 0
      //     ? self?.onboarding?.entityDetails?.riskSettings?.configurations
      //     : []

      const createdEntityConfigs =
        self?.onboarding?.createdEntityConfigs?.length > 0 ? self?.onboarding?.createdEntityConfigs : []

      const collectLinkConfigs = getUrlConfigs(self.onboarding.collectLinkUrls, 'COLLECT_LINK_INFO')
      const s2sUrls = getUrlConfigs(self.onboarding.s2sUrls, 'CALLBACK_URL')
      // Removed riskSettings as per request from BE team as this riskSettings is moved to camunda
      // [...createdEntityConfigs, ...riskSettings, ...collectLinkConfigs, ...s2sUrls]
      const configurations: any[] = [...createdEntityConfigs, ...collectLinkConfigs, ...s2sUrls]
      console.log('===> createNewConfigEntity configValues, configurations: ', configValues, configurations)
      if (configValues.length !== 0 || configurations.length !== 0) {
        try {
          response = yield createConfigOfEntity(entityId, configValues, configurations, RootStore.session.getTokens)
          console.log('===> createConfigOfEntity response: ', response)
          if (response?.data?.configValues?.length > 0) {
            response?.data?.configValues?.map((respConfig) => {
              if (respConfig?.key === 'ALLOWED_CHANNEL') {
                self.onboarding.channelIds.map((channelId) => {
                  if (channelId?.value === respConfig?.value) {
                    channelId.configValuesReferenceId = respConfig?.configValuesReferenceId
                  }
                  return channelId
                })
              }
            })
          }
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
        } catch (error) {
          ;(self as any).searchConfigEntity(entityId)
          console.log('===> createConfigOfEntity error: ', error)
          RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
          throw error
        }
      }
      return response
    }),
    removeConfigOfEntity: flow(function* removeConfigOfEntity(entityId: string) {
      let response
      const configValues: any[] = [...self.onboarding.deletedchannelIds, ...self.onboarding.deletedConfigList]
      const configurations: any[] = [...self.onboarding.deletedEntityConfigs]
      console.log(
        '===> removeConfigOfEntity configValues, configurations: ',
        configValues,
        JSON.parse(JSON.stringify(configurations)),
      )
      if (configValues.length !== 0 || configurations.length !== 0) {
        try {
          response = yield removeConfigOfEntityApi(entityId, configValues, configurations, RootStore.session.getTokens)
          console.log('===> removeConfigOfEntity response: ', response)
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
        } catch (error) {
          console.log('===> removeConfigOfEntity error: ', error)
          RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
          // throw error
        }
      }
      return response
    }),
    searchConfigEntity: flow(function* searchConfigEntity(entityId: string) {
      let response
      try {
        response = yield searchConfigEntityReq(entityId, RootStore.session.getTokens)
        if (response !== null && response?.searchEntityConfig !== null) {
          self.onboarding.configList = response?.searchEntityConfig?.entityConfigList
          self.onboarding.configurations = response?.searchEntityConfig?.entityConfig
          self.onboarding.channelIds = response?.searchEntityConfig?.entityConfigList?.filter(
            (config: any) => config.key === 'ALLOWED_CHANNEL',
          )

          //TO Update INVOICE_REGEX_PATTERN from api data
          const regexPattern = response?.searchEntityConfig?.entityConfigList?.filter(
            (config: any) => config.key === 'INVOICE_REGEX_PATTERN',
          )[0]
          self.onboarding.upiConfig.qrTxnPattern = regexPattern?.value

          if (self.onboarding.configurations && self.onboarding.configurations?.length > 0) {
            self.onboarding.configurations.map((entConfig: any) => {
              if (entConfig.configType === 'PAYMENT_ACCEPTANCE') {
                if (entConfig.key === '566') {
                  self.onboarding.updateChecked(1, true, true)
                }
                if (entConfig.key === '581') {
                  self.onboarding.updateChecked(2, true, true)
                }
                if (entConfig.key === '582') {
                  self.onboarding.updateChecked(3, true, true)
                }
                if (entConfig.key === '579') {
                  self.onboarding.updateChecked(4, true, true)
                }
                if (entConfig.key === '601') {
                  self.onboarding.updateChecked(5, true, true)
                }
              }
              if (entConfig.configType === 'KEYS') {
                if (entConfig.key === 'AES_KEY') {
                  self.onboarding.AES_KEY = entConfig.value
                }
                if (entConfig.key === 'MAC_KEY') {
                  self.onboarding.MAC_KEY = entConfig.value
                }
              }
            })
          }
          const bankList = response?.searchEntityConfig?.entityConfigList?.filter(
            (config: any) => config.key === 'SUPPORTED_NETBANKING',
          )
          if (bankList?.length > 0) {
            let selectedBankList: any[] = []
            self.onboarding.merchant.preferences.bankList.map((bank) => {
              const isSelected = getIsCheckedFromSearchConfig(bank, self.onboarding.configList)
              let updatedBank = {
                ...bank,
                isSelected: isSelected,
              }
              selectedBankList.push(updatedBank)
              // return updatedBank
            })
            self.onboarding.merchant.preferences.bankList = JSON.parse(JSON.stringify(selectedBankList))
          }
          const corpBankList = response?.searchEntityConfig?.entityConfigList?.filter(
            (config: any) => config.key === 'SUPPORTED_CORPORATENETBANKING',
          )
          if (corpBankList?.length > 0) {
            let selectedBankList: any[] = []
            self.onboarding.merchant.preferences.corpBankList.map((bank) => {
              const isSelected = getIsCheckedFromSearchConfig(bank, self.onboarding.configList)
              let updatedBank = {
                ...bank,
                isSelected: isSelected,
              }
              selectedBankList.push(updatedBank)
              // return updatedBank
            })
            self.onboarding.merchant.preferences.corpBankList = JSON.parse(JSON.stringify(selectedBankList))
          }

          const payLater = response?.searchEntityConfig?.entityConfigList?.filter(
            (config) => config.key === 'SUPPORTED_PAYLATER',
          )
          if (payLater?.length > 0) {
            let selectedPayLaterList: any[] = []
            self.onboarding.merchant.preferences.payLaterList.map((paylater) => {
              const isSelected = getIsCheckedFromSearchConfig(paylater, self.onboarding.configList)
              let updatedPayLater = {
                ...paylater,
                isSelected: isSelected,
              }
              selectedPayLaterList.push(updatedPayLater)
            })
            self.onboarding.merchant.preferences.payLaterList = JSON.parse(JSON.stringify(selectedPayLaterList))
          }
          const walletList = response?.searchEntityConfig?.entityConfigList?.filter(
            (config) => config.key === 'SUPPORTED_WALLET',
          )
          if (walletList?.length > 0) {
            let selectedWalletList: any[] = []
            self.onboarding.merchant.preferences.walletList.map((wallet) => {
              const isSelected = getIsCheckedFromSearchConfig(wallet, self.onboarding.configList)
              let updatedWallet = {
                ...wallet,
                isSelected: isSelected,
              }
              selectedWalletList.push(updatedWallet)
            })
            self.onboarding.merchant.preferences.walletList = JSON.parse(JSON.stringify(selectedWalletList))
          }
        } else {
          RootStore.message.setMessage(getErrorMessage(response?.error), MessageTypes.ERROR)
        }
        const partnerProcessorList = response?.searchEntityConfig?.entityConfigList?.filter(
          (config: any) => config.key === 'SUPPORTED_PROCESSING_ENTITY',
        )
        if (partnerProcessorList?.length > 0) {
          self.onboarding.partners.map((partner) => {
            const isSelected = getIsCheckedFromPartnerConfig(partner, self.onboarding.configList)
            partner.checkBox = isSelected
            return partner
          })
        }
        console.log('getConfigEntity response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    updateSearchConfig: flow(function* updateSearchConfig(entityId: string) {
      let response
      try {
        const updatedValidEntityConfigs = checkCompareNGetValidEntConfigChanges(
          self.onboarding.updatedEntityConfigs,
          self.onboarding.configurations,
        )
        const updatedValidConfigList = checkCompareNGetValidConfigListChanges(
          self.onboarding.updateConfigList,
          self.onboarding.configList,
        )
        // console.log('===> updateSearchConfig updatedEntityConfigs', JSON.parse(JSON.stringify(updatedValidEntityConfigs)))
        if (updatedValidConfigList.length !== 0 || updatedValidEntityConfigs?.length !== 0) {
          response = yield updateConfig(
            entityId,
            updatedValidConfigList,
            updatedValidEntityConfigs,
            RootStore.session.getTokens,
          )
          response?.data?.configValues?.map((item) => {
            self.onboarding.configList.map((updateconf) => {
              if (updateconf.key === item.key) {
                updateconf.value = item.value
                updateconf.configValuesReferenceId = item.configValuesReferenceId
              }
              return updateconf
            })
          })
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
          ;(self as any).searchConfigEntity(entityId)
        }
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    insertConfigListSelections: flow(function* insertConfigListSelections(
      mid: string,
      configs: any[],
      isUpdateRequired: boolean,
    ) {
      let response
      try {
        response = yield insertConfigList(mid, configs, RootStore.session.getTokens, isUpdateRequired)
        console.log('insertConfigListSelections response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    insertConfigSelection: flow(function* insertConfigSelection(mid: string, config: any[], isUpdateRequired: boolean) {
      let response
      try {
        response = yield insertConfig(mid, config, isUpdateRequired, RootStore.session.getTokens)
        console.log('insertConfigSelection response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    updatePagination(selectedPage: number): void {
      self.pagination.number = selectedPage
    },
    setPagination(page: any): void {
      self.pagination = page
    },
    resetPagination(): void {
      const defaultPage = {
        size: 0,
        totalElements: 0,
        totalPages: 0,
        number: 1,
      }
      self.pagination = JSON.parse(JSON.stringify(defaultPage))
    },
    fetchAadharRedactionMakerList: flow(function* fetchAadharRedactionMakerList(searchBy?: string, searchKey?: string) {
      let response
      try {
        response = yield getAadharRedactionMakerListReq(
          self.selectedDateInfo,
          self.pagination,
          self.filter.applicationStatus,
          RootStore.session.getTokens,
          searchBy,
          searchKey,
        )
        self.aadharRedactionMakerList = response?.list
        self.pagination.totalElements = response?.count
        self.pagination = getPaginationObject(response?.count, self.pagination.number, 10)
        console.log('fetchAadharRedactionMakerList response', response?.data)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    getAadharRedactionGlobalCheckerList: flow(function* getAadharRedactionGlobalCheckerList(
      searchBy?: string,
      searchKey?: string,
    ) {
      let response
      try {
        response = yield getAadharRedactionGlobalCheckerListReq(
          self.selectedDateInfo,
          self.pagination,
          self.filter.applicationStatus,
          RootStore.session.getTokens,
          searchBy,
          searchKey,
        )
        self.aadharRedactionCheckerList = response?.list
        self.pagination.totalElements = response?.count
        self.pagination = getPaginationObject(response?.count, self.pagination.number, 10)
        console.log('getAadharRedactionGlobalCheckerList response', response?.data)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    getGlobalCheckerList: flow(function* getGlobalCheckerList(
      searchBy?: string,
      searchKey?: string,
      isAudit?: boolean,
    ) {
      let response
      try {
        response = yield getGlobalCheckerListReq(
          self.selectedDateInfo,
          self.pagination,
          self.filter.applicationStatus,
          RootStore.session.getTokens,
          self.filter.auditType,
          searchBy,
          searchKey,
          isAudit,
        )
        if (isAudit) {
          self.fiuCheckerList = response?.list
        } else {
          self.globalCheckerList = response?.list
        }
        self.pagination.totalElements = response?.count
        self.pagination = getPaginationObject(response?.count, self.pagination.number, 10)
        console.log('getGlobalCheckerList response', response?.data)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchFiuCheckerList: flow(function* fetchFiuCheckerList(searchBy?: string, searchKey?: string) {
      let response
      try {
        response = yield getFiuCheckerListReq(
          self.selectedDateInfo,
          self.pagination,
          self.filter.applicationStatus,
          RootStore.session.getTokens,
          self.filter.auditType,
          searchBy,
          searchKey,
        )
        self.fiuCheckerList = response?.list
        self.pagination.totalElements = response?.count
        self.pagination = getPaginationObject(response?.count, self.pagination.number, 10)
        console.log('getGlobalCheckerList response', response?.data)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchFiuMakerList: flow(function* fetchFiuMakerList(searchBy?: string, searchKey?: string) {
      let response
      try {
        response = yield getFiuMakerListReq(
          self.selectedDateInfo,
          self.pagination,
          self.filter.applicationStatus,
          RootStore.session.getTokens,
          self.filter.auditType,
          searchBy,
          searchKey,
        )
        self.fiuMakerList = response?.list
        self.pagination.totalElements = response?.count
        self.pagination = getPaginationObject(response?.count, self.pagination.number, 10)
        console.log('getFiuMakerListReq response', response?.data)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchMakerList: flow(function* fetchMakerList(searchBy?: string, searchKey?: string) {
      let response
      try {
        response = yield getMakerListReq(
          self.selectedDateInfo,
          self.pagination,
          self.filter.applicationStatus,
          RootStore.session.getTokens,
          searchBy,
          searchKey,
        )
        self.makerList = response?.list
        //self.pagination.totalElements = response?.count
        self.pagination = response.pagination
        console.log('fetchMakerList response', response?.data)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    getMyCheckerList: flow(function* getMyCheckerList(assignee: string, searchBy?: string, searchKey?: string) {
      let response
      try {
        response = yield getMyCheckerListReq(
          assignee,
          self.pagination,
          self.selectedDateInfo,
          self.filter.applicationStatus,
          RootStore.session.getTokens,
          searchBy,
          searchKey,
        )
        console.log('getMyCheckerList response', response?.list)
        self.myCheckerList = response?.list
        self.pagination.totalElements = response?.count
        self.pagination = getPaginationObject(response?.count, self.pagination.number, 10)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    claimTask: flow(function* claimTask(assignee: string, taskIds: string[]) {
      let response
      try {
        response = yield claimTaskReq(assignee, taskIds, RootStore.session.getTokens)
        console.log('claimTask response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    approveRejectTask: flow(function* approveRejectTask(applicationId: string, status: string, comments: string) {
      let response
      try {
        response = yield approveRejectTaskReq(applicationId, status, comments, RootStore.session.getTokens)
        console.log('approveRejectTask response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    applicationRetry: flow(function* applicationRetry(applicationId: string, isAudit: boolean, filterType?: string) {
      let response
      try {
        response = yield applicationRetryReq(applicationId, RootStore.session.getTokens, isAudit, filterType)
        console.log('applicationRetry response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    checkApplicationStatusRecursivly: flow(function* (applicationId: string, noOfTimes = 0, getAbortController: any) {
      try {
        const { abortController, abortRecursive } = getAbortController()
        if (abortRecursive) {
          throw { abortRecursive }
        } else if (noOfTimes <= 100) {
          const response = yield checkApplicationStatusReq(
            applicationId,
            RootStore.session.getTokens,
            '',
            abortController,
          )
          console.log('checkApplicationStatusRecursivly', response)
          if (['COMPLETED', 'ERROR'].includes(response.applicationState)) {
            return response
          } else {
            yield delay(2000)
            return yield (self as any).checkApplicationStatusRecursivly(
              applicationId,
              noOfTimes + 1,
              getAbortController,
            )
          }
        } else {
          throw { message: 'An error has occoured , while fetching status' }
        }
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),

    checkApplicationStatus: flow(function* checkApplicationStatus(applicationId: string, auditType: string) {
      const maxRetry = 100
      const currentCount = 0
      let response: any
      try {
        response = yield checkApplicationStatusReq(applicationId, RootStore.session.getTokens, auditType)
        console.log('checkApplicationStatus response', response)

        if (
          !response.applicationStatus ||
          (response.applicationStatus?.toLowerCase() !== 'completed' &&
            response.applicationStatus?.toLowerCase() !== 'error' &&
            response.applicationStatus?.toLowerCase() !== 'rejected')
        ) {
          self.checkerApplicationStatus = JSON.parse(
            JSON.stringify({
              ...response,
              callCount: self.checkerApplicationStatus.callCount + 1,
              applicationStatus: 'pending',
            }),
          )
          waitTill(2 * 1000)
            .then(() => {
              if (currentCount < maxRetry) {
                response = (self as any).checkApplicationStatus(applicationId, auditType)
              } else {
                console.log('===> else in then')
              }
            })
            .catch((e) => {
              console.log('===> catch inside promise', e)
            })
        } else if (
          response.applicationStatus?.toLowerCase() === 'completed' ||
          response.applicationStatus?.toLowerCase() === 'error' ||
          response.applicationStatus?.toLowerCase() === 'rejected'
        ) {
          self.checkerApplicationStatus = response
          return response
        }
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    updateSelectedRowIndex(pageNumber: number, id: number, rowData: any, isChecked: boolean): void {
      const own = self
      // const isNewInsertion = own.selectedRowsIndex.find((page) => page.pageNumber === pageNumber) === undefined
      // const isRowsPresentInPage =
      //   own.selectedRowsIndex.filter((page) => pageNumber === page.pageNumber)?.[0]?.selectedRows.length >= 0
      // const isIdNotPresentInPage = !own.selectedRowsIndex
      //   .filter((page) => pageNumber === page.pageNumber)?.[0]
      //   ?.selectedRows.includes(id)
      // if (own.selectedRowsIndex.length === 0 || isNewInsertion) {
      //   const selectedids = [id]
      //   own.selectedRowsIndex.push({ pageNumber: pageNumber, selectedRows: selectedids })
      // } else if (own.selectedRowsIndex.length > 0 && isRowsPresentInPage && isIdNotPresentInPage) {
      //   own.selectedRowsIndex.filter((page) => pageNumber === page.pageNumber)?.[0]?.selectedRows.push(id)
      // } else {
      //   own.selectedRowsIndex.filter((page) => pageNumber === page.pageNumber)?.[0]?.selectedRows.remove(id)
      // }
      own.globalCheckerList.map((checker) => {
        if (checker?.applicationId === rowData?.applicationId) {
          checker.isSelected = isChecked
          return checker
        }
      })
    },
    updateMyQueueSelectedRow(pageNumber: number, id: number, rowData: any, isChecked: boolean): void {
      const own = self
      own.myCheckerList.map((checker) => {
        if (checker?.applicationId === rowData?.applicationId) {
          checker.isSelected = isChecked
          return checker
        }
      })
    },
    updateAllRowsSelection(pageNumber: number, isChecked: boolean): void {
      const own = self
      // const eligibleList = own.globalCheckerList.filter((checker) => checker.status === 'Pending')
      // own.selectedRowsIndex.filter((page) => pageNumber === page.pageNumber)?.[0]?.selectedRows.push()
      own.globalCheckerList.map((checker) => {
        if (
          (checker?.applicationStatus?.toLowerCase() === 'pending' ||
            checker?.applicationStatus?.toLowerCase() === 'pending for approval') &&
          (checker?.assignee?.toLowerCase() === 'na' || !checker?.assignee)
        ) {
          checker.isSelected = isChecked
          return checker
        }
      })
    },
    updateAllMyQueRowsSelection(pageNumber: number, isChecked: boolean): void {
      const own = self
      own.myCheckerList.map((checker) => {
        if (
          (checker.applicationStatus.toLowerCase() === 'pending' ||
            checker.applicationStatus.toLowerCase() === 'pending for approval') &&
          checker.assignee.toLowerCase() === 'na'
        ) {
          checker.isSelected = isChecked
          return checker
        }
      })
    },
    resetSelectedRows(): void {
      const own = self
      // own.selectedRowsIndex.map((item) => {
      //   return item.selectedRows.splice(0, item.selectedRows.length)
      // })
      // own.selectedRowsIndex.splice(0, own.selectedRowsIndex.length)

      own.globalCheckerList.map((checker) => {
        checker.isSelected = false
        return checker
      })
    },
    // searchGlobalCheckerListBy: flow(function* searchGlobalCheckerListBy(searchBy: string, searchString: string) {
    //   let response
    //   try {
    //     response = yield getGlobalSearchListReq(searchBy, searchString, RootStore.session.getTokens)
    //     self.globalCheckerList = response
    //     console.log('searchGlobalCheckerListBy response', response)
    //   } catch (error) {
    //     console.log('error', error)
    //     RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
    //     throw error
    //   }
    //   return response
    // }),
    updateSelectedDateInfo(dateObj: any): void {
      self.selectedDateInfo.fromDate = dateObj?.fromDate ?? new Date(Date.now())
      self.selectedDateInfo.toDate = dateObj?.toDate ?? new Date(Date.now())
      self.selectedDateInfo.position.top = dateObj?.position?.top ?? 0
      self.selectedDateInfo.position.left = dateObj?.position?.left ?? 0
      self.selectedDateInfo.position.visible = dateObj?.position?.visible ?? false
      self.selectedDateInfo.dateLabel = dateObj?.dateLabel ?? ''
      console.log('Calendar Position: ', JSON.parse(JSON.stringify(self.selectedDateInfo.position)))
    },
    resetSelectedDate(): void {
      self.selectedDateInfo.fromDate = getSelectedDate(4)
      self.selectedDateInfo.toDate = new Date(Date.now())
      self.selectedDateInfo.position.visible = false
      self.selectedDateInfo.dateLabel = 'Last 90 days'
    },
    insertMetaConfigList: flow(function* insertMetaConfigList(mid: string, config: any[], isUpdateRequired: boolean) {
      let response
      try {
        response = yield insertMetaConfig(mid, config, isUpdateRequired, RootStore.session.getTokens)
        console.log('insertConfigSelection response', response)
      } catch (error) {
        console.log('error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchOthersApiConfig: flow(function* fetchOthersApiConfig(profileName: string) {
      const own = self
      let response, resp
      try {
        const { REACT_APP_API_CONFIG_MTS_CHANNEL_ID, REACT_APP_API_CONFIG_DMM_CHANNEL_ID } = window?._env_
        response = yield fetchOthersApisConfig(
          REACT_APP_API_CONFIG_MTS_CHANNEL_ID,
          profileName,
          RootStore.session.getTokens,
        )
        resp = yield fetchOthersApisConfig(
          REACT_APP_API_CONFIG_DMM_CHANNEL_ID,
          profileName,
          RootStore.session.getTokens,
        )
        own.apis = JSON.parse(
          JSON.stringify(
            [...own.apis, ...response, ...resp].filter((value, index, array) => array.indexOf(value) === index),
          ),
        )
        if (checkIfProfileAccessPresent('OTHERS', self.onboarding.profilesaccesslist)) {
          console.log('===> profilesaccesslist includes OTHERS so setting all selected')
          self.apis.map((api) => {
            if (api.profileName === 'OTHERS') {
              api.isSelected = true
            }
            return api
          })
        }
      } catch (error) {
        console.log('fetchOthersApiConfig error', error)
      }
      return response
    }),
    fetchApiMappingListOfChannelId: flow(function* fetchApiMappingListOfChannelId(
      channelId: string,
      profileName: string,
    ) {
      const own = self
      let response
      try {
        response = yield fetchApiMappingListOfChannelIdReq(channelId, profileName, RootStore.session.getTokens)
        if (response) {
          own.apiaccesslist = JSON.parse(JSON.stringify([...own.apiaccesslist, ...response]))
        }
        console.log('apiaccesslist', JSON.parse(JSON.stringify(own.apiaccesslist)))
      } catch (error) {
        console.log('fetchApiMappingListOfChannelId error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    syncWithMas: flow(function* syncWithMas(data: any) {
      let response
      self.onboarding.isSyncDone = false
      try {
        response = yield syncWithMasReq(data, RootStore.session.getTokens)
        console.log('syncWithMas before update', JSON.parse(JSON.stringify(self.onboarding.searchEntity)))
        self.onboarding.searchEntity.map((entity) => {
          if (entity.identificationNumber === data?.identificationNumber && response !== null) {
            // entity = response?.data
            entity.entity.businessName = response?.data?.businessName
            entity.entity.legalName = response?.data?.legalName
            entity.addressDetails = response?.data?.addressDetails
            entity.entity.addressDetails = response?.data?.addressDetails
            entity.businessProfile = response?.data?.businessProfile
            entity.entity.businessProfile = response?.data?.businessProfile
            entity.contactDetails = response?.data?.contactDetails
            entity.entity.contactDetails = response?.data?.contactDetails
            entity.feePackageDetails = response?.data?.feePackageDetails
            entity.entity.feePackageDetails = response?.data?.feePackageDetails
            entity.gstDetails = response?.data?.gstDetails
            entity.entity.gstDetails = response?.data?.gstDetails
            entity.settlementDetails = response?.data?.settlementDetails
            entity.entity.settlementDetails = response?.data?.settlementDetails
            entity.terminalDetails = response?.data?.terminalDetails
            entity.entity.terminalDetails = response?.data?.terminalDetails
            entity.programCategoryDetails = response?.data?.programCategoryDetails
            entity.entity.programCategoryDetails = response?.data?.programCategoryDetails
            entity.vpaDetails = response?.data?.vpaDetails
            entity.entity.vpaDetails = response?.data?.vpaDetails
            return entity
          }
        })
        console.log('syncWithMas post update', JSON.parse(JSON.stringify(self.onboarding.searchEntity)))
      } catch (error) {
        console.log('syncWithMas error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    updateEntity: flow(function* updateEntity(identificationNumber: string, dataToUpdate: string, data: any) {
      let response
      let request = {}
      try {
        self.onboarding.searchEntity.map((entity) => {
          if (entity.identificationNumber === identificationNumber) {
            request = {
              identificationNumber: identificationNumber,
              source: entity.entity?.source,
              type: entity.entity?.type,
              ...(dataToUpdate === 'businessProfile' && data && { ...data }),
              ...(dataToUpdate === 'contactDetails' && { [dataToUpdate]: data }),
            }
          }
        })
        response = yield updateEntityReq(request, RootStore.session.getTokens)
        self.onboarding.searchEntity.map((entityData) => {
          if (entityData.identificationNumber === response?.data?.identificationNumber) {
            if (dataToUpdate === 'contactDetails') {
              entityData.entity.contactDetails = response?.data?.contactDetails
            }
            if (dataToUpdate === 'businessProfile') {
              entityData.entity.businessProfile = response?.data?.businessProfile
            }
            return entityData
          }
          return entityData
        })
        if (response && response?.data && response?.data?.identificationNumber) {
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
        }
        console.log('updateEntity response', response)
      } catch (error) {
        console.log('updateEntity error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    updateGroupCamunda: flow(function* updateGroupCamunda(
      identificationNumber: string,
      dataToUpdate: string,
      data: any,
    ) {
      let response
      let request = {}
      try {
        if (self.onboarding.group.identificationNumber === identificationNumber) {
          request = {
            identificationNumber: identificationNumber,
            type: 'GROUP',
            ...(dataToUpdate === 'businessProfile' && data && { ...data }),
            ...(dataToUpdate === 'contactDetails' && { [dataToUpdate]: data }),
          }
        }
        response = yield updateGroupCamundaReq(request, RootStore.session.getTokens)
        self.onboarding.searchEntity.map((entity) => {
          if (entity.identificationNumber === response?.data?.identificationNumber) {
            entity = response?.data
            return entity
          }
        })
        if (response && response?.data && response?.data?.identificationNumber) {
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
        }
        console.log('updateGroupCamunda response', response)
        return response
      } catch (error) {
        console.log('updateGroupCamunda error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    updateSubGroupCamunda: flow(function* updateSubGroupCamunda(
      identificationNumber: string,
      dataToUpdate: string,
      data: any,
    ) {
      let response
      let request = {}
      try {
        if (self.onboarding.group.identificationNumber === identificationNumber) {
          request = {
            identificationNumber: identificationNumber,
            type: 'SUBGROUP',
            ...(dataToUpdate === 'businessProfile' && data && { ...data }),
            ...(dataToUpdate === 'contactDetails' && { [dataToUpdate]: data }),
          }
        }
        response = yield updateSubGroupCamundaReq(request, RootStore.session.getTokens)
        self.onboarding.searchEntity.map((entity) => {
          if (entity.identificationNumber === response?.data?.identificationNumber) {
            entity = response?.data
            return entity
          }
        })
        if (response && response?.data && response?.data?.identificationNumber) {
          RootStore.message.setMessage('Updated Successfully', MessageTypes.SUCCESS)
        }
        console.log('updateSubGroupCamunda response', response)
        return response
      } catch (error) {
        console.log('updateSubGroupCamunda error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    getIndividualApiAccessList() {
      let listdata: any[] = []

      self.apis.map((api) => {
        self.apiaccesslist.map((apiacces) => {
          if (api.apiId === apiacces.apiId && apiacces.status === 'ACTIVE') {
            api.isSelected = true
            listdata.push(api)
          }
        })
        return api
      })

      const pcisLength = self.apis.filter((api) => api.profileName === 'PCI_MERCHANT').length
      const selectedPciLength = self.apis
        .filter((api) => api.profileName === 'PCI_MERCHANT')
        .filter((other) => other.isSelected === true).length

      if (pcisLength > 0 && !self.onboarding.isAllPciSelected && pcisLength === selectedPciLength) {
        self.onboarding.isAllPciSelected = true
      }

      const nonPcisLength = self.apis.filter((api) => api.profileName === 'NON_PCI_MERCHANT').length
      const selectedNonPciLength = self.apis
        .filter((api) => api.profileName === 'NON_PCI_MERCHANT')
        .filter((other) => other.isSelected === true).length
      if (
        nonPcisLength > 0 &&
        !self.onboarding.isAllCommonPciNonPciSelected &&
        nonPcisLength === selectedNonPciLength
      ) {
        self.onboarding.isAllCommonPciNonPciSelected = true
      }

      const emisLength = self.apis.filter((api) => api.profileName === 'EMI').length
      const selectedEmiLength = self.apis
        .filter((api) => api.profileName === 'EMI')
        .filter((other) => other.isSelected === true).length
      if (emisLength > 0 && !self.onboarding.isAllEmisSelected && emisLength === selectedEmiLength) {
        self.onboarding.isAllEmisSelected = emisLength === selectedEmiLength
      }

      const othersLength = self.apis.filter((api) => api.profileName === 'OTHERS').length
      const selectedOthersLength = self.apis
        .filter((api) => api.profileName === 'OTHERS')
        .filter((other) => other.isSelected === true).length
      if (othersLength > 0 && !self.onboarding.isAllOthersSelected && othersLength === selectedOthersLength) {
        self.onboarding.isAllOthersSelected = true
      }

      console.log('===> getIndividualApiAccessList: ', JSON.parse(JSON.stringify(listdata)))
      return listdata
    },

    saveApiConfigurations: flow(function* saveApiConfigurations() {
      try {
        //===> start newly Selected Apis to be created in api mapping
        const creatableApisList = (self as any).getAllCreatableApisList()
        const othersProducerChannelIds = getOthersProducerChannelIds()

        //For Others only individual api access no profile access
        if (othersProducerChannelIds.length > 0) {
          try {
            othersProducerChannelIds.map((otherProducerChannelId) => {
              const selectedApiListLinkedToProducer = creatableApisList.filter(
                (api: any) => api.channelId === otherProducerChannelId && api.isSelected,
              )
              if (selectedApiListLinkedToProducer.length > 0) {
                ;(self as any).createNewApiMapping(
                  selectedApiListLinkedToProducer,
                  otherProducerChannelId,
                  self.onboarding.getOwnChannelId(),
                )
              }
            })
          } catch (e) {
            console.log('===> creatableApisList othersProducerChannelIds failed')
          }
        }

        if (creatableApisList.length > 0) {
          try {
            const selectedPciApis = creatableApisList.filter(
              (api: any) => api.channelId === '8008' && api.isSelected && api.profileName === 'PCI_MERCHANT',
            )

            const pciApis = self.apis.filter(
              (api: any) => api.channelId === '8008' && api.profileName === 'PCI_MERCHANT',
            )

            if (selectedPciApis.length !== pciApis?.length) {
              if (checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
                ;(self as any).updateProfileStatus(self.onboarding.getOwnChannelId(), 2, 'PCI_MERCHANT')
              } else {
                if (selectedPciApis?.length > 0) {
                  ;(self as any).createNewApiMapping(selectedPciApis, '8008', self.onboarding.getOwnChannelId())
                }
              }
            } else if (
              selectedPciApis.length !== 0 &&
              pciApis?.length !== 0 &&
              selectedPciApis.length === pciApis?.length
            ) {
              ;(self as any).createApiMappingByProfileName('PCI_MERCHANT', '8008', self.onboarding.getOwnChannelId())
            }
          } catch (e) {
            console.log('===> creatableApisList selected PciApis failed')
          }

          try {
            const selectedNonPciApis = creatableApisList.filter(
              (api: any) => api.channelId === '8008' && api.isSelected && api.profileName === 'NON_PCI_MERCHANT',
            )

            const nonPciApis = self.apis.filter(
              (api: any) => api.channelId === '8008' && api.profileName === 'NON_PCI_MERCHANT',
            )

            if (selectedNonPciApis.length !== nonPciApis?.length) {
              if (checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
                ;(self as any).updateProfileStatus(self.onboarding.getOwnChannelId(), 2, 'NON_PCI_MERCHANT')
              } else {
                if (selectedNonPciApis?.length > 0) {
                  ;(self as any).createNewApiMapping(selectedNonPciApis, '8008', self.onboarding.getOwnChannelId())
                }
              }
            } else if (
              selectedNonPciApis.length !== 0 &&
              nonPciApis?.length !== 0 &&
              selectedNonPciApis.length === nonPciApis?.length
            ) {
              ;(self as any).createApiMappingByProfileName(
                'NON_PCI_MERCHANT',
                '8008',
                self.onboarding.getOwnChannelId(),
              )
            }
          } catch (e) {
            console.log('===> creatableApisList selected NonPciApis failed')
          }

          try {
            const selectedEmiApis = creatableApisList.filter(
              (api: any) => api.channelId === '394575653479' && api.isSelected && api.profileName === 'EMI',
            )

            const emiApis = self.apis.filter(
              (api: any) => api.channelId === '394575653479' && api.profileName === 'EMI',
            )
            if (selectedEmiApis.length !== emiApis?.length) {
              if (checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
                ;(self as any).updateProfileStatus(self.onboarding.getOwnChannelId(), 2, 'EMI')
              } else {
                if (selectedEmiApis?.length > 0) {
                  ;(self as any).createNewApiMapping(selectedEmiApis, '394575653479', self.onboarding.getOwnChannelId())
                }
              }
            } else if (
              selectedEmiApis.length !== 0 &&
              emiApis?.length !== 0 &&
              selectedEmiApis.length === emiApis?.length
            ) {
              ;(self as any).createApiMappingByProfileName('EMI', '394575653479', self.onboarding.getOwnChannelId())
            }
          } catch (e) {
            console.log('===> creatableApisList selected EmiApis  failed')
          }
        }
        // <=== ends newly Selected Apis to be created in api mapping

        // ===> start update api's with active/inactive which already had access
        try {
          const updateList = (self as any).getAllUpdateableApisList()

          if (updateList?.length > 0) {
            //PCI CASE to
            const pciApis = updateList.filter(
              (api: any) => api.channelId === '8008' && api.profileName === 'PCI_MERCHANT',
            )

            const selectedPciApis = updateList.filter(
              (api: any) => api.channelId === '8008' && api.isSelected && api.profileName === 'PCI_MERCHANT',
            )

            const nonPciApis = updateList.filter(
              (api: any) => api.channelId === '8008' && api.profileName === 'NON_PCI_MERCHANT',
            )

            const selectedNonPciApis = updateList.filter(
              (api: any) => api.channelId === '8008' && api.isSelected && api.profileName === 'NON_PCI_MERCHANT',
            )

            const selectedEmiApis = updateList.filter(
              (api: any) => api.channelId === '394575653479' && api.isSelected && api.profileName === 'EMI',
            )

            const emiApis = updateList.filter(
              (api: any) => api.channelId === '394575653479' && api.profileName === 'EMI',
            )

            const selectedOthersMTSApis = updateList.filter(
              (api: any) => api.channelId === '383833526050' && api.isSelected && api.profileName === 'OTHERS',
            )

            const othersMTSApis = updateList.filter(
              (api: any) => api.channelId === '383833526050' && api.profileName === 'OTHERS',
            )

            const selectedOthersDMMApis = updateList.filter(
              (api: any) => api.channelId === '317760582155' && api.isSelected && api.profileName === 'OTHERS',
            )

            const othersDMMApis = updateList.filter(
              (api: any) => api.channelId === '317760582155' && api.profileName === 'OTHERS',
            )

            if (pciApis?.length !== selectedPciApis.length) {
              if (checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
                ;(self as any).updateProfileStatus(self.onboarding.getOwnChannelId(), 2, 'PCI_MERCHANT')
              } else {
                ;(self as any).updateSelectedApisStatus(pciApis, self.onboarding.getOwnChannelId())
              }
            }

            if (nonPciApis?.length !== selectedNonPciApis.length) {
              if (checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
                ;(self as any).updateProfileStatus(self.onboarding.getOwnChannelId(), 2, 'NON_PCI_MERCHANT')
              } else {
                ;(self as any).updateSelectedApisStatus(nonPciApis, self.onboarding.getOwnChannelId())
              }
            }
            if (emiApis?.length !== selectedEmiApis.length) {
              if (checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
                ;(self as any).updateProfileStatus(self.onboarding.getOwnChannelId(), 2, 'EMI')
              } else {
                ;(self as any).updateSelectedApisStatus(emiApis, self.onboarding.getOwnChannelId())
              }
            }
            // else {
            //   const resp = yield updatApisStatusReq(
            //     updateList,
            //     self.onboarding.getOwnChannelId(),
            //     RootStore.session.getTokens,
            //   )
            //   console.log('updateProfileMapping response', resp)
            // }

            let othersCollaboratedApis = []
            if (selectedOthersMTSApis?.length !== othersMTSApis?.length) {
              othersCollaboratedApis = othersMTSApis
              // ;(self as any).updateSelectedApisStatus(othersMTSApis, self.onboarding.getOwnChannelId())
            }
            if (selectedOthersDMMApis?.length !== othersDMMApis?.length) {
              othersCollaboratedApis = [...othersCollaboratedApis, ...othersDMMApis]
              // ;(self as any).updateSelectedApisStatus(othersDMMApis, self.onboarding.getOwnChannelId())
            }
            if (othersCollaboratedApis?.length > 0) {
              ;(self as any).updateSelectedApisStatus(othersCollaboratedApis, self.onboarding.getOwnChannelId())
            }
          }
        } catch (e) {
          console.log('===> getAllUpdateableApisList updateList failed')
        }
        // <=== end update api's with active/inactive which already had access

        // TODO: check below if needed
        // const createableProfileChannelList = (self as any).getCreateableProfileChannelIds(self.onboarding.getOwnChannelId())
        // yield (self as any).createNewMultipleApiMapping(createableProfileChannelList)

        //Not needed
        // const updateProfData = (self as any).getUpdateableProfileList(self.onboarding.getOwnChannelId())
        // yield (self as any).updateProfileAccess(updateProfData)

        console.log('getAccessRevokedIndividualApis', (self as any).getAccessRevokedIndividualApis())
        self.isApiConfigSaveCallDone = true
      } catch (error) {
        console.log('saveApiConfigurations error', error)
      }
    }),
    updateContactProfilesFromSearch(identificationNumber: string, index: number, key: string, value: string) {
      self.onboarding.searchEntity.map((entity) => {
        if (entity.identificationNumber === identificationNumber) {
          if (entity && entity.entity && entity.entity.contactDetails && entity.entity.contactDetails.length > 0) {
            if (
              key === 'addressLine1' ||
              key === 'addressLine2' ||
              key === 'city' ||
              key === 'state' ||
              key === 'pincode' ||
              key === 'countryCode' ||
              key === 'groupContactAddressKey'
            ) {
              if (entity.entity.contactDetails[index].entityContactAddress !== null) {
                entity.entity.contactDetails[index].entityContactAddress[key] = value
              } else {
                entity.entity.contactDetails[index].entityContactAddress = EntityContactAddress.create({
                  addressLine1: null,
                  addressLine2: null,
                  addressType: null,
                  city: null,
                  state: null,
                  pincode: null,
                  countryCode: null,
                  groupContactAddressKey: null,
                })
                entity.entity.contactDetails[index].entityContactAddress[key] = value
              }
            } else {
              entity.entity.contactDetails[index][key] = value
            }
            return entity
          }
        }
      })
    },
    updateContactOfGroupSubGroup(identificationNumber: string, groupContactindex: number, key: string, value: string) {
      if (self.onboarding.group.identificationNumber === identificationNumber) {
        self.onboarding.group?.groupContacts?.map((groupContact, index) => {
          if (index === groupContactindex && groupContact) {
            groupContact[key] = value
          }
          return groupContact
        })
      }
    },
    getInstrumentsListWithSearch(type: string, search: string, isAllChecked: boolean) {
      console.log('===> getInstrumentsListWithSearch: ', type, isAllChecked)
      let data: any[] = []
      if (type === `${PAYMENT_MODE_SUBTYPES.NB}`) {
        self.onboarding.merchant.preferences.bankList.map((bank) => {
          // const isSelected = getIsCheckedFromSearchConfig(bank, self.onboarding.configList)
          data.push({
            id: bank.id,
            text: bank.name,
            imageUrl: bank.logo,
            type: bank.type,
            isSelected: isAllChecked ? isAllChecked : bank.isSelected,
          })
          // const updatedBank = {
          //   ...bank,
          //   isSelected: isSelected,
          // }
          // return updatedBank
        })
      } else if (type === `${PAYMENT_MODE_SUBTYPES.WALLET}`) {
        self.onboarding.merchant.preferences.walletList.map((wallet) => {
          // const isSelected = getIsCheckedFromSearchConfig(wallet, self.onboarding.configList)

          data.push({
            id: wallet.id,
            text: wallet.name,
            imageUrl: wallet.logo,
            type: wallet.type,
            isSelected: isAllChecked ? isAllChecked : wallet.isSelected,
          })
          // return {
          //   ...wallet,
          //   isSelected: isSelected,
          // }
        })
      } else if (type === `${PAYMENT_MODE_SUBTYPES.PAYLATER}`) {
        self.onboarding.merchant.preferences.payLaterList.map((paylater) => {
          // const isSelected = getIsCheckedFromSearchConfig(paylater, self.onboarding.configList)

          data.push({
            id: paylater.id,
            text: paylater.name,
            imageUrl: paylater.logo,
            type: paylater.type,
            isSelected: isAllChecked ? isAllChecked : paylater.isSelected,
          })
          // return {
          //   ...paylater,
          //   isSelected: isSelected,
          // }
        })
      } else if (type === `${PAYMENT_MODE_SUBTYPES.CORP_NB}`) {
        self.onboarding.merchant.preferences.corpBankList.map((bank) => {
          data.push({
            id: bank.id,
            text: bank.name,
            imageUrl: bank.logo,
            type: bank.type,
            isSelected: isAllChecked ? isAllChecked : bank.isSelected,
          })
        })
      }

      const sData = data
        .filter((item) => item !== undefined)
        .filter((item) => item?.text?.toLowerCase()?.includes(search?.toLowerCase()))
      return search.length > 0 ? sData : data.filter((item) => item !== undefined)
    },
    getPaymentsInstrumentsList: flow(function* getPaymentsInstrumentsList(instrumentTypeArr: any[]) {
      let nbResponse, walletResponse, payLaterResponse, corpNbResponse
      try {
        nbResponse = yield getPaymentsInstruments(instrumentTypeArr[0], RootStore.session.getTokens)
        if (instrumentTypeArr[0] === PAYMENT_MODE_SUBTYPES.NB) {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            bankList: nbResponse,
          }
        }
      } catch (error) {
        console.log('getPaymentsInstrumentsList error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }

      try {
        walletResponse = yield getPaymentsInstruments(instrumentTypeArr[1], RootStore.session.getTokens)
        if (instrumentTypeArr[1] === PAYMENT_MODE_SUBTYPES.WALLET) {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            walletList: walletResponse,
          }
        }
      } catch (error) {
        console.log('getPaymentsInstrumentsList error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }

      try {
        payLaterResponse = yield getPaymentsInstruments(instrumentTypeArr[2], RootStore.session.getTokens)
        if (instrumentTypeArr[2] === PAYMENT_MODE_SUBTYPES.PAYLATER) {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            payLaterList: payLaterResponse,
          }
        }
      } catch (error) {
        console.log('getPaymentsInstrumentsList error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }

      try {
        corpNbResponse = yield getPaymentsInstruments(instrumentTypeArr[3], RootStore.session.getTokens)
        if (instrumentTypeArr?.[3] === PAYMENT_MODE_SUBTYPES.CORP_NB) {
          self.onboarding.merchant.preferences = {
            ...self.onboarding.merchant.preferences,
            corpBankList: corpNbResponse,
          }
        }
      } catch (error) {
        console.log('getPaymentsInstrumentsList error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      console.log('getPaymentsInstrumentsList', nbResponse, walletResponse, payLaterResponse)
      return nbResponse || walletResponse || payLaterResponse
    }),
    getCardSchemesList: flow(function* getCardSchemesList() {
      let response
      try {
        response = yield getCardSchemesListApi(RootStore.session.getTokens)
        self.onboarding.cardList = response
      } catch (error) {
        console.log('getCardSchemesList error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    resetRemovableConfigs() {
      self.onboarding.deletedchannelIds = []
      self.onboarding.deletedConfigList = []
      self.onboarding.deletedEntityConfigs = []
    },
    resetNewCreatableConfig() {
      self.onboarding.addedchannelIds = []
      self.onboarding.createdConfigList = []
      self.onboarding.createdEntityConfigs = []
    },
    resetUpdatableConfig() {
      self.onboarding.updateConfigList = []
      self.onboarding.updatedEntityConfigs = []
    },
    resetSearchEntity() {
      self.onboarding.searchEntity = JSON.parse(JSON.stringify([]))
    },
    fetchMccProgramDetails: flow(function* fetchMccProgramDetails(mccCode: string, businessLine: string) {
      let response
      try {
        response = yield getBizProgDetailsFromMccCode(mccCode, businessLine, RootStore.session.getTokens)
        console.log('fetchMccProgramDetails response', response)
        const retData = self.onboarding.businessCategoryMccCodeList.map((item) => {
          if (item.businessLine === response.businessLine) {
            return response
          } else {
            return item
          }
        })
        self.onboarding.businessCategoryMccCodeList = JSON.parse(JSON.stringify(retData))
      } catch (error) {
        console.log('fetchMccProgramDetails error', error)
        RootStore.message.setMessage(error?.data?.message, MessageTypes.ERROR)
      }
      return response
    }),
    fetchAllBankDetailsByIFSC: flow(function* fetchAllBankDetailsByIFSC(ifscCode: string) {
      let response
      try {
        response = yield getAllBankDetailsByIFSC(ifscCode, RootStore.session.getTokens)
        console.log('fetchAllBankDetailsByIFSC response', response)
      } catch (error) {
        console.log('fetchAllBankDetailsByIFSC error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
      }
      return response
    }),
    fetchPincodeData: flow(function* fetchPincodeData(pincode: string) {
      let response
      try {
        response = yield getPincodeData(pincode, RootStore.session.getTokens)
        console.log('getPincodeData response', response)
      } catch (error) {
        console.log('getPincodeData error', error)
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchProgramCategoryDetails: flow(function* fetchProgramCategoryDetails(programId: string, ownerShipType: string) {
      let response
      try {
        response = yield getProgramCategoryDetails(
          programId,
          (self as any).getLovValueForDescription('OwnershipType', ownerShipType),
          RootStore.session.getTokens,
        )
        self.onboarding.programDetails = response
        console.log('fetchProgramCategoryDetails response', response)
      } catch (error) {
        console.log('fetchProgramCategoryDetails error', error)
        if (error?.data?.code !== 400017) {
          RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        }
      }
      return response
    }),
    fetchKycDocCategories: flow(function* fetchKycDocCategories(reqBody: any, showError: boolean = true) {
      let response
      try {
        if (reqBody?.kycId !== 'ALL' && self.documentCategories.length > 0) {
          const reqDocCategory = reqBody.documentCategory
          const response = self.documentCategories
            .filter((item) => item.documentCategories.includes(reqDocCategory))
            .map((item) => ({ key: item.key, value: item.value }))
          return response
        }
        response = yield getKycDocumentCategoriesLov(reqBody, RootStore.session.getTokens)
        if (reqBody?.kycId === 'ALL') {
          self.documentCategories = response
        }
        console.log('fetchKycDocCategories response', response)
      } catch (error) {
        console.log('fetchKycDocCategories error', error)
        showError && RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
      return response
    }),
    fetchProgramDetailsByIds: flow(function* fetchProgramDetailsByIds(programIds: any[]) {
      let response
      try {
        response = yield getProgramDetailsByProgramIds(programIds, RootStore.session.getTokens)
        self.onboarding.programDetails = response
        console.log('fetchProgramDetailsByIds response', response)
      } catch (error) {
        console.log('fetchProgramDetailsByIds error', error)
        // if (error?.data?.code !== 400017) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        // }
      }
      return response
    }),
    searchMid: flow(function* searchMid(mid: string, searchBy: string, fetchQuery: string, abortController?: any) {
      let response
      const traceId = generateRandomString(20)
      try {
        const pageNumber = self.pagination.number === 0 ? 1 : self.pagination.number
        const size = self.pagination.size < 5 ? 5 : self.pagination.size
        response = yield fetchSearchEntityReq(
          mid,
          searchBy,
          pageNumber,
          size,
          RootStore.session.getTokens,
          fetchQuery,
          traceId,
          abortController,
        )
        if (response instanceof Object) {
          const merchantDetails = response?.findEntity?.entitySearchList?.[0]?.entity
          return merchantDetails
        } else {
          RootStore.message.setMessage(response, MessageTypes.ERROR)
          throw response
        }
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error) ?? error?.message, MessageTypes.ERROR)
        throw error
      }
    }),
    kycFetchUploadId: flow(function* kycFetchUploadId() {
      self.onboarding.uploadId = ''
      let uploadId
      try {
        uploadId = yield kycGetUploadId(RootStore.session.getTokens)
        self.onboarding.uploadId = uploadId?.uploadId
        return uploadId
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    kycUploadFile: flow(function* kycUploadFile(
      file: any,
      documentCategory: string,
      documentNumber: string,
      documentName: string,
      dateOfExpiry: string,
      uploadType: string,
      uploadId: string,
      identificationNumber?: string,
      documentType?: string,
    ) {
      let res
      try {
        res = yield kycUploadDocument(
          file,
          documentCategory,
          documentNumber,
          documentName,
          dateOfExpiry,
          uploadType,
          uploadId,
          RootStore.session.getTokens,
          identificationNumber,
          documentType,
        )
        if (uploadType === 'REDACT' && res?.data?.documentId?.length > 0) {
          self.aadharRedactiondocuments.map((aDoc) => {
            if (aDoc.DOCID === documentNumber) {
              aDoc.DOCUMENTSTATUS = 'REPLACED'
              aDoc.action = 'REPLACE'
              aDoc.DOCID = res?.data?.documentId
              return aDoc
            }
            return aDoc
          })
        } else {
          if (uploadType === 'REDACT') {
            RootStore?.message?.setMessage('Replace failed, please retry', MessageTypes.ERROR)
          }
        }
      } catch (e) {
        RootStore?.message?.setMessage(e?.data?.error?.message, MessageTypes.ERROR)
      }
      return res
    }),
    bulkOnboardUserWithPermission: flow(function* (usersData: any[], delay: number) {
      const errorData: BulkOnnboardResponse[] = []
      for (let i = 0; i < usersData?.length; i++) {
        const user = usersData[i]
        try {
          if (user?.mid !== 'NP') {
            const response = yield createUserWithPermissions(
              user?.mobileNumber,
              user?.firstName,
              user?.lastName,
              user?.email,
              user?.entityId,
              user?.userType,
              user?.permissions,
              RootStore.session.getTokens,
            )
            errorData.push({ status: 'SUCCESS', message: JSON.stringify(response), code: '' })
          } else {
            errorData.push({ status: 'FAILURE', message: 'Grant permission is not allowed', code: '' })
          }
        } catch (e) {
          errorData.push({ status: 'Failure', message: getErrorMessage(e), code: (e as any)?.data?.error?.code ?? '' })
        }
        yield new Promise((r) => setTimeout(r, delay))
      }
      return errorData
    }),
    linkOrDelinkSRQs: flow(function* (srqsDataList: any[], action: 'Link' | 'Delink') {
      const errorData: BulkOnnboardResponse[] = []
      for (let i = 0; i < srqsDataList?.length; i++) {
        const srqsData = srqsDataList[i]
        try {
          const response = yield manageSRQsApi(srqsData, action)
          console.log('htag error ', response)
          errorData.push({ status: 'SUCCESS', message: JSON.stringify(response), code: '' })
        } catch (e) {
          console.log('htag error ', e)
          errorData.push({
            status: 'Failure',
            message: JSON.stringify(e?.data),
            code: (e as any)?.data?.error?.code ?? '',
          })
        }
        yield new Promise((r) => setTimeout(r, 100))
      }
      return errorData
    }),
  }))
  .views((self) => ({
    getAuditTrialsByType(type: string) {
      return self.auditTrials?.filter((audit) => audit?.type === type)
    },
    checkIfAnyDocumentsReplaced() {
      let isReplaced = false
      for (let i = 0; i < self.aadharRedactiondocuments.length; i++) {
        if (self.aadharRedactiondocuments[i].action === 'REPLACE') {
          isReplaced = true
          break
        }
      }
      return isReplaced
    },
    getDocumentDataByFileName(fileName: string) {
      let docUploaded: any = {}
      self.documents.map((doc) => {
        if (doc.NAME === fileName) {
          docUploaded = doc
        }
      })
      return docUploaded
    },
    getNonEditedDocuments(from: string, status: string) {
      let listData: any[] = []
      self.aadharNonEditedRedactiondocuments.map((doc) => {
        listData.push({
          NAME: doc?.NAME,
          MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
          TRANSACTION_ID: doc?.DOCID,
          uploadId: doc?.uploadId,
          DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
        })
      })
      if ((from === 'AD_MAKER' || from === 'AD_CHECKER' || from === 'AD_MAKER_QUEUE') && status !== 'Completed') {
        self.aadharEditedRedactiondocuments.map((eDoc) => {
          for (let i = 0; i < listData?.length; i++) {
            if (
              listData[i]?.TRANSACTION_ID === eDoc?.documentNumber ||
              eDoc?.MERCHANT_DOCUMENT_NAME === listData[i]?.NAME
            ) {
              listData = listData.filter((data) => data.TRANSACTION_ID !== eDoc?.documentNumber)
            }
          }
        })
      }
      return listData
    },
    getEditedDocuments() {
      let listData: any[] = []
      self.aadharEditedRedactiondocuments.map((doc) => {
        listData.push({
          NAME: doc?.NAME,
          MERCHANT_DOCUMENT_TYPE: (self as any).getDocumentTypeFromNonEditedList(doc?.documentNumber),
          RID: doc?.RID,
          oldDocName: doc?.MERCHANT_DOCUMENT_NAME,
          uploadId: doc?.uploadId,
          DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
        })
      })
      return listData
    },
    getDocuments(type: string, applicationStatus: string) {
      let listData: any[] = []
      if (type === 'AD_MAKER') {
        self.aadharRedactiondocuments.map((doc) => {
          listData.push({
            NAME: doc?.NAME,
            MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
            TRANSACTION_ID: doc?.DOCID,
            DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
            ...(doc.action !== 'REPLACE' && { action: '' }),
            ...(doc.action === 'REPLACE' && { deleteOnly: '' }),
          })
        })
      } else if (type === 'AD_CHECKER') {
        self.aadharRedactiondocuments.map((doc) => {
          listData.push({
            NAME: doc?.NAME,
            MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
            TRANSACTION_ID: doc?.DOCID,
            DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
          })
        })
      } else if (type === EmType.Search || (type === EmType.applicationQueue && applicationStatus === 'Completed')) {
        if (type === EmType.Search && self.onboarding.searchFilterBy !== 'SubGroup ID') {
          self.documents.map((doc) => {
            listData.push({
              MERCHANT_DOCUMENT_TYPE: doc?.documentCategory,
              name: getDocumentCategoryName(doc?.documentId, self.documentCategories),
              RID: doc?.documentNumber,
              dateOfExpiry: doc?.dateOfExpiry,
              view_: 'View_View',
            })
          })
        } else {
          self.documents.map((doc) => {
            listData.push({
              NAME: doc?.NAME,
              MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
              TRANSACTION_ID: doc?.DOCID,
              DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
            })
          })
        }
      } else {
        self.documents.map((doc) => {
          listData.push({
            NAME: doc?.NAME,
            MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
            MERCHANT_DOCUMENT_NAME: doc?.MERCHANT_DOCUMENT_NAME,
            RID: doc?.RID,
            uploadId: doc?.uploadId,
          })
        })
      }
      return listData
    },
    getDevicesFromSearch(entityId: string) {
      let deviceList = []
      self.onboarding.searchEntity.map((entity) => {
        if (entity.identificationNumber === entityId && !!entity.deviceDetails) {
          entity.deviceDetails.map((device) => {
            deviceList.push({
              deviceSerialNo: device.deviceSerialNo,
              deviceStatus: (self as any).getLovsDescriptionFromKeyValue('DeviceStatus', device?.deviceStatus),
            })
          })
        }
      })
      return deviceList
    },
    getKycDocumentsList() {
      let list = []
      self.documents.map((doc) => {
        list.push({
          NAME: doc?.NAME,
          MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
          RID: doc?.RID,
          TRANSACTION_ID: doc?.TRANSACTION_ID,
          DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
        })
      })
      return list
    },
    getKycAadharDocumentsList() {
      let list = []
      if (self.aadharRedactiondocuments?.length > 0) {
        self.aadharRedactiondocuments.map((doc) => {
          if (doc?.action === null || doc?.action === '') {
            list.push({
              NAME: doc?.NAME,
              MERCHANT_DOCUMENT_TYPE: doc?.MERCHANT_DOCUMENT_TYPE,
              DOCUMENTSTATUS: doc?.DOCUMENTSTATUS,
              _replace: '',
            })
          }
        })
      }
      return list
    },
    getPartnersList() {
      return self.onboarding.partners
    },
    checkIfLovsHasThisKey(key: string) {
      return self.lovs.filter((lov) => lov.key === key)?.length > 0
    },
    getProgramIds(selectedEntityId: string) {
      let programIds = []
      self.onboarding.searchEntity.map((entity) => {
        if (entity.identificationNumber === selectedEntityId) {
          if (entity?.entity?.programCategoryDetails?.length > 0) {
            entity?.entity?.programCategoryDetails.map((program) => {
              programIds.push({ programId: program?.programId })
            })
          }
        }
      })
      return programIds
    },
    getProgramIdsFromMasMid() {
      let programIds = []
      if (self.onboarding.entityDetails.programCategoryDetails?.length > 0) {
        self.onboarding.entityDetails.programCategoryDetails.map((program) => {
          programIds.push({ programId: program?.programId })
        })
      }
      return programIds
    },
    getPostUpdateBusinessData(legalName: string, businessName: string) {
      const businessProfile = self.onboarding.businessDetail
      return {
        legalEntityName: !isEmpty(legalName) ? legalName : 'NA',
        businessBrandName: !isEmpty(businessName) ? businessName : 'NA',
        ownershipType: !isEmpty(businessProfile?.ownershipType) ? businessProfile?.ownershipType : 'NA',
        businessChannel: !isEmpty(businessProfile?.businessChannel) ? businessProfile?.businessChannel : 'NA',
        setupLevel: !isEmpty(businessProfile?.setupLevel) ? businessProfile?.setupLevel : 'NA',
        premiseType: !isEmpty(businessProfile?.premiseType) ? businessProfile?.premiseType : 'NA',
        businessPAN: !isEmpty(businessProfile?.businessPAN) ? businessProfile?.businessPAN : 'NA',
        webAddress: !isEmpty(businessProfile?.webAddress) ? businessProfile?.webAddress : 'NA',
        storeType: !isEmpty(businessProfile?.storeType) ? businessProfile?.storeType : 'NA',
        yearsOfBusiness: !isEmpty(businessProfile?.yearsOfBusiness) ? businessProfile?.yearsOfBusiness : 'NA',
        mccCode: !isEmpty(businessProfile?.mccCode) ? businessProfile?.mccCode : 'NA',
        businessCategory: !isEmpty(businessProfile?.businessCategory) ? businessProfile?.businessCategory : 'NA',
        businessLine: !isEmpty(businessProfile?.businessLine) ? businessProfile?.businessLine : 'NA',
        pharmacistName: !isEmpty(businessProfile?.pharmacistName) ? businessProfile?.pharmacistName : 'NA',
        pharmacyCouncilNumber: !isEmpty(businessProfile?.pharmacyCouncilNumber)
          ? businessProfile?.pharmacyCouncilNumber
          : 'NA',
        primaryAddress1: !isEmpty(businessProfile?.primaryAddress1) ? businessProfile?.primaryAddress1 : 'NA',
        primaryAddress2: !isEmpty(businessProfile?.primaryAddress2) ? businessProfile?.primaryAddress2 : 'NA',
        pincode: !isEmpty(businessProfile?.pincode) ? businessProfile?.pincode : 'NA',
        city: !isEmpty(businessProfile?.city) ? businessProfile?.city : 'NA',
        stateUt: !isEmpty(businessProfile?.stateUt) ? businessProfile?.stateUt : 'NA',
        businessLatitude: !isEmpty(businessProfile?.businessLatitude) ? businessProfile?.businessLatitude : 'NA',
        businessLongitude: !isEmpty(businessProfile?.businessLongitude) ? businessProfile?.businessLongitude : 'NA',
        gstCategory: !isEmpty(businessProfile?.gstCategory) ? businessProfile?.gstCategory : 'NA',
        gstDealerCategory: !isEmpty(businessProfile?.gstDealerCategory) ? businessProfile?.gstDealerCategory : 'NA',
        typeOfBusiness: !isEmpty(businessProfile?.typeOfBusiness) ? businessProfile?.typeOfBusiness : 'NA',
        gstNumber: !isEmpty(businessProfile?.gstNumber) ? businessProfile?.gstNumber : 'NA',
        dateOfExpiry: !isEmpty(businessProfile?.dateOfExpiry) ? businessProfile?.dateOfExpiry : 'NA',
        jioGstAcceptanceTs: !isEmpty(businessProfile?.jioGstAcceptanceTs) ? businessProfile?.jioGstAcceptanceTs : 'NA',
        inheritParentFeePackage: !isEmpty(businessProfile?.inheritParentFeePackage)
          ? businessProfile?.inheritParentFeePackage
          : 'NA',
        feePackageId: !isEmpty(businessProfile?.mdrPackageId) ? businessProfile?.mdrPackageId : 'NA',
        feePackageName: !isEmpty(businessProfile?.mdrPackageDetails) ? businessProfile?.mdrPackageDetails : 'NA',
      }
    },
    getMakerList() {
      return self.makerList
    },
    getFiuMakerList() {
      return self.fiuMakerList
    },
    getAadharRedactionMakerList() {
      return self.aadharRedactionMakerList
    },
    getContactProfilesFromTaskId(applicationId: string) {
      let contactProfiles: any[] = []
      if (self.myCheckerList.filter((maker) => maker.applicationId === applicationId).length > 0) {
        self.myCheckerList.map((checkerRow) => {
          if (checkerRow.applicationId === applicationId) {
            contactProfiles =
              checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                ? checkerRow?.groupContacts
                : checkerRow.contactDetails ?? []
          }
        })
      } else if (self.makerList.filter((maker) => maker.applicationId === applicationId).length > 0) {
        self.makerList.map((checkerRow) => {
          if (checkerRow.applicationId === applicationId) {
            contactProfiles =
              checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                ? checkerRow?.groupContacts
                : checkerRow.contactDetails ?? []
          }
        })
      } else if (self.globalCheckerList.filter((global) => global.applicationId === applicationId).length > 0) {
        self.globalCheckerList.map((checkerRow) => {
          if (checkerRow.applicationId === applicationId) {
            contactProfiles =
              checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                ? checkerRow?.groupContacts
                : checkerRow.contactDetails ?? []
          }
        })
      }
      return contactProfiles
    },
    getBusinessDetailsFromTaskId(applicationId: string) {
      let buzzDetails = {}
      if (self.myCheckerList.filter((maker) => maker.applicationId === applicationId).length > 0) {
        self.myCheckerList.map((checkerRow) => {
          if (checkerRow.applicationId === applicationId) {
            let addressDetailsEntity =
              checkerRow?.source === 'EMS'
                ? checkerRow?.addressDetails?.[0]
                : checkerRow?.addressDetails?.filter((address) => address?.addressRole === 'CRP')?.[0]
            buzzDetails = {
              legalEntityName: checkerRow.legalName,
              businessBrandName: checkerRow?.businessName,
              primaryAddress1:
                checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                  ? checkerRow?.groupAddress?.[0]?.addressLine1
                  : checkerRow?.addressDetails?.[0]?.addressLine1 ?? 'NA',
              primaryAddress2:
                checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                  ? checkerRow?.groupAddress?.[0]?.addressLine2
                  : checkerRow?.addressDetails?.[0]?.addressLine2 ?? 'NA',
              pincode:
                checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                  ? checkerRow?.groupAddress?.[0]?.pincode
                  : checkerRow?.addressDetails?.[0]?.pincode,
              city:
                checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                  ? checkerRow?.groupAddress?.[0]?.city
                  : checkerRow?.addressDetails?.[0]?.city,
              stateUt:
                checkerRow?.type === 'GROUP_ADD' || checkerRow?.requestType === 'GROUP'
                  ? checkerRow?.groupAddress?.[0]?.state
                  : checkerRow?.addressDetails?.[0]?.state,
              ...(checkerRow?.type === 'ENTITY_ADD' &&
                checkerRow?.settlementDetails && {
                  settlementDetails: checkerRow?.settlementDetails,
                }),
              ...(checkerRow?.type === 'ENTITY_ADD' && {
                ownershipType: !isEmpty(checkerRow?.businessProfile?.ownershipType)
                  ? checkerRow?.businessProfile?.ownershipType
                  : 'NA',
                businessChannel: !isEmpty(checkerRow?.businessProfile?.businessChannel)
                  ? checkerRow?.businessProfile?.businessChannel
                  : 'NA',
                setupLevel: !isEmpty(checkerRow?.businessProfile?.setUpLevel)
                  ? checkerRow?.businessProfile?.setUpLevel
                  : 'NA',
                premiseType: !isEmpty(checkerRow?.businessProfile?.premiseType)
                  ? checkerRow?.businessProfile?.premiseType
                  : 'NA',
                businessPAN: !isEmpty(checkerRow?.businessProfile?.businessPan)
                  ? checkerRow?.businessProfile?.businessPan
                  : 'NA',
                webAddress: !isEmpty(checkerRow?.businessProfile?.webAddress)
                  ? checkerRow?.businessProfile?.webAddress
                  : 'NA',
                storeType: !isEmpty(checkerRow?.businessProfile?.storeType)
                  ? checkerRow?.businessProfile?.storeType
                  : 'NA',
                yearsOfBusiness: !isEmpty(checkerRow?.businessProfile?.yearsInBusiness)
                  ? checkerRow?.businessProfile?.yearsInBusiness
                  : 'NA',
                dailyTransactionValue: !isEmpty(checkerRow?.businessProfile?.dailyTransactionValue)
                  ? checkerRow?.businessProfile?.dailyTransactionValue
                  : 'NA',
                dailyTransactionVolume: !isEmpty(checkerRow?.businessProfile?.dailyTransactionVolume)
                  ? checkerRow?.businessProfile?.dailyTransactionVolume
                  : 'NA',
                merchantOtpDate: !isEmpty(checkerRow?.merchantOtpDate) ? checkerRow?.merchantOtpDate : 'NA',
                deviceOtpDate: !isEmpty(checkerRow?.deviceOtpDate) ? checkerRow?.deviceOtpDate : 'NA',
                mccCode: !isEmpty(checkerRow?.businessProfile?.mccCode) ? checkerRow?.businessProfile?.mccCode : 'NA',
                businessCategory: !isEmpty(checkerRow?.businessProfile?.businessCategory)
                  ? checkerRow?.businessProfile?.businessCategory
                  : self.onboarding.businessDetail.businessCategory ?? 'NA',
                businessLine: !isEmpty(checkerRow?.businessProfile?.businessLine)
                  ? checkerRow?.businessProfile?.businessLine
                  : self.onboarding.businessDetail.businessLine ?? 'NA',
                pharmacistName: !isEmpty(checkerRow?.businessProfile?.pharmacistName)
                  ? checkerRow?.businessProfile?.pharmacistName
                  : 'NA',
                pharmacyCouncilNumber: !isEmpty(checkerRow?.businessProfile?.pharmacyCouncilNumber)
                  ? checkerRow?.businessProfile?.pharmacyCouncilNumber
                  : 'NA',
                primaryAddress1: !isEmpty(addressDetailsEntity?.addressLine1)
                  ? addressDetailsEntity?.addressLine1
                  : 'NA',
                primaryAddress2: !isEmpty(addressDetailsEntity?.addressLine2)
                  ? addressDetailsEntity?.addressLine2
                  : 'NA',
                pincode: !isEmpty(addressDetailsEntity?.pincode) ? addressDetailsEntity?.pincode : 'NA',
                city: !isEmpty(addressDetailsEntity?.city) ? addressDetailsEntity?.city : 'NA',
                stateUt: !isEmpty(addressDetailsEntity?.state) ? addressDetailsEntity?.state : 'NA',
                businessLatitude: !isEmpty(addressDetailsEntity?.latitude) ? addressDetailsEntity?.latitude : 'NA',
                businessLongitude: !isEmpty(addressDetailsEntity?.longitude) ? addressDetailsEntity?.longitude : 'NA',
                gstCategory: !isEmpty(checkerRow?.gstDetails?.merchantCategory)
                  ? checkerRow?.gstDetails?.merchantCategory
                  : 'NA',
                gstDealerCategory: !isEmpty(checkerRow?.gstDetails?.dealerCategory)
                  ? checkerRow?.gstDetails?.dealerCategory
                  : 'NA',
                typeOfBusiness: !isEmpty(checkerRow?.gstDetails?.typeOfBusiness)
                  ? checkerRow?.gstDetails?.typeOfBusiness
                  : 'NA',
                gstNumber: !isEmpty(checkerRow?.gstDetails?.gstin) ? checkerRow?.gstDetails?.gstin : 'NA',
                dateOfExpiry: !isEmpty(checkerRow?.gstDetails?.dateOfExpiry)
                  ? checkerRow?.gstDetails?.dateOfExpiry
                  : 'NA',
                jioGstAcceptanceTs: !isEmpty(checkerRow?.gstDetails?.jioGST) ? checkerRow?.gstDetails?.jioGST : 'NA',
                inheritParentFeePackage: !isEmpty(checkerRow?.feePackageDetails?.inheritParentFeePackage)
                  ? checkerRow?.feePackageDetails?.inheritParentFeePackage
                  : 'NA',
                feePackageId: !isEmpty(checkerRow?.feePackageDetails?.feePkgId)
                  ? checkerRow?.feePackageDetails?.feePkgId
                  : 'NA',
                feePackageName: !isEmpty(checkerRow?.feePackageDetails?.feePackageName)
                  ? checkerRow?.feePackageDetails?.feePackageName
                  : 'NA',
                programCategoryDetails: checkerRow?.programCategoryDetails,
                country: !isEmpty(addressDetailsEntity?.countryCode)
                  ? (self as any).getLovsDescriptionFromKeyValue('Country', addressDetailsEntity?.countryCode)
                  : 'NA',
              }),
            }
          }
        })
      } else if (self.makerList.filter((maker) => maker.applicationId === applicationId).length > 0) {
        self.makerList.map((maker) => {
          if (maker.applicationId === applicationId) {
            let addressDetailsEntity =
              maker?.source === 'EMS'
                ? maker?.addressDetails?.[0]
                : maker?.addressDetails?.filter((address) => address?.addressRole === 'CRP')?.[0]
            buzzDetails = {
              legalEntityName: maker.legalName,
              businessBrandName: maker?.businessName,
              primaryAddress1:
                maker?.type === 'GROUP_ADD' || maker?.requestType === 'GROUP'
                  ? maker?.groupAddress?.[0]?.addressLine1
                  : maker?.addressDetails?.[0]?.addressLine1 ?? 'NA',
              primaryAddress2:
                maker?.type === 'GROUP_ADD' || maker?.requestType === 'GROUP'
                  ? maker?.groupAddress?.[0]?.addressLine2
                  : maker?.addressDetails?.[0]?.addressLine2 ?? 'NA',
              pincode:
                maker?.type === 'GROUP_ADD' || maker?.requestType === 'GROUP'
                  ? maker?.groupAddress?.[0]?.pincode
                  : maker?.addressDetails?.[0]?.pincode,
              city:
                maker?.type === 'GROUP_ADD' || maker?.requestType === 'GROUP'
                  ? maker?.groupAddress?.[0]?.city
                  : maker?.addressDetails?.[0]?.city,
              stateUt:
                maker?.type === 'GROUP_ADD' || maker?.requestType === 'GROUP'
                  ? maker?.groupAddress?.[0]?.state
                  : maker?.addressDetails?.[0]?.state,
              ...(maker?.type === 'ENTITY_ADD' &&
                maker?.settlementDetails && {
                  settlementDetails: maker?.settlementDetails,
                }),
              ...(maker?.type === 'ENTITY_ADD' && {
                ownershipType: !isEmpty(maker?.businessProfile?.ownershipType)
                  ? maker?.businessProfile?.ownershipType
                  : 'NA',
                businessChannel: !isEmpty(maker?.businessProfile?.businessChannel)
                  ? maker?.businessProfile?.businessChannel
                  : 'NA',
                setupLevel: !isEmpty(maker?.businessProfile?.setUpLevel) ? maker?.businessProfile?.setUpLevel : 'NA',
                premiseType: !isEmpty(maker?.businessProfile?.premiseType) ? maker?.businessProfile?.premiseType : 'NA',
                businessPAN: !isEmpty(maker?.businessProfile?.businessPan) ? maker?.businessProfile?.businessPan : 'NA',
                webAddress: !isEmpty(maker?.businessProfile?.webAddress) ? maker?.businessProfile?.webAddress : 'NA',
                storeType: !isEmpty(maker?.businessProfile?.storeType) ? maker?.businessProfile?.storeType : 'NA',
                yearsOfBusiness: !isEmpty(maker?.businessProfile?.yearsInBusiness)
                  ? maker?.businessProfile?.yearsInBusiness
                  : 'NA',
                dailyTransactionValue: !isEmpty(maker?.businessProfile?.dailyTransactionValue)
                  ? maker?.businessProfile?.dailyTransactionValue
                  : 'NA',
                dailyTransactionVolume: !isEmpty(maker?.businessProfile?.dailyTransactionVolume)
                  ? maker?.businessProfile?.dailyTransactionVolume
                  : 'NA',
                merchantOtpDate: !isEmpty(maker?.merchantOtpDate) ? maker?.merchantOtpDate : 'NA',
                deviceOtpDate: !isEmpty(maker?.deviceOtpDate) ? maker?.deviceOtpDate : 'NA',
                mccCode: !isEmpty(maker?.businessProfile?.mccCode) ? maker?.businessProfile?.mccCode : 'NA',
                businessCategory: !isEmpty(maker?.businessProfile?.businessCategory)
                  ? maker?.businessProfile?.businessCategory
                  : self.onboarding.businessDetail.businessCategory ?? 'NA',
                businessLine: !isEmpty(maker?.businessProfile?.businessLine)
                  ? maker?.businessProfile?.businessLine
                  : self.onboarding.businessDetail.businessLine ?? 'NA',
                pharmacistName: !isEmpty(maker?.businessProfile?.pharmacistName)
                  ? maker?.businessProfile?.pharmacistName
                  : 'NA',
                pharmacyCouncilNumber: !isEmpty(maker?.businessProfile?.pharmacyCouncilNumber)
                  ? maker?.businessProfile?.pharmacyCouncilNumber
                  : 'NA',
                primaryAddress1: !isEmpty(addressDetailsEntity?.addressLine1)
                  ? addressDetailsEntity?.addressLine1
                  : 'NA',
                primaryAddress2: !isEmpty(addressDetailsEntity?.addressLine2)
                  ? addressDetailsEntity?.addressLine2
                  : 'NA',
                pincode: !isEmpty(addressDetailsEntity?.pincode) ? addressDetailsEntity?.pincode : 'NA',
                city: !isEmpty(addressDetailsEntity?.city) ? addressDetailsEntity?.city : 'NA',
                stateUt: !isEmpty(addressDetailsEntity?.state) ? addressDetailsEntity?.state : 'NA',
                businessLatitude: !isEmpty(addressDetailsEntity?.latitude) ? addressDetailsEntity?.latitude : 'NA',
                businessLongitude: !isEmpty(addressDetailsEntity?.longitude) ? addressDetailsEntity?.longitude : 'NA',
                gstCategory: !isEmpty(maker?.gstDetails?.merchantCategory) ? maker?.gstDetails?.merchantCategory : 'NA',
                gstDealerCategory: !isEmpty(maker?.gstDetails?.dealerCategory)
                  ? maker?.gstDetails?.dealerCategory
                  : 'NA',
                typeOfBusiness: !isEmpty(maker?.gstDetails?.typeOfBusiness) ? maker?.gstDetails?.typeOfBusiness : 'NA',
                gstNumber: !isEmpty(maker?.gstDetails?.gstin) ? maker?.gstDetails?.gstin : 'NA',
                dateOfExpiry: !isEmpty(maker?.gstDetails?.dateOfExpiry) ? maker?.gstDetails?.dateOfExpiry : 'NA',
                jioGstAcceptanceTs: !isEmpty(maker?.gstDetails?.jioGST) ? maker?.gstDetails?.jioGST : 'NA',
                inheritParentFeePackage: !isEmpty(maker?.feePackageDetails?.inheritParentFeePackage)
                  ? maker?.feePackageDetails?.inheritParentFeePackage
                  : 'NA',
                feePackageId: !isEmpty(maker?.feePackageDetails?.feePkgId) ? maker?.feePackageDetails?.feePkgId : 'NA',
                feePackageName: !isEmpty(maker?.feePackageDetails?.feePackageName)
                  ? maker?.feePackageDetails?.feePackageName
                  : 'NA',
                programCategoryDetails: maker?.programCategoryDetails,
                country: !isEmpty(addressDetailsEntity?.countryCode)
                  ? (self as any).getLovsDescriptionFromKeyValue('Country', addressDetailsEntity?.countryCode)
                  : 'NA',
              }),
            }
          }
        })
      } else if (self.globalCheckerList.filter((global) => global.applicationId === applicationId).length > 0) {
        self.globalCheckerList.map((global) => {
          if (global.applicationId === applicationId) {
            let addressDetailsEntity =
              global?.source === 'EMS'
                ? global?.addressDetails?.[0]
                : global?.addressDetails?.filter((address) => address?.addressRole === 'CRP')?.[0]

            buzzDetails = {
              legalEntityName: global.legalName,
              businessBrandName: global?.businessName,
              primaryAddress1:
                global?.type === 'GROUP_ADD' || global?.requestType === 'GROUP'
                  ? global?.groupAddress?.[0]?.addressLine1
                  : global?.addressDetails?.[0]?.addressLine1 ?? 'NA',
              primaryAddress2:
                global?.type === 'GROUP_ADD' || global?.requestType === 'GROUP'
                  ? global?.groupAddress?.[0]?.addressLine2
                  : global?.addressDetails?.[0]?.addressLine2 ?? 'NA',
              pincode:
                global?.type === 'GROUP_ADD' || global?.requestType === 'GROUP'
                  ? global?.groupAddress?.[0]?.pincode
                  : global?.addressDetails?.[0]?.pincode ?? 'NA',
              city:
                global?.type === 'GROUP_ADD' || global?.requestType === 'GROUP'
                  ? global?.groupAddress?.[0]?.city
                  : global?.addressDetails?.[0]?.city,
              stateUt:
                global?.type === 'GROUP_ADD' || global?.requestType === 'GROUP'
                  ? global?.groupAddress?.[0]?.state
                  : global?.addressDetails?.[0]?.state,

              ...(global?.type === 'ENTITY_ADD' &&
                global?.settlementDetails && {
                  settlementDetails: global?.settlementDetails,
                }),
              ...(global?.type === 'ENTITY_ADD' && {
                ownershipType: !isEmpty(global?.businessProfile?.ownershipType)
                  ? global?.businessProfile?.ownershipType
                  : 'NA',
                businessChannel: !isEmpty(global?.businessProfile?.businessChannel)
                  ? global?.businessProfile?.businessChannel
                  : 'NA',
                setupLevel: !isEmpty(global?.businessProfile?.setUpLevel) ? global?.businessProfile?.setUpLevel : 'NA',
                premiseType: !isEmpty(global?.businessProfile?.premiseType)
                  ? global?.businessProfile?.premiseType
                  : 'NA',
                businessPAN: !isEmpty(global?.businessProfile?.businessPan)
                  ? global?.businessProfile?.businessPan
                  : 'NA',
                webAddress: !isEmpty(global?.businessProfile?.webAddress) ? global?.businessProfile?.webAddress : 'NA',
                storeType: !isEmpty(global?.businessProfile?.storeType) ? global?.businessProfile?.storeType : 'NA',
                yearsOfBusiness: !isEmpty(global?.businessProfile?.yearsInBusiness)
                  ? global?.businessProfile?.yearsInBusiness
                  : 'NA',
                dailyTransactionValue: !isEmpty(global?.businessProfile?.dailyTransactionValue)
                  ? global?.businessProfile?.dailyTransactionValue
                  : 'NA',
                dailyTransactionVolume: !isEmpty(global?.businessProfile?.dailyTransactionVolume)
                  ? global?.businessProfile?.dailyTransactionVolume
                  : 'NA',
                merchantOtpDate: !isEmpty(global?.merchantOtpDate) ? global?.merchantOtpDate : 'NA',
                deviceOtpDate: !isEmpty(global?.deviceOtpDate) ? global?.deviceOtpDate : 'NA',
                mccCode: !isEmpty(global?.businessProfile?.mccCode) ? global?.businessProfile?.mccCode : 'NA',
                businessCategory: !isEmpty(global?.businessProfile?.businessCategory)
                  ? global?.businessProfile?.businessCategory
                  : self.onboarding.businessDetail.businessCategory ?? 'NA',
                businessLine: !isEmpty(global?.businessProfile?.businessLine)
                  ? global?.businessProfile?.businessLine
                  : self.onboarding.businessDetail.businessLine ?? 'NA',
                pharmacistName: !isEmpty(global?.businessProfile?.pharmacistName)
                  ? global?.businessProfile?.pharmacistName
                  : 'NA',
                pharmacyCouncilNumber: !isEmpty(global?.businessProfile?.pharmacyCouncilNumber)
                  ? global?.businessProfile?.pharmacyCouncilNumber
                  : 'NA',
                primaryAddress1: !isEmpty(addressDetailsEntity?.addressLine1)
                  ? addressDetailsEntity?.addressLine1
                  : 'NA',
                primaryAddress2: !isEmpty(addressDetailsEntity?.addressLine2)
                  ? addressDetailsEntity?.addressLine2
                  : 'NA',
                pincode: !isEmpty(addressDetailsEntity?.pincode) ? addressDetailsEntity?.pincode : 'NA',
                city: !isEmpty(addressDetailsEntity?.city) ? addressDetailsEntity?.city : 'NA',
                stateUt: !isEmpty(addressDetailsEntity?.state) ? addressDetailsEntity?.state : 'NA',
                businessLatitude: !isEmpty(addressDetailsEntity?.latitude) ? addressDetailsEntity?.latitude : 'NA',
                businessLongitude: !isEmpty(addressDetailsEntity?.longitude) ? addressDetailsEntity?.longitude : 'NA',
                gstCategory: !isEmpty(global?.gstDetails?.merchantCategory)
                  ? global?.gstDetails?.merchantCategory
                  : 'NA',
                gstDealerCategory: !isEmpty(global?.gstDetails?.dealerCategory)
                  ? global?.gstDetails?.dealerCategory
                  : 'NA',
                typeOfBusiness: !isEmpty(global?.gstDetails?.typeOfBusiness)
                  ? global?.gstDetails?.typeOfBusiness
                  : 'NA',
                gstNumber: !isEmpty(global?.gstDetails?.gstin) ? global?.gstDetails?.gstin : 'NA',
                dateOfExpiry: !isEmpty(global?.gstDetails?.dateOfExpiry) ? global?.gstDetails?.dateOfExpiry : 'NA',
                jioGstAcceptanceTs: !isEmpty(global?.gstDetails?.jioGST) ? global?.gstDetails?.jioGST : 'NA',
                inheritParentFeePackage: !isEmpty(global?.feePackageDetails?.inheritParentFeePackage)
                  ? global?.feePackageDetails?.inheritParentFeePackage
                  : 'NA',
                feePackageId: !isEmpty(global?.feePackageDetails?.feePkgId)
                  ? global?.feePackageDetails?.feePkgId
                  : 'NA',
                feePackageName: !isEmpty(global?.feePackageDetails?.feePackageName)
                  ? global?.feePackageDetails?.feePackageName
                  : 'NA',
                programCategoryDetails: global?.programCategoryDetails,
                country: !isEmpty(addressDetailsEntity?.countryCode)
                  ? (self as any).getLovsDescriptionFromKeyValue('Country', addressDetailsEntity?.countryCode)
                  : 'NA',
              }),
            }
          }
        })
      }
      return buzzDetails
    },
    getApplicationIdFromTaskId(appId: string) {
      let applicationId = ''
      self.myCheckerList.map((checkerRow) => {
        if (checkerRow.applicationId === appId) {
          applicationId = checkerRow.applicationId
        }
      })
      return applicationId
    },
    getApplicationApprovalstatus() {
      return self.checkerApplicationStatus.applicationStatus ?? ''
    },
    getMdrFeePackageDetails(entityId: string) {
      for (let i = 0; i < self.onboarding.searchEntity.length; i++) {
        if (self.onboarding.searchEntity[i].entity?.identificationNumber === entityId) {
          return self.onboarding.searchEntity[i].entity?.feePackageDetails
        }
      }
    },
    getIsParentEntityHasFeePackage(entityId: string) {
      for (let i = 0; i < self.onboarding.searchEntity.length; i++) {
        if (self.onboarding.searchEntity[i].entity?.identificationNumber === entityId) {
          const feePackageDetails = self.onboarding.searchEntity[i].entity?.feePackageDetails
          return self.onboarding.entityParentType === 'Entity' && feePackageDetails && feePackageDetails?.id
        }
      }
    },
    //TODO: check if needed
    getIsSelectedCardTypeFullySelected(selectedType: string) {
      let isAllTrue = false
      for (let i = 0; i < self.onboarding.cardList.length; i++) {
        const card = self.onboarding.cardList[i]
        if (card.type === selectedType) {
          if (card.isDomesticAllowed && card.isInternationalAllowed && card.isPremium) {
            isAllTrue = true
          } else {
            isAllTrue = false
            return false
          }
        }
      }
      return isAllTrue
    },
    getSearchHeaderData(entityId: string) {
      let headerData = {}
      self.onboarding.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          headerData = {
            id: entityId,
            masId:
              data?.entity?.parentEntityIdentificationNumber?.length > 0
                ? data?.entity?.parentEntityIdentificationNumber
                : data?.entity?.subGroupIdentificationNumber ?? '',
            onboardingChannel: !isEmpty(data?.entity?.settlementDetails?.setupCompleteInd)
              ? (self as any).getLovsDescriptionFromKeyValue(
                  'SetupCompleteInd',
                  data?.entity?.settlementDetails?.setupCompleteInd,
                )
              : 'NA',
            type: (self as any).getLovsDescriptionFromKeyValue('EntityType', data.entity?.type) ?? '',
            level: data?.entity?.entityLevel ?? '',
            group: data?.group?.brandName,
            subGroup: data?.subGroup?.brandName,
            status: data?.entity?.status,
          }
        }
      })
      return headerData
    },
    getOthersApisList() {
      const othersList = self.apis.filter((item) => item.profileName === 'OTHERS')
      const finalList = othersList.filter((obj, index) => {
        return index === othersList.findIndex((o) => obj.apiId === o.apiId)
      })
      return JSON.parse(JSON.stringify(finalList))
    },
    getApisList(profileName: string) {
      const filteredListByProfileName = self.apis.filter((item) => item.profileName === profileName)
      const finalList = filteredListByProfileName.filter((obj, index) => {
        return index === filteredListByProfileName.findIndex((o) => obj.apiId === o.apiId)
      })
      return JSON.parse(JSON.stringify(finalList))
    },
    getCommonInPciNonPci() {
      const nonPciFilteredList = self.apis.filter((item) => item.profileName === 'NON_PCI_MERCHANT')
      const pciFilteredList = self.apis.filter((item) => item.profileName === 'PCI_MERCHANT')
      const data = _.intersectionBy(nonPciFilteredList, pciFilteredList, 'apiId')
      const list = JSON.parse(JSON.stringify(data))
      console.log('===> getCommonInPciNonPci: ', list)
      return list
    },
    getEmiList() {
      const emiLink = self.apis.filter((item) => item.profileName === 'EMI')
      const finalList = emiLink.filter((obj, index) => {
        return index === emiLink.findIndex((o) => obj.apiId === o.apiId)
      })
      return JSON.parse(JSON.stringify([...finalList]))
    },
    getAllPciList() {
      const pciFilteredList = self.apis.filter((item) => item.profileName === 'PCI_MERCHANT')
      const finalList = pciFilteredList.filter((obj, index) => {
        return index === pciFilteredList.findIndex((o) => obj.apiId === o.apiId)
      })
      return JSON.parse(JSON.stringify([...finalList]))
    },
    banksSelectedLength() {
      let count = 0
      self.onboarding.merchant.preferences.bankList.map((bank) => {
        if (bank.isSelected) {
          count++
        }
      })
      console.log('banksSelectedLength', count)
      return count
    },
    corporateBanksSelectedLength() {
      let count = 0
      self.onboarding.merchant.preferences.corpBankList.map((bank) => {
        if (bank.isSelected) {
          count++
        }
      })
      console.log('corp banks selected length', count)
      return count
    },
    walletSelectedLength() {
      let count = 0
      self.onboarding.merchant.preferences.walletList.map((wallet) => {
        if (wallet.isSelected) {
          count++
        }
      })
      console.log('walletSelectedLength', count)
      return count
    },
    payLaterSelectedLength() {
      let count = 0
      self.onboarding.merchant.preferences.payLaterList.map((paylater) => {
        if (paylater.isSelected) {
          count++
        }
      })
      console.log('payLaterListLength', count)
      return count
    },
    getCardsConfig() {
      return self.onboarding.cardConfig
    },
    getCardTypeSelection(item: any) {
      let isSelected = false
      for (let i = 0; i < self.onboarding.cardList.length; i++) {
        if (self.onboarding.cardList[i].type === item.type && self.onboarding.cardList[i].scheme === item.scheme) {
          isSelected =
            self.onboarding.cardList[i].isDomesticAllowed &&
            self.onboarding.cardList[i].isInternationalAllowed &&
            self.onboarding.cardList[i].isPremium
          break
        }
      }
      return isSelected
    },
    getSearchData(type: string) {
      let arr: any[] = []
      if (self.onboarding.searchEntity.length > 0) {
        self.onboarding.searchEntity.map((data) => {
          const parsedData =
            type === EmType.Search
              ? {
                  id: data?.entity?.identificationNumber ?? '',
                  masId:
                    data?.entity?.parentEntityIdentificationNumber?.length > 0
                      ? data?.entity?.parentEntityIdentificationNumber
                      : data?.entity?.subGroupIdentificationNumber ?? '',
                  businessName: data?.entity?.businessName ?? '',
                  level: `${data?.entity?.entityLevel}` ?? '',
                  mobileNumber:
                    data?.entity?.contactDetails?.[0]?.mobileNumber?.length > 0
                      ? data?.entity?.contactDetails?.[0]?.mobileNumber
                      : 'NA',
                  status: data?.entity?.status ?? '',
                  // type: data?.entity?.type ?? '', //TODO: may be needed  in search header
                  group: data?.group?.legalName ?? '',
                  subGroup: data?.subGroup?.legalName ?? '',
                  type: data?.entity?.type,
                }
              : {
                  id: data?.entity?.identificationNumber ?? '',
                  businessName: data?.entity?.businessName ?? '',
                  type: data?.entity?.type ?? '',
                  level: `${data?.entity?.entityLevel}` ?? '',
                  status: (self as any).getLovsDescriptionFromKeyValue('Status', data?.entity?.status) ?? '',
                  viewDetails: 'View Details',
                  //was showing extra column in few mid's
                  // group: data?.group?.legalName ?? '',
                }
          // console.log('===> parsedData', parsedData)
          arr.push(parsedData)
        })
      }
      return arr
    },
    searchDataWithFilters() {
      const filteredArr = self.onboarding.searchEntity.map((data) => {
        return {
          id: data?.entity?.identificationNumber ?? '',
          masId: data?.entity?.parentEntityIdentificationNumber ?? '',
          businessName: data?.entity?.businessName ?? '',
          level: `${data?.entity?.entityLevel}` ?? '',
          mobileNumber:
            data?.contactDetails?.[0]?.mobileNumber?.length > 0 ? data?.contactDetails?.[0]?.mobileNumber : 'NA',
          status: data?.entity?.status ?? '',
        }
      })
      if (self.filter.allLevelsSelected && self.filter.allStatusSelected) {
        return filteredArr
      } else if (!self.filter.allLevelsSelected && self.filter.levelSelected) {
        return filteredArr.filter((item) => self.filter.levelSelected.includes(item.level))
      } else if (!self.filter.allStatusSelected && self.filter.statusSelected) {
        return filteredArr.filter((item) => item.status.toLowerCase() === self.filter.statusSelected.toLowerCase())
      }
      console.log('searchDataWithFilters: ', JSON.parse(JSON.stringify(filteredArr)))
      return filteredArr
    },
    getRecentSearches(): any {
      return self.recentSearches
    },
    getAccountSummaryData(entityId: string) {
      let accountSummary
      self.onboarding.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          const contactDetails =
            data?.entity?.source === 'MAS'
              ? data?.entity?.contactDetails
                  ?.filter((contact) => contact?.role === 'LOC')
                  ?.filter((mContact) => mContact?.mobileNumber?.length > 3)?.[0]
              : data?.entity?.contactDetails?.[0]
          const addressDetails =
            data?.entity?.source === 'MAS' ? contactDetails?.entityContactAddress : data?.entity?.addressDetails?.[0]
          const businessDetail = data?.entity?.businessProfile
          const storeCodeDetails = data?.entity?.storeCodeDetails
          accountSummary = {
            gender: !isEmpty(contactDetails?.gender)
              ? (self as any).getLovsDescriptionFromKeyValue('Gender', contactDetails?.gender)
              : 'NA',
            firstName: !isEmpty(contactDetails?.firstName) ? contactDetails?.firstName : 'NA',
            lastName: !isEmpty(contactDetails?.lastName) ? contactDetails?.lastName : 'NA',
            dateOfBirth: !isEmpty(contactDetails?.dateOfBirth) ? contactDetails?.dateOfBirth : 'NA',
            mobileNumber:
              !isEmpty(contactDetails?.mobileNumber) &&
              !isEmpty(contactDetails?.entityContactAddress?.countryCode) &&
              contactDetails?.entityContactAddress?.countryCode !== 'NA'
                ? `${contactDetails?.entityContactAddress?.countryCode}${contactDetails?.mobileNumber}`
                : !isEmpty(contactDetails?.mobileNumber)
                ? contactDetails?.mobileNumber
                : 'NA',
            emailId: !isEmpty(contactDetails?.emailId) ? contactDetails?.emailId : 'NA',
            storeCode: !isEmpty(storeCodeDetails?.storeCode) ? storeCodeDetails?.storeCode : 'NA',
            format: !isEmpty(storeCodeDetails?.format) ? storeCodeDetails?.format : 'NA',
            businessDisplayName: !isEmpty(data?.entity?.businessName) ? data?.entity?.businessName : 'NA',
            entityPanNumber: !isEmpty(businessDetail?.businessPan) ? businessDetail?.businessPan : 'NA',
            businessChannel: !isEmpty(businessDetail?.businessChannel)
              ? (self as any).getLovsDescriptionFromKeyValue('BusinessChannel', businessDetail?.businessChannel)
              : 'NA',
            lineOfBusiness: !isEmpty(businessDetail?.businessLine) ? businessDetail?.businessLine : 'NA',
            webAddress: !isEmpty(businessDetail?.webAddress) ? businessDetail.webAddress : 'NA',

            addressLine1: !isEmpty(addressDetails?.addressLine1) ? addressDetails?.addressLine1 : 'NA',
            addressLine2: !isEmpty(addressDetails?.addressLine2) ? addressDetails?.addressLine2 : 'NA',
            city: !isEmpty(addressDetails?.city) ? addressDetails?.city : 'NA',
            state: !isEmpty(addressDetails?.state)
              ? (self as any).getLovsDescriptionFromKeyValue('State', addressDetails?.state)
              : 'NA',
            pincode: !isEmpty(addressDetails?.pincode) ? addressDetails?.pincode : 'NA',
            country:
              data?.entity?.source === 'MAS'
                ? !isEmpty(contactDetails?.country)
                  ? (self as any).getLovsDescriptionFromKeyValue('Country', contactDetails?.country)
                  : 'NA'
                : !isEmpty(data?.entity?.addressDetails?.[0]?.countryCode)
                ? (self as any).getLovsDescriptionFromKeyValue(
                    'Country',
                    data?.entity?.addressDetails?.[0]?.countryCode,
                  )
                : 'NA',
            status: !isEmpty(data?.entity?.status)
              ? (self as any).getLovsDescriptionFromKeyValue('Status', data?.entity?.status)
              : 'NA',
            onboardingChannel: !isEmpty(data?.entity?.settlementDetails?.setupCompleteInd)
              ? (self as any).getLovsDescriptionFromKeyValue(
                  'SetupCompleteInd',
                  data?.entity?.settlementDetails?.setupCompleteInd,
                )
              : 'NA',
            mccCode: businessDetail?.mccCode,
          }
        }
      })
      console.log('summaryData:', accountSummary)
      return accountSummary
    },
    getOnboardingChannel(entityId: string) {
      let channel = 'NA'
      self.onboarding.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          if (!isEmpty(data?.entity?.settlementDetails?.setupCompleteInd)) {
            channel = (self as any).getLovsDescriptionFromKeyValue(
              'SetupCompleteInd',
              data?.entity?.settlementDetails?.setupCompleteInd,
            )
          } else {
            channel = 'NA'
          }
        }
      })
      return channel
    },
    getAccountSummaryDataForMakerChecker(data: any) {
      let accountSummary
      const contactDetails = data?.contactDetails?.[0]
      const addressDetails = data?.addressDetails?.[0]
      const businessDetail = data?.businessProfile
      const storeCodeDetails = data?.storeCodeDetails
      accountSummary = {
        gender: !isEmpty(contactDetails?.gender)
          ? (self as any).getLovsDescriptionFromKeyValue('Gender', contactDetails?.gender)
          : 'NA',
        firstName: !isEmpty(contactDetails?.firstName) ? contactDetails?.firstName : 'NA',
        lastName: !isEmpty(contactDetails?.lastName) ? contactDetails?.lastName : 'NA',
        dob: !isEmpty(contactDetails?.dob) ? contactDetails?.dob : 'NA',
        dateOfBirth: !isEmpty(contactDetails?.dateOfBirth) ? contactDetails?.dateOfBirth : 'NA',
        mobileNumber: !isEmpty(contactDetails?.mobileNumber) ? contactDetails?.mobileNumber : 'NA',
        emailId: !isEmpty(contactDetails?.emailId) ? contactDetails?.emailId : 'NA',
        businessDisplayName: !isEmpty(data?.businessName) ? data?.businessName : 'NA',
        entityPanNumber: !isEmpty(businessDetail?.businessPan) ? businessDetail?.businessPan : 'NA',
        businessChannel: !isEmpty(businessDetail?.businessChannel)
          ? (self as any).getLovsDescriptionFromKeyValue('BusinessChannel', businessDetail?.businessChannel)
          : 'NA',
        lineOfBusiness: !isEmpty(businessDetail?.businessLine) ? businessDetail?.businessLine : 'NA',
        webAddress: !isEmpty(businessDetail?.webAddress) ? businessDetail.webAddress : 'NA',
        addressLine1: !isEmpty(addressDetails?.addressLine1) ? addressDetails?.addressLine1 : 'NA',
        addressLine2: !isEmpty(addressDetails?.addressLine2) ? addressDetails?.addressLine2 : 'NA',
        city: !isEmpty(addressDetails?.city) ? addressDetails?.city : 'NA',
        state: !isEmpty(addressDetails?.state)
          ? (self as any).getLovsDescriptionFromKeyValue('State', addressDetails?.state)
          : 'NA',
        pincode: !isEmpty(addressDetails?.pincode) ? addressDetails?.pincode : 'NA',
        country: !isEmpty(addressDetails?.countryCode)
          ? (self as any).getLovsDescriptionFromKeyValue('Country', addressDetails?.countryCode)
          : 'NA',
        status: !isEmpty(data?.status) ? (self as any).getLovsDescriptionFromKeyValue('Status', data?.status) : 'NA',
        mccCode: businessDetail?.mccCode,
        storeCode: !isEmpty(storeCodeDetails?.storeCode) ? storeCodeDetails?.storeCode : 'NA',
        format: !isEmpty(storeCodeDetails?.format) ? storeCodeDetails?.format : 'NA',
      }
      console.log('summaryData:', accountSummary)
      return accountSummary
    },
    getKycList(entityId: string) {
      return self.onboarding.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          return data?.kycDetailDetails?.map((kyc) => {
            return {
              category: kyc.documentCategory,
              name: kyc.documentName,
              number: kyc.documentNumber,
              expiryDate: kyc.dateOfExpiry,
              kycStatus: kyc.kycStatus,
            }
          })
        }
      })
    },
    getBusinessDetailsFromEntity(entityId: string, type: string) {
      let bizzDetails
      if (entityId && self.onboarding.searchEntity.length > 0 && type === EmType.Search) {
        self.onboarding.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            const businessProfile = data?.entity?.businessProfile
            const locContact = data?.entity?.contactDetails?.filter((contact) => contact?.role === 'LOC')?.[0]
            const mobileNumber =
              data?.entity?.source === 'MAS'
                ? locContact?.mobileNumber
                : data?.entity?.contactDetails?.[0]?.mobileNumber
            const countryCode =
              data?.entity?.source === 'MAS'
                ? locContact?.entityContactAddress?.countryCode
                : data?.entity?.contactDetails?.[0]?.countryCode
            const addressDetails =
              data?.entity?.source === 'MAS'
                ? data?.entity?.addressDetails?.filter((address) => address?.addressRole === 'LOC')?.[0]
                : data?.entity?.addressDetails?.[0]
            const country =
              data?.entity?.source === 'MAS'
                ? data?.entity?.contactDetails
                    ?.filter((contact) => contact?.role === 'LOC')
                    ?.filter((mContact) => mContact?.mobileNumber?.length > 3)?.[0]?.country ?? 'NA'
                : data?.entity?.addressDetails?.[0]?.countryCode ?? 'NA'
            const gstDetails = data?.entity?.gstDetails
            const feePackageDetails = data?.entity?.feePackageDetails
            const programCategoryDetails = {
              id: !isEmpty(data?.entity?.programCategoryDetails?.[0]?.id)
                ? data?.entity?.programCategoryDetails?.[0]?.id
                : 'NA',
              programId: !isEmpty(data?.entity?.programCategoryDetails?.[0]?.programId)
                ? data?.entity?.programCategoryDetails?.[0]?.programId
                : 'NA',
              category: !isEmpty(data?.entity?.programCategoryDetails?.[0]?.category)
                ? data?.entity?.programCategoryDetails?.[0]?.category
                : 'NA',
              referenceId: !isEmpty(data?.entity?.programCategoryDetails?.[0]?.referenceId)
                ? data?.entity?.programCategoryDetails?.[0]?.referenceId
                : 'NA',
            }
            bizzDetails = {
              legalEntityName: !isEmpty(data?.entity?.legalName) ? data?.entity?.legalName : 'NA',
              businessBrandName: !isEmpty(data?.entity?.businessName) ? data?.entity?.businessName : 'NA',
              ownershipType: !isEmpty(businessProfile?.ownershipType) ? businessProfile?.ownershipType : 'NA',
              businessChannel: !isEmpty(businessProfile?.businessChannel) ? businessProfile?.businessChannel : 'NA',
              setupLevel: !isEmpty(businessProfile?.setUpLevel) ? businessProfile?.setUpLevel : 'NA',
              premiseType: !isEmpty(businessProfile?.premiseType) ? businessProfile?.premiseType : 'NA',
              businessPAN: !isEmpty(businessProfile?.businessPan) ? businessProfile?.businessPan : 'NA',
              webAddress: !isEmpty(businessProfile?.webAddress) ? businessProfile?.webAddress : 'NA',
              storeType: !isEmpty(businessProfile?.storeType) ? businessProfile?.storeType : 'NA',
              yearsOfBusiness: !isEmpty(businessProfile?.yearsInBusiness) ? businessProfile?.yearsInBusiness : 'NA',
              dailyTransactionValue: !isEmpty(businessProfile?.dailyTransactionValue)
                ? businessProfile?.dailyTransactionValue
                : 'NA',
              dailyTransactionVolume: !isEmpty(businessProfile?.dailyTransactionVolume)
                ? businessProfile?.dailyTransactionVolume
                : 'NA',
              merchantOtpDate: !isEmpty(data?.entity?.merchantOtpDate) ? data?.entity?.merchantOtpDate : 'NA',
              deviceOtpDate: !isEmpty(data?.entity?.deviceOtpDate) ? data?.entity?.deviceOtpDate : 'NA',
              mccCode: !isEmpty(businessProfile?.mccCode) ? businessProfile?.mccCode : 'NA',
              businessCategory: !isEmpty(businessProfile?.businessCategory)
                ? businessProfile?.businessCategory
                : self.onboarding.businessDetail.businessCategory ?? 'NA',
              businessLine: !isEmpty(businessProfile?.businessLine)
                ? businessProfile?.businessLine
                : self.onboarding.businessDetail.businessLine ?? 'NA',
              pharmacistName: !isEmpty(businessProfile?.pharmacistName) ? businessProfile?.pharmacistName : 'NA',
              pharmacyCouncilNumber: !isEmpty(businessProfile?.pharmacyCouncilNumber)
                ? businessProfile?.pharmacyCouncilNumber
                : 'NA',
              primaryAddress1: !isEmpty(addressDetails?.addressLine1) ? addressDetails?.addressLine1 : 'NA',
              primaryAddress2: !isEmpty(addressDetails?.addressLine2) ? addressDetails?.addressLine2 : 'NA',
              pincode: !isEmpty(addressDetails?.pincode) ? addressDetails?.pincode : 'NA',
              city: !isEmpty(addressDetails?.city) ? addressDetails?.city : 'NA',
              stateUt: !isEmpty(addressDetails?.state) ? addressDetails?.state : 'NA',
              businessLatitude: !isEmpty(addressDetails?.latitude) ? addressDetails?.latitude : 'NA',
              businessLongitude: !isEmpty(addressDetails?.longitude) ? addressDetails?.longitude : 'NA',
              gstCategory: !isEmpty(gstDetails?.merchantCategory) ? gstDetails?.merchantCategory : 'NA',
              gstDealerCategory: !isEmpty(gstDetails?.dealerCategory) ? gstDetails?.dealerCategory : 'NA',
              typeOfBusiness: !isEmpty(gstDetails?.typeOfBusiness) ? gstDetails?.typeOfBusiness : 'NA',
              gstNumber: !isEmpty(gstDetails?.gstin) ? gstDetails?.gstin : 'NA',
              dateOfExpiry: !isEmpty(gstDetails?.dateOfExpiry) ? gstDetails?.dateOfExpiry : 'NA',
              jioGstAcceptanceTs: !isEmpty(gstDetails?.jioGST) ? gstDetails?.jioGST : 'NA',
              inheritParentFeePackage: !isEmpty(feePackageDetails?.inheritParentFeePackage)
                ? feePackageDetails?.inheritParentFeePackage
                : 'NA',
              feePackageId: !isEmpty(feePackageDetails?.feePkgId) ? feePackageDetails?.feePkgId : 'NA',
              feePackageName: !isEmpty(feePackageDetails?.feePackageName) ? feePackageDetails?.feePackageName : 'NA',
              programCategoryDetails: programCategoryDetails,
              mobileNumber:
                !isEmpty(mobileNumber) && !isEmpty(countryCode) && countryCode !== 'NA'
                  ? `${countryCode}${mobileNumber}`
                  : !isEmpty(mobileNumber)
                  ? mobileNumber
                  : 'NA',
              ownerType: !isEmpty(data?.entity?.ownerType) ? data?.entity?.ownerType : 'NA',
              country: (self as any).getLovsDescriptionFromKeyValue('Country', country),
            }
          }
        })
      } else if (
        self.onboarding.entityDetails &&
        self.onboarding.entityDetails.businessProfile &&
        type === EmType.createSingleEntity
      ) {
        const data = self.onboarding.entityDetails
        const businessProfile = data?.businessProfile
        const addressDetails = data?.addressDetails?.filter((address) => address?.addressRole === 'LOC')?.[0]
        const gstDetails = data?.gstDetails
        const feePackageDetails = data?.feePackageDetails
        const programCategoryDetails = {
          id: !isEmpty(data?.programCategoryDetails?.[0]?.id) ? data?.programCategoryDetails?.[0]?.id : 'NA',
          programId: !isEmpty(data?.programCategoryDetails?.[0]?.programId)
            ? data?.programCategoryDetails?.[0]?.programId
            : 'NA',
          category: !isEmpty(data?.programCategoryDetails?.[0]?.category)
            ? data?.programCategoryDetails?.[0]?.category
            : 'NA',
          referenceId: !isEmpty(data?.programCategoryDetails?.[0]?.referenceId)
            ? data?.programCategoryDetails?.[0]?.referenceId
            : 'NA',
        }
        bizzDetails = {
          legalEntityName: !isEmpty(data?.entity?.legalName) ? data?.entity?.legalName : 'NA',
          businessBrandName: !isEmpty(data?.entity?.businessName) ? data?.entity?.businessName : 'NA',
          ownershipType: !isEmpty(businessProfile?.ownershipType) ? businessProfile?.ownershipType : 'NA',
          businessChannel: !isEmpty(businessProfile?.businessChannel) ? businessProfile?.businessChannel : 'NA',
          setupLevel: !isEmpty(businessProfile?.setUpLevel) ? businessProfile?.setUpLevel : 'NA',
          premiseType: !isEmpty(businessProfile?.premiseType) ? businessProfile?.premiseType : 'NA',
          businessPAN: !isEmpty(businessProfile?.businessPan) ? businessProfile?.businessPan : 'NA',
          webAddress: !isEmpty(businessProfile?.webAddress) ? businessProfile?.webAddress : 'NA',
          storeType: !isEmpty(businessProfile?.storeType) ? businessProfile?.storeType : 'NA',
          yearsOfBusiness: !isEmpty(businessProfile?.yearsInBusiness) ? businessProfile?.yearsInBusiness : 'NA',
          dailyTransactionValue: 'NA', //TODO:
          dailyTransactionVolume: 'NA', //TODO:
          merchantOtpDate: !isEmpty(data?.entity?.merchantOtpDate) ? data?.entity?.merchantOtpDate : 'NA',
          deviceOtpDate: !isEmpty(data?.entity?.deviceOtpDate) ? data?.entity?.deviceOtpDate : 'NA',
          mccCode: !isEmpty(businessProfile?.mccCode) ? businessProfile?.mccCode : 'NA',
          businessCategory: !isEmpty(businessProfile?.businessCategory) ? businessProfile?.businessCategory : 'NA',
          businessLine: !isEmpty(businessProfile?.businessLine) ? businessProfile?.businessLine : 'NA',
          pharmacistName: !isEmpty(businessProfile?.pharmacistName) ? businessProfile?.pharmacistName : 'NA',
          pharmacyCouncilNumber: !isEmpty(businessProfile?.pharmacyCouncilNumber)
            ? businessProfile?.pharmacyCouncilNumber
            : 'NA',
          primaryAddress1: !isEmpty(addressDetails?.addressLine1) ? addressDetails?.addressLine1 : 'NA',
          primaryAddress2: !isEmpty(addressDetails?.addressLine2) ? addressDetails?.addressLine2 : 'NA',
          pincode: !isEmpty(addressDetails?.pincode) ? addressDetails?.pincode : 'NA',
          city: !isEmpty(addressDetails?.city) ? addressDetails?.city : 'NA',
          stateUt: !isEmpty(addressDetails?.state) ? addressDetails?.state : 'NA',
          businessLatitude: !isEmpty(addressDetails?.latitude) ? addressDetails?.latitude : 'NA',
          businessLongitude: !isEmpty(addressDetails?.longitude) ? addressDetails?.longitude : 'NA',
          gstCategory: !isEmpty(gstDetails?.merchantCategory) ? gstDetails?.merchantCategory : 'NA',
          gstDealerCategory: !isEmpty(gstDetails?.dealerCategory) ? gstDetails?.dealerCategory : 'NA',
          typeOfBusiness: !isEmpty(gstDetails?.typeOfBusiness) ? gstDetails?.typeOfBusiness : 'NA',
          gstNumber: !isEmpty(gstDetails?.gstin) ? gstDetails?.gstin : 'NA',
          dateOfExpiry: !isEmpty(gstDetails?.dateOfExpiry) ? gstDetails?.dateOfExpiry : 'NA',
          jioGstAcceptanceTs: !isEmpty(gstDetails?.jioGstAcceptanceTs) ? gstDetails?.jioGstAcceptanceTs : 'NA',
          inheritParentFeePackage: !isEmpty(feePackageDetails?.inheritParentFeePackage)
            ? feePackageDetails?.inheritParentFeePackage
            : 'NA',
          feePackageId: !isEmpty(feePackageDetails?.feePkgId?.toString()) ? feePackageDetails?.feePkgId : 'NA',
          feePackageName: !isEmpty(feePackageDetails?.feePackageName) ? feePackageDetails?.feePackageName : 'NA',
          programCategoryDetails: programCategoryDetails,
        }
      } else if (self.onboarding.businessDetail && type === EmType.createSingleEntity && entityId === undefined) {
        const data = self.onboarding.businessDetail
        return {
          legalEntityName: !isEmpty(data?.legalEntityName) ? data?.legalEntityName : 'NA',
          businessBrandName: !isEmpty(data?.businessBrandName) ? data?.businessBrandName : 'NA',
          ownershipType: !isEmpty(data?.ownershipType) ? data?.ownershipType : 'NA',
          businessChannel: !isEmpty(data?.businessChannel) ? data?.businessChannel : 'NA',
          setupLevel: !isEmpty(data?.setupLevel) ? data?.setupLevel : 'NA',
          premiseType: !isEmpty(data?.premiseType) ? data?.premiseType : 'NA',
          businessPAN: !isEmpty(data?.businessPAN) ? data?.businessPAN : 'NA',
          webAddress: !isEmpty(data?.webAddress) ? data?.webAddress : 'NA',
          storeType: !isEmpty(data?.storeType) ? data?.storeType : 'NA',
          yearsOfBusiness: !isEmpty(data?.yearsOfBusiness) ? data?.yearsOfBusiness : 'NA',
          dailyTransactionValue: 'NA', //TODO:
          dailyTransactionVolume: 'NA', //TODO:
          merchantOtpDate: !isEmpty(data?.merchantOtpDate) ? data?.merchantOtpDate : 'NA',
          deviceOtpDate: !isEmpty(data?.deviceOtpDate) ? data?.deviceOtpDate : 'NA',
          mccCode: !isEmpty(data?.mccCode) ? data?.mccCode : '',
          businessCategory: !isEmpty(data?.businessCategory) ? data?.businessCategory : 'NA',
          businessLine: !isEmpty(data?.businessLine) ? data?.businessLine : 'NA',
          pharmacistName: !isEmpty(data?.pharmacistName) ? data?.pharmacistName : 'NA',
          pharmacyCouncilNumber: !isEmpty(data?.pharmacyCouncilNumber) ? data?.pharmacyCouncilNumber : 'NA',
          primaryAddress1: !isEmpty(data?.primaryAddress1) ? data?.primaryAddress1 : 'NA',
          primaryAddress2: !isEmpty(data?.primaryAddress1) ? data?.primaryAddress1 : 'NA',
          pincode: !isEmpty(data?.pincode) ? data?.pincode : 'NA',
          city: !isEmpty(data?.city) ? data?.city : 'NA',
          stateUt: !isEmpty(data?.stateUt) ? data?.stateUt : 'NA',
          businessLatitude: !isEmpty(data?.businessLatitude) ? data?.businessLatitude : 'NA',
          businessLongitude: !isEmpty(data?.businessLongitude) ? data?.businessLongitude : 'NA',
          gstCategory: !isEmpty(data?.gstCategory) ? data?.gstCategory : 'NA',
          gstDealerCategory: !isEmpty(data?.gstDealerCategory) ? data?.gstDealerCategory : 'NA',
          typeOfBusiness: !isEmpty(data?.typeOfBusiness) ? data?.typeOfBusiness : 'NA',
          gstNumber: !isEmpty(data?.gstNumber) ? data?.gstNumber : 'NA',
          dateOfExpiry: !isEmpty(data?.dateOfExpiry) ? data?.dateOfExpiry : 'NA',
          jioGstAcceptanceTs: !isEmpty(data?.jioGstAcceptanceTs) ? data?.jioGstAcceptanceTs : 'NA',
          inheritParentFeePackage: !isEmpty(data?.inheritParentFeePackage) ? data?.inheritParentFeePackage : 'NA',
          mdrPackageId: !isEmpty(data?.mdrPackageId) ? data?.mdrPackageId : 'NA',
          mdrPackageDetails: !isEmpty(data?.mdrPackageDetails) ? data?.mdrPackageDetails : 'NA',
          programCategoryDetails: 'NA', //TODO:
        }
      } else if (
        self.onboarding.businessDetail &&
        (type === EmType.createGroup || type === EmType.createSubGroup) &&
        entityId === undefined
      ) {
        const data = self.onboarding.businessDetail
        return {
          legalEntityName: !isEmpty(data?.legalEntityName) ? data?.legalEntityName : '',
          businessBrandName: !isEmpty(data?.businessBrandName) ? data?.businessBrandName : '',
          primaryAddress1: !isEmpty(data?.primaryAddress1) ? data?.primaryAddress1 : '',
          primaryAddress2: !isEmpty(data?.primaryAddress1) ? data?.primaryAddress1 : '',
          pincode: !isEmpty(data?.pincode) ? data?.pincode : '',
          city: !isEmpty(data?.city) ? data?.city : '',
          stateUt: !isEmpty(data?.stateUt) ? data?.stateUt : '',
        }
      }
      return bizzDetails
    },
    getBusinessDetailsFromGroup(identificationNumber: string) {
      if (self.onboarding.group.identificationNumber === identificationNumber) {
        const data = self.onboarding.group
        const address = data?.groupAddress?.[0]
        return {
          legalEntityName: !isEmpty(data?.legalName) ? data?.legalName : 'NA',
          businessBrandName: !isEmpty(data?.brandName) ? data?.brandName : 'NA',
          primaryAddress1: !isEmpty(address?.addressLine1) ? address?.addressLine1 : 'NA',
          primaryAddress2: !isEmpty(address?.addressLine2) ? address?.addressLine2 : 'NA',
          pincode: !isEmpty(address?.pincode) ? address?.pincode : 'NA',
          city: !isEmpty(address?.city) ? address?.city : 'NA',
          stateUt: !isEmpty(address?.state) ? address?.state : 'NA',
        }
      }
    },
    getBusinessDetailsSubGroup(identificationNumber: string) {
      if (self.onboarding.subgroup?.[0].identificationNumber === identificationNumber) {
        const data = self.onboarding.subgroup?.[0]
        return {
          legalEntityName: !isEmpty(data?.legalName) ? data?.legalName : 'NA',
          businessBrandName: !isEmpty(data?.brandName) ? data?.brandName : 'NA',
        }
      }
    },
    getContactProfileFromGroup(identificationNumber: string) {
      let contacts: any[] = []
      if (self.onboarding.group.identificationNumber === identificationNumber) {
        self.onboarding.group?.groupContacts?.map((group) => {
          const data = {
            mobileNumber: group?.mobileNumber,
            firstName: group?.firstName,
            lastName: group?.lastName,
            dateOfBirth: group?.dateOfBirth,
            gender: group?.gender,
            emailId: group?.emailId,
            landlineNumber: group?.phone1,
            address1: group?.groupContactAddress?.addressLine1,
            address2: group?.groupContactAddress?.addressLine2,
            city: group?.groupContactAddress?.city,
            state: group?.groupContactAddress?.state,
            pincode: group?.groupContactAddress?.pincode,
            role: group?.role,
            allowNotification:
              group?.groupContactNotification?.email && group?.groupContactNotification?.sms
                ? 'All'
                : group?.groupContactNotification?.email && !group?.groupContactNotification?.sms
                ? 'EMAIL'
                : 'SMS',
            type: 'GROUP',
          }
          contacts.push(data)
        })
      }
      return contacts
    },
    getGroupSubGroupContactProfile(identificationNumber: string) {
      let contacts: any[] = []
      if (self.onboarding.group.identificationNumber === identificationNumber) {
        self.onboarding.group?.groupContacts?.map((group) => {
          const data = {
            salutation: group.salutation,
            mobileNumber: group.mobileNumber,
            firstName: group.firstName,
            lastName: group.lastName,
            ...(group.phone1?.length > 0 && group?.phone1 !== 'NA' && { phone1: group.phone1 }),
            emailId: group.emailId,
            role: group.role,
            gender: group.gender,
            groupContactReferenceId: group?.groupContactReferenceId,
            status: group.status,
            groupContactNotification: {
              sms: group.allowNotification === 'SMS' || group.allowNotification === 'All',
              email: group.allowNotification === 'EMAIL' || group.allowNotification === 'All',
              groupContactNotificationKey: group.groupContactNotification?.groupContactNotificationKey,
            },
            groupContactAddress: {
              addressLine1: group?.addressLine1,
              addressLine2: group?.addressLine2,
              addressType: 'COMMUNICATION_ADDRESS',
              pincode: group?.pincode,
              city: group?.city,
              state: group?.state,
              countryCode: group?.countryCode,
              groupContactAddressKey: group.groupContactAddress?.groupContactAddressKey,
            },
          }
          contacts.push(data)
        })
      }
      return contacts
    },
    getLovsFromKey(key: string) {
      const data = self.lovs.map((item, index) => {
        if (item.key === key) {
          return {
            id: index,
            value: item.value,
            description: item.description,
          }
        }
      })
      return data.filter((item) => item !== undefined)
    },
    getLovsDescriptionFromKeyValue(key: string, value: string) {
      let description = ''
      self.lovs.map((item, index) => {
        if (item.key === key && item.value === value) {
          description = item.description
        }
      })
      description = description === '' && value === 'NA' ? 'NA' : description === '' ? value : description
      console.log('getLovsDescriptionFromKeyValue: ', key, value, description)
      return description
    },
    getIsRowSelected(pageNumber: number, id: string): boolean {
      // return self.selectedRowsIndex[pageNumber].selectedRows.includes(index)
      return self.globalCheckerList.filter((checker) => checker.applicationId === id)?.[0]?.isSelected
    },
    getRowsSelected(pageNumber: number) {
      // return self.selectedRowsIndex.filter((page: any) => page.pageNumber === pageNumber)?.[0]?.selectedRows ?? []
      return self.globalCheckerList.filter((checker) => checker.isSelected === true).map((data) => data.applicationId)
    },
    getCheckerGlobalList() {
      return self.globalCheckerList
    },
    getCheckerMyQueList() {
      return self.myCheckerList
    },
    getFiuCheckerList() {
      return self.fiuCheckerList
    },
    getAadharRedactionCheckerList() {
      return self.aadharRedactionCheckerList
    },
    getFiuMakerlList() {
      return self.fiuMakerList
    },
    emisSelectedLength() {
      let count = 0
      self.onboarding.emis.map((emi) => {
        emi.banks.map((bank) => {
          bank.tenuresInterest.map((tenureInt) => {
            if (tenureInt.isSelected === true) {
              count++
            }
          })
        })
      })
      console.log('emisSelectedLength', count)
      return count
    },
    getBusinessHierarchy(entityId: string) {
      let bussHierarchy: any[] = []
      self.onboarding.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          bussHierarchy.push({
            id: data?.group?.groupId,
            type: 'Group',
            name: data?.group?.brandName,
            masId: data?.group?.identificationNumber,
            status: data?.group?.status,
          })

          bussHierarchy.push({
            id: data?.subGroup?.groupId,
            type: 'Subgroup',
            name: data?.subGroup?.brandName,
            masId: data?.subGroup?.identificationNumber,
            status: data?.subGroup?.status,
          })

          bussHierarchy.push({
            id: `${data?.parent?.entityLevel}`,
            type: 'Entity',
            name: data?.parent?.businessName,
            masId: data?.parent?.identificationNumber,
            status: data?.parent?.status,
          })

          bussHierarchy.push({
            id: data?.parent?.identificationNumber,
            type: `L${data?.parent?.entityLevel}`,
            name: data?.parent?.businessName,
            masId: data?.parent?.identificationNumber,
            status: data?.parent?.status,
          })
        }
        return bussHierarchy
      })
    },
    getSearchedMasEntityData() {
      let listdata: any[] = []
      listdata.push({
        businessName: self.onboarding.entityDetails?.entity?.businessName ?? 'NA',
        type: 'Entity',
        masMid: self.onboarding.entityDetails?.entity?.identificationNumber,
        status: (self as any).getLovsDescriptionFromKeyValue('Status', self.onboarding.entityDetails?.entity?.status),
      })
      return [listdata[0]]
    },
    getAllUpdateableApisList() {
      let updateableApisList: any[] = []

      //Check if profile has access and all api's under it not selected
      if (checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
        if (!self.onboarding.isAllPciSelected) {
          const inActiveList = (self as any).getAllPciList().map((api) => {
            api.isActive = false
            return api
          })
          updateableApisList = [...updateableApisList, ...inActiveList]
        }
        if (!self.onboarding.isAllCommonPciNonPciSelected) {
          const inActiveList = (self as any).getCommonInPciNonPci().map((api) => {
            api.isActive = false
            return api
          })
          updateableApisList = [...updateableApisList, ...inActiveList]
        }
      } else {
        const allapiList = (self as any).getAllPciList()
        if (allapiList.length > 0) {
          self.apiaccesslist.map((apiAccess) => {
            allapiList.map((allapi) => {
              if (apiAccess.apiId === allapi.apiId) {
                updateableApisList.push(allapi)
              }
            })
          })
        }
      }

      if (checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
        if (!self.onboarding.isAllCommonPciNonPciSelected) {
          const inActiveList = (self as any).getCommonInPciNonPci().map((api) => {
            api.isActive = false
            return api
          })
          updateableApisList = [...updateableApisList, ...inActiveList]
        }
      } else {
        const apiList = (self as any).getCommonInPciNonPci()
        if (apiList.length > 0) {
          self.apiaccesslist.map((apiAccess) => {
            apiList.map((api) => {
              if (apiAccess.apiId === api.apiId) {
                updateableApisList.push(api)
              }
            })
          })
        }
      }

      if (checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
        if (!self.onboarding.isAllEmisSelected) {
          const inActiveList = (self as any).getEmiList().map((api) => {
            api.isActive = false
            return api
          })
          updateableApisList = [...updateableApisList, ...inActiveList]
        }
      } else {
        const apiList = (self as any).getEmiList()
        if (apiList.length > 0) {
          self.apiaccesslist.map((apiAccess) => {
            apiList.map((api) => {
              if (apiAccess.apiId === api.apiId) {
                updateableApisList.push(api)
              }
            })
          })
        }
      }

      const othersList = (self as any).getOthersApisList()
      if (othersList.length > 0) {
        self.apiaccesslist.map((apiAccess) => {
          othersList.map((otherApi) => {
            if (apiAccess.apiId === otherApi.apiId) {
              updateableApisList.push(otherApi)
            }
          })
        })
      }

      console.log('===> getAllUpdateableApisList', JSON.parse(JSON.stringify(updateableApisList)))
      return updateableApisList
    },
    getAllCreatableApisList() {
      //Working
      let apisList: any[] = []

      if (!checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
        apisList = [...apisList, ...(self as any).getAllPciList()]
      }
      if (!checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
        apisList = [...apisList, ...(self as any).getCommonInPciNonPci()]
      }
      if (!checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
        apisList = [...apisList, ...(self as any).getEmiList()]
      }

      // if (!self.onboarding.isAllOthersSelected) {
      const othersList = (self as any).getOthersApisList()
      // const othersSelectedList: any[] = []
      // if (othersList.length > 0) {
      //   othersList.map((other: any) => {
      //     if (other.isSelected) {
      //       othersSelectedList.push(other)
      //     }
      //   })
      // }
      console.log('===> othersSelectedList', othersList)
      apisList = [...apisList, ...othersList]
      // }

      apisList = apisList.filter((api) => api.isSelected)

      if (apisList.length > 0 && self.apiaccesslist.length > 0) {
        self.apiaccesslist.map((apiAccess) => {
          apisList.map((api, index) => {
            if (apiAccess.apiId === api.apiId) {
              console.log('===> getAllCreatableApisList removing: ', JSON.parse(JSON.stringify(api)))
              apisList.splice(index)
            }
          })
        })
      }

      console.log('===> getAllCreatableApisList', JSON.parse(JSON.stringify(apisList)))
      return apisList
    },
    getCreateableProfileChannelIds(consumerChannelId: string) {
      let channelIds: any[] = []
      let mappingIds: any[] = []
      //Check for no profile access
      if (
        !checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist) ||
        !checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)
      ) {
        //and check for if user selects full profile
        if (self.onboarding.isAllPciSelected) {
          channelIds = [...channelIds, '8008']
        }
      }
      if (!checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
        // !(
        //   checkIfProfileAccessPresent('EMI') ||
        //   checkIfProfileAccessPresent('EMI_NON_PCI') ||
        //   checkIfProfileAccessPresent('EMI_PCI Merchant')
        // )
        if (self.onboarding.isAllEmisSelected) {
          channelIds = [...channelIds, '394575653479']
        }
      }
      // if (!self.onboarding.isAllOthersSelected) {
      //   channelIds = [...channelIds, '388841029868', '3136']
      // }
      channelIds.map((channelId) => {
        mappingIds.push({ producerChannelId: channelId, consumerChannelId: consumerChannelId })
      })
      return mappingIds
    },
    getUpdateableProfileList(channelId: string) {
      let updateArr: any[] = []
      if (checkIfProfileAccessPresent('PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
        const pciActiveInactive = self.onboarding.isAllPciSelected ? '1' : '2'
        updateArr.push({ profileName: 'PCI_MERCHANT', channelId: channelId, status: pciActiveInactive })
      }
      if (checkIfProfileAccessPresent('NON_PCI_MERCHANT', self.onboarding.profilesaccesslist)) {
        const nonPciActiveInactive = self.onboarding.isAllCommonPciNonPciSelected ? '1' : '2'
        updateArr.push({ profileName: 'NON_PCI_MERCHANT', channelId: channelId, status: nonPciActiveInactive })
      }
      if (checkIfProfileAccessPresent('EMI', self.onboarding.profilesaccesslist)) {
        const activeInactive = self.onboarding.isAllEmisSelected ? '1' : '2'
        updateArr.push({ profileName: 'EMI', channelId: channelId, status: activeInactive })
      }
      return updateArr
    },
    getAccessRevokedIndividualApis() {
      //only for PCI, NON_PCI, EMI
      const allApisExceptOthers = [
        ...(self as any).getAllPciList(),
        ...(self as any).getCommonInPciNonPci(),
        ...(self as any).getEmiList(),
      ]

      const list = self.apiaccesslist.map((apiAccess) => {
        allApisExceptOthers.map((mApi) => {
          if (mApi.apiId === apiAccess.apiId) {
            if (!apiAccess.isSelected) {
              return apiAccess
            }
          }
        })
      })
      console.log('getAccessRevokedIndividualApis: ', list)
      return list
    },
    getSyncWithMasData(entityId: string) {
      // let contactDetails,
      //   addressDetails,
      //   gstDetails,
      //   settlementDetails,
      //   feePackageDetails,
      //   vpaDetails,
      //   programCategoryDetails,
      //   businessProfile,
      //   terminalDetails
      // self.onboarding.searchEntity.map((data) => {
      //   if (data?.entity?.identificationNumber === entityId) {
      //     contactDetails = data?.entity?.contactDetails
      //     addressDetails = data?.entity?.addressDetails
      //     gstDetails = data?.entity?.gstDetails
      //     settlementDetails = data?.entity?.settlementDetails
      //     feePackageDetails = data?.entity?.feePackageDetails
      //     vpaDetails = data?.entity?.vpaDetails
      //     programCategoryDetails = data?.entity?.programCategoryDetails
      //     businessProfile = data?.entity?.businessProfile
      //     terminalDetails = data?.entity?.terminalDetails
      //   }
      // })
      let data = {
        identificationNumber: entityId,
        source: 'MAS', //TODO: check when its MAS and when it is EMS
        type: 'MERCHANT',
        // contactDetails,
        // addressDetails,
        // gstDetails,
        // settlementDetails,
        // feePackageDetails,
        // vpaDetails,
        // programCategoryDetails,
        // businessProfile,
        // terminalDetails,
      }
      console.log('getSyncWithMasData: ', data)
      return data
    },
    getLovValueForDescription(key: string, description: string) {
      let value = ''
      self.lovs.map((lov) => {
        if (lov.key === key && lov?.description?.toLowerCase() === description?.toLowerCase()) {
          value = lov.value
        }
      })
      return value
    },
    getLovValueForDescriptionFromValue(key: string, value: string) {
      let result = ''
      self.lovs.map((lov) => {
        if (lov.key === key && lov.value === value) {
          result = lov.value
        }
      })
      return result
    },
    getPaymentsListByType(type: number) {
      let data: any[] = []
      if (type === PAYMENT_MODE_SUBTYPES.NB) {
        self.onboarding.merchant.preferences.bankList.map((bank) => {
          const isSelected = getIsCheckedFromSearchConfig(bank, self.onboarding.configList)
          data.push({
            id: bank.id,
            text: bank.name,
            imageUrl: bank.logo,
            type: bank.type,
            isSelected: bank.isSelected,
          })
        })
      } else if (type === PAYMENT_MODE_SUBTYPES.WALLET) {
        self.onboarding.merchant.preferences.walletList.map((wallet) => {
          const isSelected = getIsCheckedFromSearchConfig(wallet, self.onboarding.configList)
          data.push({
            id: wallet.id,
            text: wallet.name,
            imageUrl: wallet.logo,
            type: wallet.type,
            isSelected: wallet.isSelected,
          })
        })
      } else if (type === PAYMENT_MODE_SUBTYPES.PAYLATER) {
        self.onboarding.merchant.preferences.payLaterList.map((paylater) => {
          const isSelected = getIsCheckedFromSearchConfig(paylater, self.onboarding.configList)
          data.push({
            id: paylater.id,
            text: paylater.name,
            imageUrl: paylater.logo,
            type: paylater.type,
            isSelected: paylater.isSelected,
          })
        })
      }
      return data
    },
    getAllBusinessLines() {
      let list = []
      self?.onboarding?.businessCategoryMccCodeList?.map((item, index) => {
        list?.push({
          id: `${index}`,
          value: item.businessLine,
          description: item.businessLine,
        })
      })
      return list
    },
    getSelectedGlobalListLength() {
      return self.globalCheckerList.filter((global) => global.isSelected).length
    },
    getSelectedFiuCheckerListLength() {
      return self.fiuCheckerList.filter((fiu) => fiu?.isSelected).length
    },
    getAadharRedactionGlobalListLength() {
      return self.aadharRedactionCheckerList.filter((global) => global.isSelected).length
    },
    getMultipleKycDocumentsList(document: any) {
      if (document?.RID?.length > 0) {
        return self.documents.filter((doc) => doc?.documentNumber === document?.RID)?.[0]?.kycDocuments
      } else if (document?.name?.length > 0) {
        return self.documents.filter((doc) => doc?.documentId === document?.name)?.[0]?.kycDocuments
      }
    },
    getConfigDataToDownload() {
      const configData = {
        mid: self.onboarding.globalSearchString,
        config: self.onboarding.configurations,
        configList: self.onboarding.configList,
      }
      return configData
    },
    getOtherConfigs() {
      if (self?.onboarding?.configurations && self?.onboarding?.configurations?.length > 0) {
        return self.onboarding.configurations.filter(
          (config) =>
            config.configType !== 'RISK_SETTING' &&
            config.configType !== 'OPEN_LOOP_RISK' &&
            config.configType !== 'CLOSED_LOOP_RISK' &&
            config.configType !== 'PAYMENT_ACCEPTANCE' &&
            config.configType !== 'ALLOWED_CHANNEL' &&
            config.configType !== 'INTEGRATION_TYPE' &&
            config.configType !== 'ALLOWED_TXN_TYPE' &&
            config.configType !== 'MERCHANT_CONVENIENCE_FEE' &&
            config.configType !== 'S2S_URL' &&
            config.configType !== 'KEYS' &&
            config.configType !== 'CALLBACK_URL' &&
            config.configType !== 'SUPPORTED_NETBANKING' &&
            config.configType !== 'SUPPORTED_WALLET' &&
            config.configType !== 'SUPPORTED_CORPORATENETBANKING' &&
            config.configType !== 'SUPPORTED_PAYLATER',
        )
      } else {
        return []
      }
    },
    getConfigurationsList() {
      let list = []
      if (self.onboarding.configList && self.onboarding.configList.length > 0) {
        self.onboarding.configList.map((conf) => {
          if (
            conf.key !== 'ALLOWED_CHANNEL' &&
            conf.key !== 'SUPPORTED_NETBANKING' &&
            conf.key !== 'SUPPORTED_WALLET' &&
            conf.key !== 'SUPPORTED_CORPORATENETBANKING' &&
            conf.key !== 'SUPPORTED_PAYLATER'
          ) {
            list.push({
              text: `${conf?.key}: ${conf?.value === 'Y' ? 'Yes' : conf?.value === 'N' ? 'No' : conf?.value}`,
              status: conf?.status,
            })
          }
        })
      }
      return list
    },
  }))

const RootStore = Root.create({
  user: userData,
  card: cardData,
  devices: devicesData,
  netBanking: netBankingData,
  routingRule: routingRuleData,
  merchantMapping: merchantdata,
  approvals: approvalData,
  entityMaster: entityMasterData,
  message: { value: '', type: 'NEGATIVE', code: '' },
  package: packageData,
  packageToInstrument: packageInstrumentData,
  packageToMId: packageMIDData,
  generateExcelFile: excelFileData,
  fileUpload: fileUploadData,
  bankingCode: bankingCodeData,
  userManagement: userManagementdata,
  session: sessionData,
  onboarding: onboardingData,
  bulkEntity: BulkEntityData,
  filter: defaultSelectedFilters,
  feePackage: feePackageData,
  feePackageFileUpload: feePackageFileUploadData,
  feePackageToMId: feePackageMIDData,
  ledgerMapping: ledgerMappingData,
  riskConfig: riskTxnsData,
  merchantPayoutConfig: merchantPayoutConfigData,
  sourceAccountConfig: sourceAccConfigData,
  essControls: essControlsData,
  processingEntity: {},
  payoutFrequencyConfig: payoutFrequencyConfigData,
  payoutCms: payoutCmsData,
  creditAdjustment: creditadjustmentData,
  posApprovals: posApprovalData,
  postRecon: postReconData,
  entityOnboarding: entityOnboardingData,
})

onSnapshot(RootStore, (snapshot) => {
  console.log('%c%s', 'color: green; background: yellow; font-size: 14px;', 'SnapShot!:', snapshot)
})

export type RootType = Instance<typeof Root>
export { Root, RootStore }
